import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, vShow as _vShow, TransitionGroup as _TransitionGroup, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "chat-loader-wrap"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "lds-ring" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_8 = {
  class: "chat-screen left-chat-block",
  id: "chat-screen-content"
}
const _hoisted_9 = { class: "chat-header align-items-start" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-8" }
const _hoisted_12 = {
  key: 0,
  class: "chat-title"
}
const _hoisted_13 = {
  key: 0,
  class: "project-title-wrap",
  id: "projectTitle"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "title-icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("strong", null, "Project :", -1)
const _hoisted_16 = {
  key: 1,
  class: "project-title-wrap",
  id: "projectTitle"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "absolute-link"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "title-icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("strong", null, "Project :", -1)
const _hoisted_20 = {
  class: "inline-items",
  id: "channelToProject"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments fa-w-18 text-secondary" }, null, -1)
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-check mr-1" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("strong", null, " Channel created on :", -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Go To Invitation")
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "more-detail" }
const _hoisted_30 = { class: "members-list pt-0 text-right" }
const _hoisted_31 = {
  key: 0,
  class: "d-none d-sm-none d-md-none d-lg-inline-block",
  id: "channelMemberList"
}
const _hoisted_32 = { class: "more-member" }
const _hoisted_33 = /*#__PURE__*/_createVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  class: "bi bi-three-dots-vertical",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
  })
], -1)
const _hoisted_34 = {
  key: 0,
  class: "result-wrap p-3 bg-dark text-white text-center"
}
const _hoisted_35 = { class: "search-wrap mx-3 my-1" }
const _hoisted_36 = { class: "search-ico" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "clear-ico"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "text-center",
  style: {"position":"absolute","top":"100px","z-index":"9999","left":"50%"}
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border m-2",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_42 = {
  key: 2,
  class: "timeline-text"
}
const _hoisted_43 = { class: "dragdrop-area" }
const _hoisted_44 = {
  key: 0,
  class: "chat-loader-wrap"
}
const _hoisted_45 = {
  key: 0,
  class: "lds-ring"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("input", {
  type: "file",
  accept: "*.*",
  multiple: "",
  id: "gallery-photo-add",
  class: "custom-file-input"
}, null, -1)
const _hoisted_51 = {
  key: 1,
  id: "chat-screen-content",
  ref: "chatBody"
}
const _hoisted_52 = { class: "messages" }
const _hoisted_53 = {
  key: 0,
  class: "chat-box"
}
const _hoisted_54 = {
  key: 0,
  class: "msg-user"
}
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 2,
  class: "edit-text mb-2"
}
const _hoisted_57 = { class: "editor-wrap" }
const _hoisted_58 = { class: "small-texts-side text-right" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Shift"),
  /*#__PURE__*/_createTextVNode(" + "),
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_63 = { key: 3 }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "deleted-holder" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Message Deleted. ")
const _hoisted_67 = { class: "text-primary" }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = {
  key: 0,
  class: "mt-3 reply-block"
}
const _hoisted_72 = { class: "iconed-box-wrap" }
const _hoisted_73 = {
  key: 0,
  class: "small-fig-wrap"
}
const _hoisted_74 = {
  key: 1,
  class: "chat-desc-wrap"
}
const _hoisted_75 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_76 = { class: " text-green" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode()
const _hoisted_78 = { class: "date ml-1 text-muted" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_81 = {
  key: 2,
  class: "image-in-chat"
}
const _hoisted_82 = {
  key: 0,
  class: "deleteimage-wrapper shadowed-card bg-white"
}
const _hoisted_83 = { class: "delete-content bg-light p-2" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_85 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_87 = {
  key: 1,
  class: "shadowed-card bg-white"
}
const _hoisted_88 = {
  key: 0,
  class: "image-box"
}
const _hoisted_89 = { class: "\n                                                  embed-responsive embed-responsive-16by9\n                                                " }
const _hoisted_90 = /*#__PURE__*/_createVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1)
const _hoisted_91 = { class: "file-name bg-light p-2" }
const _hoisted_92 = {
  key: 1,
  class: "image-box"
}
const _hoisted_93 = /*#__PURE__*/_createVNode("div", { class: "image-file-wrap" }, null, -1)
const _hoisted_94 = { class: "file-name bg-light p-2" }
const _hoisted_95 = {
  key: 2,
  class: "image-box"
}
const _hoisted_96 = { class: "same-ht-img" }
const _hoisted_97 = { class: "file-name bg-light p-2" }
const _hoisted_98 = {
  key: 3,
  class: "image-box"
}
const _hoisted_99 = { class: "same-ht-img" }
const _hoisted_100 = { class: "file-name bg-light p-2" }
const _hoisted_101 = {
  key: 4,
  class: "image-box"
}
const _hoisted_102 = { class: "image-wrapp" }
const _hoisted_103 = { class: "file-name bg-light p-2" }
const _hoisted_104 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-download" }, null, -1)
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_106 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_109 = {
  key: 5,
  class: "image-box"
}
const _hoisted_110 = { class: "same-ht-img" }
const _hoisted_111 = { class: "file-name bg-light p-2" }
const _hoisted_112 = {
  key: 6,
  class: "pdf-in-chat border-0 p-0"
}
const _hoisted_113 = { class: "pdf-wrapp" }
const _hoisted_114 = { class: "bg-light p-2" }
const _hoisted_115 = { class: "size" }
const _hoisted_116 = {
  key: 0,
  class: "size"
}
const _hoisted_117 = {
  key: 3,
  class: "image-in-chat forward-communication-share_history"
}
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { class: "shadowed-card bg-white" }
const _hoisted_120 = {
  key: 0,
  class: "\n                                                    deleteimage-wrapper\n                                                    shadowed-card\n                                                    bg-white\n                                                  "
}
const _hoisted_121 = { class: "delete-content bg-light p-2" }
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_123 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_125 = {
  key: 1,
  class: "image-box"
}
const _hoisted_126 = { class: "\n                                                      embed-responsive embed-responsive-16by9\n                                                    " }
const _hoisted_127 = /*#__PURE__*/_createVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1)
const _hoisted_128 = {
  key: 0,
  class: "file-name bg-light p-2"
}
const _hoisted_129 = { class: "font-weight-bold" }
const _hoisted_130 = {
  key: 2,
  class: "image-box"
}
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { class: "doc-file-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "image-wrapp" })
], -1)
const _hoisted_132 = { class: "file-name bg-light p-2" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = {
  key: 3,
  class: "image-box"
}
const _hoisted_135 = { class: "doc-file-wrap" }
const _hoisted_136 = { class: "image-wrapp" }
const _hoisted_137 = { class: "same-ht-img" }
const _hoisted_138 = { class: "file-name bg-light p-2" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = {
  key: 4,
  class: "image-box"
}
const _hoisted_141 = { class: "doc-file-wrap" }
const _hoisted_142 = { class: "image-wrapp" }
const _hoisted_143 = { class: "same-ht-img" }
const _hoisted_144 = { class: "file-name bg-light p-2" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = {
  key: 5,
  class: "image-box"
}
const _hoisted_147 = {
  key: 0,
  class: "file-name bg-light p-2"
}
const _hoisted_148 = { class: "font-weight-bold" }
const _hoisted_149 = /*#__PURE__*/_createVNode("a", {
  title: "Rename",
  "data-toggle": "modal",
  class: "remove-image edit-icon"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" })
], -1)
const _hoisted_150 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "remove-image"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_151 = {
  key: 6,
  class: "pdf-in-chat border-0 p-0"
}
const _hoisted_152 = { class: "pdf-wrapp" }
const _hoisted_153 = { class: "bg-light p-2" }
const _hoisted_154 = { key: 0 }
const _hoisted_155 = {
  key: 1,
  class: "size"
}
const _hoisted_156 = {
  key: 2,
  class: "size"
}
const _hoisted_157 = { key: 2 }
const _hoisted_158 = { class: "d-flex align-items-center" }
const _hoisted_159 = { key: 1 }
const _hoisted_160 = { class: "text-primary" }
const _hoisted_161 = {
  key: 0,
  class: "mt-3 reply-block"
}
const _hoisted_162 = { class: "iconed-box-wrap" }
const _hoisted_163 = {
  key: 0,
  class: "small-fig-wrap"
}
const _hoisted_164 = {
  key: 1,
  class: "chat-desc-wrap"
}
const _hoisted_165 = { key: 0 }
const _hoisted_166 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_167 = {
  key: 2,
  class: "image-in-chat"
}
const _hoisted_168 = {
  key: 0,
  class: "deleteimage-wrapper shadowed-card bg-white"
}
const _hoisted_169 = { class: "delete-content bg-light p-2" }
const _hoisted_170 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_171 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_172 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_173 = {
  key: 1,
  class: "shadowed-card bg-white"
}
const _hoisted_174 = {
  key: 0,
  class: "image-box"
}
const _hoisted_175 = { class: "\n                                                  embed-responsive embed-responsive-16by9\n                                                " }
const _hoisted_176 = /*#__PURE__*/_createVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1)
const _hoisted_177 = { class: "file-name bg-light p-2" }
const _hoisted_178 = {
  key: 1,
  class: "image-box"
}
const _hoisted_179 = /*#__PURE__*/_createVNode("div", { class: "image-file-wrap" }, null, -1)
const _hoisted_180 = { class: "file-name bg-light p-2" }
const _hoisted_181 = {
  key: 2,
  class: "image-box"
}
const _hoisted_182 = { class: "same-ht-img" }
const _hoisted_183 = { class: "file-name bg-light p-2" }
const _hoisted_184 = {
  key: 3,
  class: "image-box"
}
const _hoisted_185 = { class: "same-ht-img" }
const _hoisted_186 = { class: "file-name bg-light p-2" }
const _hoisted_187 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_188 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_189 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_190 = {
  key: 4,
  class: "image-box"
}
const _hoisted_191 = { class: "image-wrapp" }
const _hoisted_192 = { class: "same-ht-img" }
const _hoisted_193 = { class: "file-name bg-light p-2" }
const _hoisted_194 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-download" }, null, -1)
const _hoisted_195 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_196 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_197 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_198 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_199 = {
  key: 5,
  class: "image-box"
}
const _hoisted_200 = { class: "same-ht-img" }
const _hoisted_201 = { class: "file-name bg-light p-2" }
const _hoisted_202 = {
  key: 6,
  class: "pdf-in-chat border-0 p-0"
}
const _hoisted_203 = { class: "pdf-wrapp" }
const _hoisted_204 = { class: "bg-light p-2" }
const _hoisted_205 = { class: "size" }
const _hoisted_206 = {
  key: 0,
  class: "size"
}
const _hoisted_207 = { class: "inline-items" }
const _hoisted_208 = { key: 0 }
const _hoisted_209 = { href: "javascript:void(0)" }
const _hoisted_210 = {
  key: 0,
  class: "date"
}
const _hoisted_211 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-alt" }, null, -1)
const _hoisted_212 = { key: 0 }
const _hoisted_213 = /*#__PURE__*/_createTextVNode(" Sent ")
const _hoisted_214 = /*#__PURE__*/_createTextVNode(" form to ")
const _hoisted_215 = { key: 0 }
const _hoisted_216 = { key: 1 }
const _hoisted_217 = /*#__PURE__*/_createTextVNode(" created ")
const _hoisted_218 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-alt" }, null, -1)
const _hoisted_219 = { key: 0 }
const _hoisted_220 = /*#__PURE__*/_createTextVNode(" Sent ")
const _hoisted_221 = { key: 0 }
const _hoisted_222 = { key: 1 }
const _hoisted_223 = /*#__PURE__*/_createTextVNode(" created ")
const _hoisted_224 = {
  key: 7,
  class: "image-in-chat"
}
const _hoisted_225 = {
  key: 0,
  class: "deleteimage-wrapper shadowed-card bg-white"
}
const _hoisted_226 = { class: "delete-content bg-light p-2" }
const _hoisted_227 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_228 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_229 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_230 = {
  key: 1,
  class: "shadowed-card bg-white"
}
const _hoisted_231 = {
  key: 0,
  class: "image-box"
}
const _hoisted_232 = { class: "\n                                                  embed-responsive embed-responsive-16by9\n                                                " }
const _hoisted_233 = /*#__PURE__*/_createVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1)
const _hoisted_234 = { class: "file-name bg-light p-2" }
const _hoisted_235 = {
  key: 1,
  class: "image-box"
}
const _hoisted_236 = /*#__PURE__*/_createVNode("div", { class: "image-file-wrap" }, null, -1)
const _hoisted_237 = { class: "file-name bg-light p-2" }
const _hoisted_238 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_239 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_240 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_241 = {
  key: 2,
  class: "image-box"
}
const _hoisted_242 = { class: "same-ht-img" }
const _hoisted_243 = { class: "file-name bg-light p-2" }
const _hoisted_244 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_245 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_246 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_247 = {
  key: 3,
  class: "image-box"
}
const _hoisted_248 = { class: "same-ht-img" }
const _hoisted_249 = { class: "file-name bg-light p-2" }
const _hoisted_250 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_251 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_252 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_253 = {
  key: 4,
  class: "image-box"
}
const _hoisted_254 = { class: "image-wrapp" }
const _hoisted_255 = { class: "file-name bg-light p-2" }
const _hoisted_256 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-download" }, null, -1)
const _hoisted_257 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_258 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_259 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_260 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_261 = {
  key: 5,
  class: "image-box"
}
const _hoisted_262 = { class: "image-wrapp" }
const _hoisted_263 = { class: "file-name bg-light p-2" }
const _hoisted_264 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_265 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_266 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_267 = {
  key: 6,
  class: "image-box"
}
const _hoisted_268 = { class: "same-ht-img" }
const _hoisted_269 = { class: "file-name bg-light p-2" }
const _hoisted_270 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_271 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_272 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_273 = {
  key: 7,
  class: "pdf-in-chat border-0 p-0"
}
const _hoisted_274 = { class: "pdf-wrapp" }
const _hoisted_275 = { class: "bg-light p-2" }
const _hoisted_276 = { class: "size" }
const _hoisted_277 = {
  key: 0,
  class: "size"
}
const _hoisted_278 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_279 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_280 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_281 = {
  key: 8,
  class: "image-in-chat"
}
const _hoisted_282 = { key: 0 }
const _hoisted_283 = { class: "shadowed-card bg-white" }
const _hoisted_284 = {
  key: 0,
  class: "\n                                                    deleteimage-wrapper\n                                                    shadowed-card\n                                                    bg-white\n                                                  "
}
const _hoisted_285 = { class: "delete-content bg-light p-2" }
const _hoisted_286 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_287 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_288 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_289 = {
  key: 1,
  class: "image-box"
}
const _hoisted_290 = { class: "\n                                                      embed-responsive embed-responsive-16by9\n                                                    " }
const _hoisted_291 = /*#__PURE__*/_createVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1)
const _hoisted_292 = {
  key: 0,
  class: "file-name bg-light p-2"
}
const _hoisted_293 = { class: "font-weight-bold" }
const _hoisted_294 = {
  key: 2,
  class: "image-box"
}
const _hoisted_295 = /*#__PURE__*/_createVNode("div", { class: "doc-file-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "image-wrapp" })
], -1)
const _hoisted_296 = { class: "file-name bg-light p-2" }
const _hoisted_297 = { key: 0 }
const _hoisted_298 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_299 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_300 = {
  key: 3,
  class: "image-box"
}
const _hoisted_301 = { class: "doc-file-wrap" }
const _hoisted_302 = { class: "image-wrapp" }
const _hoisted_303 = { class: "same-ht-img" }
const _hoisted_304 = { class: "file-name bg-light p-2" }
const _hoisted_305 = { key: 0 }
const _hoisted_306 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_307 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_308 = {
  key: 4,
  class: "image-box"
}
const _hoisted_309 = { class: "doc-file-wrap" }
const _hoisted_310 = { class: "image-wrapp" }
const _hoisted_311 = { class: "same-ht-img" }
const _hoisted_312 = { class: "file-name bg-light p-2" }
const _hoisted_313 = { key: 0 }
const _hoisted_314 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_315 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_316 = {
  key: 5,
  class: "image-box"
}
const _hoisted_317 = {
  key: 0,
  class: "file-name bg-light p-2"
}
const _hoisted_318 = { class: "font-weight-bold" }
const _hoisted_319 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_320 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_321 = {
  key: 6,
  class: "pdf-in-chat border-0 p-0"
}
const _hoisted_322 = { class: "pdf-wrapp" }
const _hoisted_323 = { class: "bg-light p-2" }
const _hoisted_324 = { key: 0 }
const _hoisted_325 = {
  key: 1,
  class: "size"
}
const _hoisted_326 = {
  key: 2,
  class: "size"
}
const _hoisted_327 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_328 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_329 = {
  key: 9,
  class: "text-right"
}
const _hoisted_330 = /*#__PURE__*/_createVNode("span", { class: "grey-btn" }, "Sending...", -1)
const _hoisted_331 = { key: 10 }
const _hoisted_332 = {
  key: 0,
  class: "right-actions-block"
}
const _hoisted_333 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-regular fa-comment-dots",
  title: "Reply"
}, null, -1)
const _hoisted_334 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-solid fa-share",
  title: "Forward"
}, null, -1)
const _hoisted_335 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-edit",
  title: "Edit"
}, null, -1)
const _hoisted_336 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-trash-alt",
  title: "Remove"
}, null, -1)
const _hoisted_337 = {
  key: 1,
  class: "right-actions-block"
}
const _hoisted_338 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-regular fa-comment-dots",
  title: "Reply"
}, null, -1)
const _hoisted_339 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-solid fa-share",
  title: "Forward"
}, null, -1)
const _hoisted_340 = {
  key: 11,
  class: "send-status-block text-right"
}
const _hoisted_341 = /*#__PURE__*/_createVNode("div", {
  class: "send-tag",
  title: "sent"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check-double text-green" }),
  /*#__PURE__*/_createTextVNode(" Sent")
], -1)
const _hoisted_342 = {
  key: 12,
  class: "members-list pt-1 text-right"
}
const _hoisted_343 = { key: 0 }
const _hoisted_344 = { key: 1 }
const _hoisted_345 = {
  key: 0,
  class: "send-icon-wrap"
}
const _hoisted_346 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_347 = { class: "more-member" }
const _hoisted_348 = { key: 2 }
const _hoisted_349 = {
  key: 0,
  class: "timeline-text latest-message"
}
const _hoisted_350 = /*#__PURE__*/_createVNode("span", null, "Latest Message", -1)
const _hoisted_351 = /*#__PURE__*/_createVNode("input", {
  type: "file",
  accept: "*.*",
  multiple: "",
  id: "gallery-photo-add",
  class: "custom-file-input"
}, null, -1)
const _hoisted_352 = {
  key: 0,
  class: "editor-wrap",
  id: "sendMsg"
}
const _hoisted_353 = { key: 0 }
const _hoisted_354 = { class: "carousel__wrapper" }
const _hoisted_355 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_356 = { class: "msg-action-btn" }
const _hoisted_357 = { key: 0 }
const _hoisted_358 = /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt" }, null, -1)
const _hoisted_359 = { key: 1 }
const _hoisted_360 = /*#__PURE__*/_createVNode("div", { class: "mic-icons" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt-slash" })
], -1)
const _hoisted_361 = { key: 2 }
const _hoisted_362 = /*#__PURE__*/_createVNode("div", { class: "mic-icons" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt" })
], -1)
const _hoisted_363 = { key: 3 }
const _hoisted_364 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-file-upload upload-icons",
  "data-toggle": "modal"
}, null, -1)
const _hoisted_365 = /*#__PURE__*/_createVNode("label", {
  style: {"cursor":"pointer"},
  title: "Upload Attachment",
  for: "create-document-upload"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-paperclip upload-icons" })
], -1)
const _hoisted_366 = { key: 0 }
const _hoisted_367 = {
  key: 1,
  class: "spinner-border",
  role: "status"
}
const _hoisted_368 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_369 = { class: "small-texts-side text-right" }
const _hoisted_370 = { key: 0 }
const _hoisted_371 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_372 = { key: 1 }
const _hoisted_373 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Shift"),
  /*#__PURE__*/_createTextVNode(" + "),
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_374 = {
  key: 1,
  class: "error-field-text"
}
const _hoisted_375 = {
  key: 2,
  class: "error-field-text"
}
const _hoisted_376 = { class: "user-typing-height" }
const _hoisted_377 = { key: 0 }
const _hoisted_378 = { class: "chat-sidebar" }
const _hoisted_379 = /*#__PURE__*/_createVNode("div", { class: "chat-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-md-10 col-8" }, [
      /*#__PURE__*/_createVNode("h3", null, "Details")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-md-2 col-4 text-right" }, [
      /*#__PURE__*/_createVNode("a", {
        href: "javascript:void(0)",
        id: "close-sidebar"
      }, [
        /*#__PURE__*/_createVNode("svg", {
          width: "1em",
          height: "1em",
          viewBox: "0 0 16 16",
          class: "bi bi-x-circle",
          fill: "currentColor",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          /*#__PURE__*/_createVNode("path", {
            "fill-rule": "evenodd",
            d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
          }),
          /*#__PURE__*/_createVNode("path", {
            "fill-rule": "evenodd",
            d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_380 = /*#__PURE__*/_createVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_381 = { class: "chat-sidebar-body member-list-item custom-scroll" }
const _hoisted_382 = {
  key: 0,
  class: "p-3 border-bottom"
}
const _hoisted_383 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_384 = /*#__PURE__*/_createTextVNode(" Add member")
const _hoisted_385 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_386 = /*#__PURE__*/_createTextVNode(" Add member")
const _hoisted_387 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-export" }, null, -1)
const _hoisted_388 = /*#__PURE__*/_createTextVNode(" Export Chat")
const _hoisted_389 = { id: "accordion" }
const _hoisted_390 = {
  key: 0,
  class: "accordion-card"
}
const _hoisted_391 = {
  class: "accordion-header flex-box",
  id: "headingOne"
}
const _hoisted_392 = { class: "flext-content" }
const _hoisted_393 = { class: "mb-0" }
const _hoisted_394 = {
  class: "btn",
  "data-toggle": "collapse",
  "data-target": "#collapseOne",
  "aria-expanded": "true",
  "aria-controls": "collapseOne"
}
const _hoisted_395 = {
  key: 0,
  href: "javascript:void(0)",
  class: "text-success",
  "data-toggle": "modal",
  "data-target": "#pendingMembers"
}
const _hoisted_396 = /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" }, null, -1)
const _hoisted_397 = {
  id: "collapseOne",
  class: "collapse show",
  "aria-labelledby": "headingOne",
  "data-parent": "#accordion"
}
const _hoisted_398 = { class: "card-body custom-scroll" }
const _hoisted_399 = { key: 0 }
const _hoisted_400 = { key: 1 }
const _hoisted_401 = { class: "accordion-card" }
const _hoisted_402 = /*#__PURE__*/_createVNode("div", {
  class: "accordion-header",
  id: "headingTwo"
}, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
    /*#__PURE__*/_createVNode("button", {
      class: "btn collapsed",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    }, " Actions ")
  ])
], -1)
const _hoisted_403 = {
  id: "collapseTwo",
  class: "collapse",
  "aria-labelledby": "headingTwo",
  "data-parent": "#accordion"
}
const _hoisted_404 = { class: "card-body" }
const _hoisted_405 = { class: "row mx-n2" }
const _hoisted_406 = { class: "col-6 px-2" }
const _hoisted_407 = {
  key: 0,
  class: "col-6 px-2"
}
const _hoisted_408 = { class: "accordion-card" }
const _hoisted_409 = /*#__PURE__*/_createVNode("div", {
  class: "accordion-header",
  id: "headingThree"
}, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
    /*#__PURE__*/_createVNode("button", {
      class: "btn collapsed",
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "false",
      "aria-controls": "collapseThree"
    }, " Shared forms ")
  ])
], -1)
const _hoisted_410 = {
  id: "collapseThree",
  class: "collapse",
  "aria-labelledby": "headingThree",
  "data-parent": "#accordion"
}
const _hoisted_411 = {
  key: 0,
  class: "card-body custom-scroll"
}
const _hoisted_412 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_413 = { key: 0 }
const _hoisted_414 = { key: 1 }
const _hoisted_415 = {
  key: 0,
  class: "mr-1"
}
const _hoisted_416 = {
  key: 1,
  class: "accordion-card"
}
const _hoisted_417 = /*#__PURE__*/_createVNode("div", {
  class: "accordion-header",
  id: "headingThree"
}, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
    /*#__PURE__*/_createVNode("button", {
      class: "btn collapsed",
      "data-toggle": "collapse",
      "data-target": "#collapseThreeSharedFiles",
      "aria-expanded": "false",
      "aria-controls": "collapseThreeSharedFiles"
    }, " Shared Files ")
  ])
], -1)
const _hoisted_418 = {
  id: "collapseThreeSharedFiles",
  class: "collapse",
  "aria-labelledby": "headingThree",
  "data-parent": "#accordion"
}
const _hoisted_419 = { class: "card-body custom-scroll" }
const _hoisted_420 = {
  key: 0,
  class: "shared-form-list"
}
const _hoisted_421 = /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt" }, null, -1)
const _hoisted_422 = { key: 0 }
const _hoisted_423 = { key: 1 }
const _hoisted_424 = {
  key: 2,
  class: "accordion-card"
}
const _hoisted_425 = /*#__PURE__*/_createVNode("div", {
  class: "accordion-header",
  id: "headingThree"
}, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, [
    /*#__PURE__*/_createVNode("button", {
      class: "btn collapsed",
      "data-toggle": "collapse",
      "data-target": "#collapseThreeSharedAttachment",
      "aria-expanded": "false",
      "aria-controls": "collapseThreeSharedAttachment"
    }, " Shared Attachments ")
  ])
], -1)
const _hoisted_426 = {
  id: "collapseThreeSharedAttachment",
  class: "collapse",
  "aria-labelledby": "headingThree",
  "data-parent": "#accordion"
}
const _hoisted_427 = { class: "card-body custom-scroll" }
const _hoisted_428 = {
  key: 0,
  class: "shadowed-card bg-white"
}
const _hoisted_429 = { class: "pdf-wrapp attachment-wrap" }
const _hoisted_430 = { class: "attachment-buttons" }
const _hoisted_431 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_432 = /*#__PURE__*/_createVNode("i", { class: "fas fa-comment-alt" }, null, -1)
const _hoisted_433 = { class: "bg-light p-2 position-relative" }
const _hoisted_434 = { key: 1 }
const _hoisted_435 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Shared in-"),
  /*#__PURE__*/_createTextVNode(" Channel")
], -1)
const _hoisted_436 = { key: 0 }
const _hoisted_437 = {
  key: 0,
  class: "shadowed-card bg-white"
}
const _hoisted_438 = { class: "pdf-wrapp attachment-wrap" }
const _hoisted_439 = { class: "attachment-buttons" }
const _hoisted_440 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_441 = /*#__PURE__*/_createVNode("i", { class: "fas fa-comment-alt" }, null, -1)
const _hoisted_442 = { class: "bg-light p-2 position-relative" }
const _hoisted_443 = { key: 1 }
const _hoisted_444 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Shared in-"),
  /*#__PURE__*/_createTextVNode(" Reply Thread")
], -1)
const _hoisted_445 = { class: "accordion-card" }
const _hoisted_446 = {
  class: "accordion-header",
  id: "headingSix"
}
const _hoisted_447 = { class: "mb-0" }
const _hoisted_448 = {
  id: "collapseSix",
  class: "collapse",
  "aria-labelledby": "headingSix",
  "data-parent": "#accordion"
}
const _hoisted_449 = { class: "card-body custom-scroll" }
const _hoisted_450 = /*#__PURE__*/_createVNode("div", { class: "file-icon-wrap mr-2" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf fa-2x" })
], -1)
const _hoisted_451 = { class: "file-desc file-name flex-grow-1" }
const _hoisted_452 = { class: "font-weight-bold" }
const _hoisted_453 = { class: "action-box ml-2" }
const _hoisted_454 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_455 = { class: "right-chat-block" }
const _hoisted_456 = { class: "thread-header" }
const _hoisted_457 = { class: "thread-close-btn" }
const _hoisted_458 = /*#__PURE__*/_createVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_459 = { class: "thread-title" }
const _hoisted_460 = /*#__PURE__*/_createVNode("h6", null, "Thread", -1)
const _hoisted_461 = { key: 0 }
const _hoisted_462 = { class: "main-msg-thread" }
const _hoisted_463 = {
  class: "reply-chat-body custom-scroll",
  style: {"position":"relative"}
}
const _hoisted_464 = { class: "chat-block" }
const _hoisted_465 = { class: "chat-box" }
const _hoisted_466 = { class: "msg-user" }
const _hoisted_467 = { class: "chat mw-100" }
const _hoisted_468 = { key: 0 }
const _hoisted_469 = {
  key: 0,
  class: "date"
}
const _hoisted_470 = {
  key: 0,
  class: "image-in-chat"
}
const _hoisted_471 = { class: "shadowed-card bg-white" }
const _hoisted_472 = {
  key: 0,
  class: "image-box"
}
const _hoisted_473 = {
  key: 0,
  class: "image-wrapp"
}
const _hoisted_474 = { class: "file-name bg-light p-2" }
const _hoisted_475 = { class: "font-weight-bold" }
const _hoisted_476 = {
  key: 1,
  class: "image-wrapp"
}
const _hoisted_477 = { class: "file-name bg-light p-2" }
const _hoisted_478 = { class: "font-weight-bold" }
const _hoisted_479 = {
  key: 2,
  class: "image-wrapp"
}
const _hoisted_480 = { class: "file-name bg-light p-2" }
const _hoisted_481 = { class: "font-weight-bold" }
const _hoisted_482 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-download" }, null, -1)
const _hoisted_483 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_484 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_485 = {
  key: 1,
  class: "deleteimage-wrapper shadowed-card bg-white"
}
const _hoisted_486 = { class: "delete-content bg-light p-2" }
const _hoisted_487 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_488 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_489 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_490 = {
  class: "no-of-replies",
  s: ""
}
const _hoisted_491 = { key: 0 }
const _hoisted_492 = { class: "chat-box mb-2" }
const _hoisted_493 = { class: "msg-user" }
const _hoisted_494 = { class: "chat mw-100" }
const _hoisted_495 = {
  key: 0,
  class: "deleted-holder"
}
const _hoisted_496 = { class: "date" }
const _hoisted_497 = /*#__PURE__*/_createTextVNode(" Message Deleted. ")
const _hoisted_498 = { class: "text-primary" }
const _hoisted_499 = { key: 1 }
const _hoisted_500 = { class: "date" }
const _hoisted_501 = {
  key: 2,
  class: "image-in-chat"
}
const _hoisted_502 = { class: "shadowed-card bg-white" }
const _hoisted_503 = {
  key: 0,
  class: "image-box"
}
const _hoisted_504 = {
  key: 0,
  class: "image-wrapp"
}
const _hoisted_505 = { class: "file-name bg-light p-2" }
const _hoisted_506 = { class: "font-weight-bold" }
const _hoisted_507 = {
  key: 1,
  class: "image-wrapp"
}
const _hoisted_508 = { class: "file-name bg-light p-2" }
const _hoisted_509 = { class: "font-weight-bold" }
const _hoisted_510 = {
  key: 2,
  class: "image-wrapp"
}
const _hoisted_511 = { class: "file-name bg-light p-2" }
const _hoisted_512 = { class: "font-weight-bold" }
const _hoisted_513 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-download" }, null, -1)
const _hoisted_514 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_515 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_516 = {
  key: 1,
  class: "deleteimage-wrapper shadowed-card bg-white"
}
const _hoisted_517 = { class: "delete-content bg-light p-2" }
const _hoisted_518 = /*#__PURE__*/_createTextVNode(" image was ")
const _hoisted_519 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "deleted", -1)
const _hoisted_520 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_521 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_522 = {
  key: 0,
  class: "text-right"
}
const _hoisted_523 = /*#__PURE__*/_createVNode("span", { class: "grey-btn" }, "Sending...", -1)
const _hoisted_524 = {
  key: 1,
  class: "send-status-block text-right"
}
const _hoisted_525 = /*#__PURE__*/_createVNode("div", {
  class: "send-tag",
  title: "sent"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check-double text-green" }),
  /*#__PURE__*/_createTextVNode(" Sent")
], -1)
const _hoisted_526 = {
  key: 2,
  class: "members-list pt-0 text-right"
}
const _hoisted_527 = { key: 0 }
const _hoisted_528 = { key: 0 }
const _hoisted_529 = { key: 1 }
const _hoisted_530 = {
  key: 0,
  class: "send-icon-wrap"
}
const _hoisted_531 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_532 = { class: "more-member" }
const _hoisted_533 = {
  key: 0,
  class: "edit-text mb-2"
}
const _hoisted_534 = { class: "editor-wrap" }
const _hoisted_535 = { class: "small-texts-side text-right" }
const _hoisted_536 = { key: 0 }
const _hoisted_537 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_538 = { key: 1 }
const _hoisted_539 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Shift"),
  /*#__PURE__*/_createTextVNode(" + "),
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_540 = {
  key: 0,
  class: "right-actions-block"
}
const _hoisted_541 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_542 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_543 = {
  key: 0,
  class: "msg-block mt-4"
}
const _hoisted_544 = { class: "editor-wrap" }
const _hoisted_545 = { class: "msg-action-btn" }
const _hoisted_546 = { key: 0 }
const _hoisted_547 = /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt" }, null, -1)
const _hoisted_548 = { key: 1 }
const _hoisted_549 = /*#__PURE__*/_createVNode("div", { class: "mic-icons" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt-slash" })
], -1)
const _hoisted_550 = { key: 2 }
const _hoisted_551 = /*#__PURE__*/_createVNode("div", { class: "mic-icons" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-microphone-alt" })
], -1)
const _hoisted_552 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-file-upload upload-icons",
  "data-toggle": "modal"
}, null, -1)
const _hoisted_553 = /*#__PURE__*/_createVNode("label", {
  style: {"cursor":"pointer"},
  for: "thread-photo-add"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-paperclip upload-icons" })
], -1)
const _hoisted_554 = { key: 0 }
const _hoisted_555 = {
  key: 1,
  class: "spinner-border",
  role: "status"
}
const _hoisted_556 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_557 = { class: "small-texts-side text-right" }
const _hoisted_558 = { key: 0 }
const _hoisted_559 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_560 = { key: 1 }
const _hoisted_561 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("strong", null, "Shift"),
  /*#__PURE__*/_createTextVNode(" + "),
  /*#__PURE__*/_createVNode("strong", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" to add a new line")
], -1)
const _hoisted_562 = { class: "modal-wrap default-modal lg-size" }
const _hoisted_563 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_564 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_565 = { class: "modal-content" }
const _hoisted_566 = { class: "modal-header" }
const _hoisted_567 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Invite member "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_568 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_569 = { class: "modal-body" }
const _hoisted_570 = { class: "form-wrap pt-0" }
const _hoisted_571 = { key: 0 }
const _hoisted_572 = { class: "inline-items" }
const _hoisted_573 = {
  key: 0,
  class: "form-group"
}
const _hoisted_574 = { class: "custom-control custom-switch mr-3" }
const _hoisted_575 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "guestSwitch"
}, "As Guest", -1)
const _hoisted_576 = {
  key: 0,
  class: "from-group"
}
const _hoisted_577 = { class: "custom-control custom-switch mr-3" }
const _hoisted_578 = /*#__PURE__*/_createVNode("label", {
  class: "custom-control-label",
  for: "guestSwitch1"
}, "As Public User", -1)
const _hoisted_579 = {
  key: 0,
  class: "form-group"
}
const _hoisted_580 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite Existing member", -1)
const _hoisted_581 = { class: "mb-0" }
const _hoisted_582 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_583 = {
  key: 1,
  class: "form-group"
}
const _hoisted_584 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite new member by Email", -1)
const _hoisted_585 = { class: "input-btn" }
const _hoisted_586 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_587 = { key: 0 }
const _hoisted_588 = { key: 1 }
const _hoisted_589 = {
  key: 2,
  class: "table-wrap"
}
const _hoisted_590 = { class: "table table-bordered table-shadowed my-3 font-12" }
const _hoisted_591 = /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "Email"),
    /*#__PURE__*/_createVNode("td", null, "First Name"),
    /*#__PURE__*/_createVNode("td", null, "Last Name"),
    /*#__PURE__*/_createVNode("td", null, "Action")
  ])
], -1)
const _hoisted_592 = { class: "form-group" }
const _hoisted_593 = { class: "form-group" }
const _hoisted_594 = { class: "form-group" }
const _hoisted_595 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_596 = {
  key: 2,
  class: "form-group"
}
const _hoisted_597 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite new member by Email & Number", -1)
const _hoisted_598 = { class: "col-lg-3" }
const _hoisted_599 = { class: "form-group" }
const _hoisted_600 = /*#__PURE__*/_createVNode("label", { for: "exampleFullName" }, "Full Name", -1)
const _hoisted_601 = { class: "col-lg-3" }
const _hoisted_602 = { class: "form-group" }
const _hoisted_603 = /*#__PURE__*/_createVNode("label", { for: "exampleEmailInput" }, "Email", -1)
const _hoisted_604 = { class: "col-lg-3" }
const _hoisted_605 = { class: "form-group" }
const _hoisted_606 = /*#__PURE__*/_createVNode("label", { for: "exampleMobileNumber" }, "Mobile Number", -1)
const _hoisted_607 = { class: "input-group" }
const _hoisted_608 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_609 = { class: "col-lg-2" }
const _hoisted_610 = /*#__PURE__*/_createVNode("label", { for: "notifyByFormGroup" }, "Notify By", -1)
const _hoisted_611 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_612 = { class: "form-check form-check-inline" }
const _hoisted_613 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_614 = { class: "form-check form-check-inline" }
const _hoisted_615 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox2"
}, "SMS", -1)
const _hoisted_616 = { class: "d-flex align-items-center" }
const _hoisted_617 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_618 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_619 = { class: "mb-0" }
const _hoisted_620 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_621 = { key: 1 }
const _hoisted_622 = {
  key: 0,
  class: "form-group"
}
const _hoisted_623 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_624 = /*#__PURE__*/_createVNode("p", null, " Members listed below are already active in this channel. Any new invitation won't be sent to them. ", -1)
const _hoisted_625 = { class: "block-element" }
const _hoisted_626 = {
  key: 1,
  class: "form-group"
}
const _hoisted_627 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_628 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", { class: "text-danger" }, "Invitations to members listed below is already sent.")
], -1)
const _hoisted_629 = { class: "block-element" }
const _hoisted_630 = {
  key: 2,
  class: "form-group"
}
const _hoisted_631 = {
  class: "alert alert-success text-center mb-0",
  role: "alert"
}
const _hoisted_632 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "New Members listed below.")
], -1)
const _hoisted_633 = { class: "block-element" }
const _hoisted_634 = { class: "modal-footer" }
const _hoisted_635 = { key: 2 }
const _hoisted_636 = { class: "modal-wrap default-modal" }
const _hoisted_637 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_638 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_639 = { class: "modal-content text-center" }
const _hoisted_640 = { class: "msg-header" }
const _hoisted_641 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_642 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_643 = { class: "msg-body" }
const _hoisted_644 = /*#__PURE__*/_createVNode("h3", null, "Great!", -1)
const _hoisted_645 = { class: "msg-footer" }
const _hoisted_646 = { class: "modal-wrap pending-member-modal default-modal" }
const _hoisted_647 = {
  class: "modal fade bd-example-modal-sm",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "pendingMembers",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLongTitle",
  "aria-hidden": "true"
}
const _hoisted_648 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_649 = { class: "modal-content" }
const _hoisted_650 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLongTitle"
  }, " pending member "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_651 = { class: "modal-body" }
const _hoisted_652 = { class: "col-sm-8 mb-2" }
const _hoisted_653 = { class: "member-list pr-0" }
const _hoisted_654 = { class: "round-img" }
const _hoisted_655 = {
  key: 0,
  class: "text-lowercase"
}
const _hoisted_656 = {
  key: 1,
  class: "text-lowercase"
}
const _hoisted_657 = {
  key: 0,
  class: "col-sm-4 text-sm-right mb-2"
}
const _hoisted_658 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-trash" }),
  /*#__PURE__*/_createTextVNode(" Modify Conversation History")
], -1)
const _hoisted_659 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-trash" }),
  /*#__PURE__*/_createTextVNode(" Delete")
], -1)
const _hoisted_660 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-share" }),
  /*#__PURE__*/_createTextVNode(" Resend")
], -1)
const _hoisted_661 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn secondary-btn",
    "data-dismiss": "modal"
  }, " Close ")
], -1)
const _hoisted_662 = { class: "send-form modal-wrap xl-size" }
const _hoisted_663 = {
  class: "modal fade",
  id: "templateupload",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLongTitle",
  "aria-hidden": "true"
}
const _hoisted_664 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_665 = { class: "modal-content" }
const _hoisted_666 = { class: "modal-header" }
const _hoisted_667 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLongTitle"
}, "send form", -1)
const _hoisted_668 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_669 = { class: "modal-body" }
const _hoisted_670 = { class: "form-wrap pt-0" }
const _hoisted_671 = /*#__PURE__*/_createStaticVNode("<label class=\"mb-3\">Recently used</label><div class=\"modal-template-list\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"template-thumbnail\"><i class=\"fas fa-file-alt\"></i><div class=\"template-name\"><h5>Kitchen template 1</h5><p>Description goes here...</p></div></div></div><div class=\"col-lg-4\"><div class=\"template-thumbnail\"><i class=\"fas fa-file-alt\"></i><div class=\"template-name\"><h5>Kitchen template 1</h5><p>Description goes here...</p></div></div></div><div class=\"col-lg-4\"><div class=\"template-thumbnail\"><i class=\"fas fa-file-alt\"></i><div class=\"template-name\"><h5>Kitchen template 1</h5><p>Description goes here...</p></div></div></div></div></div>", 2)
const _hoisted_673 = { class: "row align-items-center" }
const _hoisted_674 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createVNode("h5", null, [
    /*#__PURE__*/_createVNode("strong", null, "Form List ")
  ])
], -1)
const _hoisted_675 = { class: "col-md-6" }
const _hoisted_676 = { class: "create-new-form" }
const _hoisted_677 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-plus fa-w-14",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "plus",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
  })
], -1)
const _hoisted_678 = /*#__PURE__*/_createTextVNode(" Create New Form")
const _hoisted_679 = { class: "search-wrap my-3" }
const _hoisted_680 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_681 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Display form")
], -1)
const _hoisted_682 = { class: "row" }
const _hoisted_683 = { class: "col-md-4" }
const _hoisted_684 = /*#__PURE__*/_createVNode("label", {
  for: "all",
  class: "ml-1"
}, "All", -1)
const _hoisted_685 = { class: "col-md-4 col-6" }
const _hoisted_686 = /*#__PURE__*/_createVNode("label", {
  for: "sent_by_me",
  class: "ml-1"
}, "Sent by me", -1)
const _hoisted_687 = { class: "col-md-4 col-6" }
const _hoisted_688 = /*#__PURE__*/_createVNode("label", {
  for: "sent_to_me",
  class: "ml-1"
}, "Sent to me", -1)
const _hoisted_689 = { class: "table-wrap inner-wrap pt-3 table-responsive" }
const _hoisted_690 = { class: "table table-bordered" }
const _hoisted_691 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      class: "col-name"
    }, "form name"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      class: "col-user"
    }, "send to users"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "created date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "updated date"),
    /*#__PURE__*/_createVNode("th", {
      scope: "col",
      class: "col-action"
    }, "Action")
  ])
], -1)
const _hoisted_692 = { key: 0 }
const _hoisted_693 = { class: "form-info" }
const _hoisted_694 = { key: 0 }
const _hoisted_695 = { key: 1 }
const _hoisted_696 = { key: 2 }
const _hoisted_697 = { key: 3 }
const _hoisted_698 = { key: 0 }
const _hoisted_699 = { key: 0 }
const _hoisted_700 = { class: "table-button" }
const _hoisted_701 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_702 = /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" }, null, -1)
const _hoisted_703 = { key: 1 }
const _hoisted_704 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: "5" }, [
    /*#__PURE__*/_createVNode("p", { class: "text-danger text-center" }, [
      /*#__PURE__*/_createVNode("strong", null, "No Templates !!! Create New")
    ])
  ])
], -1)
const _hoisted_705 = { class: "mt-3" }
const _hoisted_706 = { "aria-label": "Page navigation example" }
const _hoisted_707 = { class: "modal-footer" }
const _hoisted_708 = { class: "send-form modal-wrap xl-size" }
const _hoisted_709 = {
  class: "modal fade",
  id: "showdigitizedtemplate",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLongTitle",
  "aria-hidden": "true"
}
const _hoisted_710 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_711 = { class: "modal-content" }
const _hoisted_712 = { class: "modal-header" }
const _hoisted_713 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLongTitle"
}, " send digitized form ", -1)
const _hoisted_714 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_715 = { class: "modal-body" }
const _hoisted_716 = { class: "form-wrap pt-0" }
const _hoisted_717 = /*#__PURE__*/_createStaticVNode("<label class=\"mb-3\">Recently used</label><div class=\"modal-template-list\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"template-thumbnail\"><i class=\"fas fa-file-alt\"></i><div class=\"template-name\"><h5>Kitchen template 1</h5><p>Description goes here...</p></div></div></div><div class=\"col-lg-4\"><div class=\"template-thumbnail\"><i class=\"fas fa-file-alt\"></i><div class=\"template-name\"><h5>Kitchen template 1</h5><p>Description goes here...</p></div></div></div><div class=\"col-lg-4\"><div class=\"template-thumbnail\"><i class=\"fas fa-file-alt\"></i><div class=\"template-name\"><h5>Kitchen template 1</h5><p>Description goes here...</p></div></div></div></div></div>", 2)
const _hoisted_719 = { class: "row align-items-center" }
const _hoisted_720 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createVNode("h5", null, [
    /*#__PURE__*/_createVNode("strong", null, "Digitized Pdf List")
  ])
], -1)
const _hoisted_721 = { class: "col-md-6" }
const _hoisted_722 = { class: "create-new-form" }
const _hoisted_723 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-plus fa-w-14",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "plus",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
  })
], -1)
const _hoisted_724 = /*#__PURE__*/_createTextVNode(" Create New Form")
const _hoisted_725 = { class: "table-responsive my-3" }
const _hoisted_726 = {
  key: 0,
  class: "table table-bordered table-shadowed mb-0"
}
const _hoisted_727 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Upload Template"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Uploaded By"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Uploaded Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Sent To")
  ])
], -1)
const _hoisted_728 = /*#__PURE__*/_createVNode("i", { class: "fa fa-external-link-alt" }, null, -1)
const _hoisted_729 = { key: 0 }
const _hoisted_730 = { class: "user-img-wrap" }
const _hoisted_731 = /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" }, null, -1)
const _hoisted_732 = /*#__PURE__*/_createTextVNode(" Send to")
const _hoisted_733 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_734 = { class: "modal-footer" }
const _hoisted_735 = { class: "modal-wrap xl-size" }
const _hoisted_736 = {
  class: "modal fade",
  id: "innerchannelModal",
  tabindex: "-1",
  "aria-labelledby": "innerchannelModalLabel",
  "aria-hidden": "true"
}
const _hoisted_737 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_738 = { class: "modal-content" }
const _hoisted_739 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "innerchannelModalLabel"
  }, " Create New Form "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_740 = { class: "modal-body create-template-block bg-light" }
const _hoisted_741 = { class: "row" }
const _hoisted_742 = { class: "col-3" }
const _hoisted_743 = { class: "\n                                    form-element-wrapper\n                                    block-list\n                                    position-relative\n                                    w-100\n                                  " }
const _hoisted_744 = /*#__PURE__*/_createTextVNode(" Section ")
const _hoisted_745 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_746 = /*#__PURE__*/_createTextVNode(" TextBox ")
const _hoisted_747 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_748 = /*#__PURE__*/_createTextVNode(" Textarea ")
const _hoisted_749 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_750 = /*#__PURE__*/_createTextVNode(" Select ")
const _hoisted_751 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_752 = /*#__PURE__*/_createTextVNode(" Radio ")
const _hoisted_753 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_754 = /*#__PURE__*/_createTextVNode(" checkbox ")
const _hoisted_755 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_756 = { class: "col-lg-9" }
const _hoisted_757 = { class: "card drag-wrapper" }
const _hoisted_758 = { class: "form-wrap pt-0" }
const _hoisted_759 = { class: "form-block" }
const _hoisted_760 = { class: "form-group" }
const _hoisted_761 = { class: "edit-action" }
const _hoisted_762 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_763 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Form", -1)
const _hoisted_764 = { class: "form-group mb-0" }
const _hoisted_765 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Short Description", -1)
const _hoisted_766 = { class: "form-wrap pt-0" }
const _hoisted_767 = { key: 0 }
const _hoisted_768 = { class: "form-block form-title" }
const _hoisted_769 = { class: "edit-action" }
const _hoisted_770 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_771 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_772 = { class: "title" }
const _hoisted_773 = {
  key: 1,
  class: "form-block"
}
const _hoisted_774 = { class: "form-group mb-0" }
const _hoisted_775 = { class: "edit-action" }
const _hoisted_776 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_777 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_778 = { for: "inputPassword" }
const _hoisted_779 = {
  key: 2,
  class: "form-block"
}
const _hoisted_780 = { class: "form-group mb-0" }
const _hoisted_781 = { class: "edit-action" }
const _hoisted_782 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_783 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_784 = { for: "inputPassword" }
const _hoisted_785 = {
  key: 3,
  class: "form-block"
}
const _hoisted_786 = { class: "edit-action" }
const _hoisted_787 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_788 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_789 = { class: "d-inline-block ml-2 mb-0" }
const _hoisted_790 = {
  key: 4,
  class: "form-block"
}
const _hoisted_791 = { class: "form-wrap pt-0" }
const _hoisted_792 = { class: "edit-action" }
const _hoisted_793 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_794 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_795 = { for: "" }
const _hoisted_796 = {
  key: 5,
  class: "form-block"
}
const _hoisted_797 = { class: "edit-action" }
const _hoisted_798 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_799 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_800 = { for: "" }
const _hoisted_801 = {
  id: "cars",
  class: "form-control"
}
const _hoisted_802 = { class: "modal-footer d-block" }
const _hoisted_803 = { class: "row" }
const _hoisted_804 = { class: "col-lg-6" }
const _hoisted_805 = { class: "share-form-block form-inline" }
const _hoisted_806 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "mr-2"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mr-2" }),
  /*#__PURE__*/_createTextVNode(" Share this Form : ")
], -1)
const _hoisted_807 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_808 = { class: "tooltip-block" }
const _hoisted_809 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_810 = { class: "tooltip-msg" }
const _hoisted_811 = { class: "mb-0" }
const _hoisted_812 = { class: "col-lg-6" }
const _hoisted_813 = { class: "col-button" }
const _hoisted_814 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_815 = { class: "modal-wrap form-edit" }
const _hoisted_816 = {
  class: "modal fade",
  id: "deleteSelectedElementInCreateNewForm",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_817 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_818 = { class: "modal-content" }
const _hoisted_819 = { class: "modal-header" }
const _hoisted_820 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Delete Confirmation ", -1)
const _hoisted_821 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_822 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-wrap pt-0" }, [
    /*#__PURE__*/_createVNode("p", { class: "mb-0" }, " Are you sure you want to delete following form item? ")
  ])
], -1)
const _hoisted_823 = { class: "modal-footer" }
const _hoisted_824 = { class: "modal-wrap form-edit xl-size" }
const _hoisted_825 = {
  class: "modal fade",
  id: "editSelectedElementOfCreateNewForm",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_826 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_827 = { class: "modal-content" }
const _hoisted_828 = { class: "modal-header" }
const _hoisted_829 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_830 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_831 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_832 = { class: "modal-body" }
const _hoisted_833 = { class: "form-wrap pt-0" }
const _hoisted_834 = { key: 0 }
const _hoisted_835 = { class: "form-group" }
const _hoisted_836 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Form", -1)
const _hoisted_837 = { class: "form-group" }
const _hoisted_838 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Short Description", -1)
const _hoisted_839 = { key: 1 }
const _hoisted_840 = { class: "form-group" }
const _hoisted_841 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Section", -1)
const _hoisted_842 = { class: "form-group" }
const _hoisted_843 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Section Short Description", -1)
const _hoisted_844 = { key: 2 }
const _hoisted_845 = { class: "form-group" }
const _hoisted_846 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_847 = { key: 3 }
const _hoisted_848 = { class: "form-group" }
const _hoisted_849 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_850 = { key: 4 }
const _hoisted_851 = { class: "form-wrap pt-0" }
const _hoisted_852 = { class: "form-group" }
const _hoisted_853 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_854 = {
  key: 0,
  class: "form-group"
}
const _hoisted_855 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_856 = { class: "col-lg-1" }
const _hoisted_857 = { class: "form-check" }
const _hoisted_858 = { class: "col-lg-5" }
const _hoisted_859 = { class: "col-lg-1 pl-0" }
const _hoisted_860 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_861 = { class: "text-right" }
const _hoisted_862 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_863 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_864 = { key: 5 }
const _hoisted_865 = { class: "form-wrap pt-0" }
const _hoisted_866 = { class: "form-group" }
const _hoisted_867 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_868 = {
  key: 0,
  class: "form-group"
}
const _hoisted_869 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_870 = { class: "col-lg-1" }
const _hoisted_871 = { class: "col-lg-5" }
const _hoisted_872 = { class: "col-lg-1 pl-0" }
const _hoisted_873 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_874 = { class: "text-right" }
const _hoisted_875 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_876 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_877 = { key: 6 }
const _hoisted_878 = { class: "form-wrap pt-0" }
const _hoisted_879 = { class: "form-group" }
const _hoisted_880 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_881 = {
  key: 0,
  class: "form-group"
}
const _hoisted_882 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_883 = { class: "col-lg-1" }
const _hoisted_884 = { class: "col-lg-5" }
const _hoisted_885 = { class: "col-lg-1 pl-0" }
const _hoisted_886 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_887 = { class: "text-right" }
const _hoisted_888 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_889 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_890 = { class: "modal-footer" }
const _hoisted_891 = { class: "modal-wrap xl-size" }
const _hoisted_892 = {
  class: "modal fade",
  id: "addfieldModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_893 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_894 = { class: "modal-content" }
const _hoisted_895 = { class: "modal-header" }
const _hoisted_896 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_897 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_898 = { class: "modal-body" }
const _hoisted_899 = { class: "form-wrap pt-0" }
const _hoisted_900 = { key: 0 }
const _hoisted_901 = { class: "form-group" }
const _hoisted_902 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_903 = { class: "form-group" }
const _hoisted_904 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Description", -1)
const _hoisted_905 = { key: 1 }
const _hoisted_906 = { class: "form-group" }
const _hoisted_907 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_908 = { class: "form-group" }
const _hoisted_909 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Description", -1)
const _hoisted_910 = { key: 2 }
const _hoisted_911 = { class: "form-group" }
const _hoisted_912 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_913 = { key: 3 }
const _hoisted_914 = { class: "form-group" }
const _hoisted_915 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_916 = { key: 4 }
const _hoisted_917 = { class: "form-wrap pt-0" }
const _hoisted_918 = { class: "form-group" }
const _hoisted_919 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_920 = {
  key: 0,
  class: "form-group"
}
const _hoisted_921 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_922 = { class: "col-lg-1" }
const _hoisted_923 = { class: "col-lg-5" }
const _hoisted_924 = {
  key: 0,
  class: "col-lg-1 pl-0"
}
const _hoisted_925 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_926 = { class: "text-right" }
const _hoisted_927 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_928 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_929 = { key: 5 }
const _hoisted_930 = { class: "form-wrap pt-0" }
const _hoisted_931 = { class: "form-group" }
const _hoisted_932 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_933 = {
  key: 0,
  class: "form-group"
}
const _hoisted_934 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_935 = { class: "col-lg-1" }
const _hoisted_936 = { class: "col-lg-5" }
const _hoisted_937 = {
  key: 0,
  class: "col-lg-1 pl-0"
}
const _hoisted_938 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_939 = { class: "text-right" }
const _hoisted_940 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_941 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_942 = { key: 6 }
const _hoisted_943 = { class: "form-wrap pt-0" }
const _hoisted_944 = { class: "form-group" }
const _hoisted_945 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_946 = {
  key: 0,
  class: "form-group"
}
const _hoisted_947 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_948 = { class: "col-lg-1" }
const _hoisted_949 = { class: "form-check" }
const _hoisted_950 = { class: "col-lg-5" }
const _hoisted_951 = {
  key: 0,
  class: "col-lg-1 pl-0"
}
const _hoisted_952 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_953 = { class: "text-right" }
const _hoisted_954 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_955 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_956 = { class: "form-group" }
const _hoisted_957 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Add at", -1)
const _hoisted_958 = /*#__PURE__*/_createVNode("option", { value: "top" }, "Top", -1)
const _hoisted_959 = /*#__PURE__*/_createVNode("option", { value: "bottom" }, "Bottom", -1)
const _hoisted_960 = { class: "modal-footer" }
const _hoisted_961 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_962 = { class: "send-to modal-wrap xl-size" }
const _hoisted_963 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_964 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_965 = { class: "modal-content" }
const _hoisted_966 = { class: "modal-header" }
const _hoisted_967 = { class: "d-block" }
const _hoisted_968 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_969 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_970 = { class: "modal-body" }
const _hoisted_971 = { class: "form-wrap pt-0" }
const _hoisted_972 = { disabled: "" }
const _hoisted_973 = { class: "modal-footer d-block" }
const _hoisted_974 = { class: "row" }
const _hoisted_975 = { class: "col-lg-6" }
const _hoisted_976 = { class: "share-form-block form-inline" }
const _hoisted_977 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "mr-2"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mr-2" }),
  /*#__PURE__*/_createTextVNode(" Share this Form : ")
], -1)
const _hoisted_978 = {
  key: 0,
  class: "form-wrap pt-0 ml-2"
}
const _hoisted_979 = { class: "tooltip-block" }
const _hoisted_980 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_981 = { class: "tooltip-msg" }
const _hoisted_982 = { class: "mb-0" }
const _hoisted_983 = { class: "col-lg-6" }
const _hoisted_984 = { class: "col-button" }
const _hoisted_985 = { class: "edit-template modal-wrap xl-size" }
const _hoisted_986 = {
  class: "modal fade",
  id: "editExampleModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_987 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_988 = { class: "modal-content" }
const _hoisted_989 = { class: "modal-header" }
const _hoisted_990 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_991 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_992 = { class: "modal-body" }
const _hoisted_993 = { class: "form-wrap pt-0" }
const _hoisted_994 = { class: "modal-footer" }
const _hoisted_995 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn default-btn",
  "data-toggle": "modal",
  "data-target": "#mentionuser"
}, " Send to Users ", -1)
const _hoisted_996 = { class: "mention-user modal-wrap xl-size" }
const _hoisted_997 = {
  class: "modal fade",
  id: "mentionuser",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_998 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_999 = { class: "modal-content" }
const _hoisted_1000 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><div class=\"d-block\"><h5 class=\"modal-title\" id=\"mentionuser\">Send form</h5><p class=\"text-muted\"> Choose user to send this form. You can choose multiple users too. </p></div><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div>", 1)
const _hoisted_1001 = { class: "modal-body" }
const _hoisted_1002 = { class: "form-wrap pt-0" }
const _hoisted_1003 = { class: "form-group" }
const _hoisted_1004 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Choose member", -1)
const _hoisted_1005 = { class: "mb-0" }
const _hoisted_1006 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_1007 = { class: "form-group" }
const _hoisted_1008 = /*#__PURE__*/_createVNode("label", { for: "" }, "Additional message", -1)
const _hoisted_1009 = { class: "modal-footer" }
const _hoisted_1010 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " cancel ", -1)
const _hoisted_1011 = /*#__PURE__*/_createStaticVNode("<div class=\"edit-template modal-wrap xl-size\"><div class=\"modal fade\" id=\"edittemplate\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered modal-dialog-scrollable\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Edit template</h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\">...</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn secondary-btn\" data-dismiss=\"modal\"> Close </button><button type=\"button\" class=\"btn btn-primary\"> Save changes </button></div></div></div></div></div>", 1)
const _hoisted_1012 = { class: "modal-wrap xl-size default-modal" }
const _hoisted_1013 = {
  class: "modal fade",
  id: "formview",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1014 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_1015 = { class: "modal-content" }
const _hoisted_1016 = { class: "modal-header" }
const _hoisted_1017 = {
  key: 0,
  class: "d-block"
}
const _hoisted_1018 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1019 = {
  key: 1,
  class: "d-block"
}
const _hoisted_1020 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1021 = { key: 0 }
const _hoisted_1022 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1023 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_1024 = { class: "row" }
const _hoisted_1025 = { class: "col -md-8" }
const _hoisted_1026 = /*#__PURE__*/_createVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "nav-link active",
      id: "profile-tab",
      "data-toggle": "tab",
      href: "#profile",
      role: "tab",
      "aria-controls": "home",
      "aria-selected": "true"
    }, "Fill Out The Form")
  ])
], -1)
const _hoisted_1027 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_1028 = {
  class: "tab-pane fade show active",
  id: "home",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_1029 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_1030 = { disabled: "" }
const _hoisted_1031 = { key: 7 }
const _hoisted_1032 = { for: "" }
const _hoisted_1033 = {
  key: 0,
  class: "p-3"
}
const _hoisted_1034 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-name mb-2\"><div class=\"doc-wrap pdf-wrap\"><i class=\"fa fa-file-pdf\"></i></div></div></div></div>", 1)
const _hoisted_1035 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_1036 = /*#__PURE__*/_createTextVNode(" Download Pdf ")
const _hoisted_1037 = {
  key: 1,
  class: "\n                                        empty-holder\n                                        dashed-box\n                                        bg-white\n                                        mb-3\n                                        align-items-center\n                                        m-3\n                                      "
}
const _hoisted_1038 = { class: "p-5 text-center w-100" }
const _hoisted_1039 = { class: "empty-channel w-100" }
const _hoisted_1040 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-exclamation-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1)
const _hoisted_1041 = { class: "text-center" }
const _hoisted_1042 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_1043 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_1044 = { key: 2 }
const _hoisted_1045 = /*#__PURE__*/_createTextVNode(" You have not filled the form ")
const _hoisted_1046 = /*#__PURE__*/_createTextVNode(" to fill it. ")
const _hoisted_1047 = {
  class: "tab-pane fade",
  id: "profile",
  role: "tabpanel",
  "aria-labelledby": "profile-tab"
}
const _hoisted_1048 = { disabled: "" }
const _hoisted_1049 = { class: "form-wrap pt-0" }
const _hoisted_1050 = { key: 7 }
const _hoisted_1051 = { for: "" }
const _hoisted_1052 = { class: "col-lg-4 equal-height-lg-div" }
const _hoisted_1053 = { class: "form-wrap pt-0 mb-3" }
const _hoisted_1054 = { class: "search-wrap" }
const _hoisted_1055 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_1056 = {
  key: 0,
  class: "vertical-nav-wrap"
}
const _hoisted_1057 = { class: "member-list form-response" }
const _hoisted_1058 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_1059 = { class: "row" }
const _hoisted_1060 = { class: "col -md-8" }
const _hoisted_1061 = /*#__PURE__*/_createVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "nav-link active",
      id: "profile-tab",
      "data-toggle": "tab",
      href: "#profile",
      role: "tab",
      "aria-controls": "home",
      "aria-selected": "true"
    }, "Fill Out The Form")
  ])
], -1)
const _hoisted_1062 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_1063 = {
  class: "tab-pane fade show active",
  id: "home",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_1064 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_1065 = {
  key: 0,
  class: "p-3"
}
const _hoisted_1066 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-name mb-2\"><div class=\"doc-wrap pdf-wrap\"><i class=\"fa fa-file-pdf\"></i></div></div></div></div>", 1)
const _hoisted_1067 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_1068 = /*#__PURE__*/_createTextVNode(" Download Pdf ")
const _hoisted_1069 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_1070 = {
  key: 1,
  class: "\n                                        empty-holder\n                                        dashed-box\n                                        bg-white\n                                        mb-3\n                                        align-items-center\n                                        m-3\n                                      "
}
const _hoisted_1071 = { class: "p-5 text-center w-100" }
const _hoisted_1072 = { class: "empty-channel w-100" }
const _hoisted_1073 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-exclamation-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1)
const _hoisted_1074 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_1075 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_1076 = { key: 2 }
const _hoisted_1077 = /*#__PURE__*/_createTextVNode(" You have not filled the form ")
const _hoisted_1078 = /*#__PURE__*/_createTextVNode(" to fill it. ")
const _hoisted_1079 = { key: 0 }
const _hoisted_1080 = /*#__PURE__*/_createTextVNode(" Form Preview ")
const _hoisted_1081 = {
  class: "tab-pane fade",
  id: "profile",
  role: "tabpanel",
  "aria-labelledby": "profile-tab"
}
const _hoisted_1082 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_1083 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_1084 = {
  key: 0,
  class: "p-3"
}
const _hoisted_1085 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-name mb-2\"><div class=\"doc-wrap pdf-wrap\"><i class=\"fa fa-file-pdf\"></i></div></div></div></div>", 1)
const _hoisted_1086 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_1087 = /*#__PURE__*/_createTextVNode(" Download Pdf ")
const _hoisted_1088 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_1089 = {
  key: 1,
  class: "\n                                        empty-holder\n                                        dashed-box\n                                        bg-white\n                                        mb-3\n                                        align-items-center\n                                        m-3\n                                      "
}
const _hoisted_1090 = { class: "p-5 text-center w-100" }
const _hoisted_1091 = { class: "empty-channel w-100" }
const _hoisted_1092 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-exclamation-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1)
const _hoisted_1093 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_1094 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_1095 = { key: 2 }
const _hoisted_1096 = /*#__PURE__*/_createTextVNode(" You have not filled the form ")
const _hoisted_1097 = /*#__PURE__*/_createTextVNode(" to fill it. ")
const _hoisted_1098 = { key: 0 }
const _hoisted_1099 = /*#__PURE__*/_createTextVNode(" Form Preview ")
const _hoisted_1100 = { class: "col-lg-4 equal-height-lg-div" }
const _hoisted_1101 = { class: "form-wrap pt-0 mb-3" }
const _hoisted_1102 = { class: "search-wrap" }
const _hoisted_1103 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_1104 = {
  key: 0,
  class: "vertical-nav-wrap"
}
const _hoisted_1105 = { class: "member-list form-response" }
const _hoisted_1106 = { class: "modal-footer justify-content-between" }
const _hoisted_1107 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_1108 = { class: "mb-0" }
const _hoisted_1109 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_1110 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_1111 = { key: 0 }
const _hoisted_1112 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_1113 = { class: "modal-wrap xl-size" }
const _hoisted_1114 = {
  class: "modal fade",
  id: "createnewformModal",
  tabindex: "-1",
  "aria-labelledby": "createnewformModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1115 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_1116 = { class: "modal-content" }
const _hoisted_1117 = { class: "modal-header" }
const _hoisted_1118 = /*#__PURE__*/_createVNode("div", { class: "modal-back-btn" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" })
], -1)
const _hoisted_1119 = { class: "d-block mt-1" }
const _hoisted_1120 = {
  class: "modal-title",
  id: "createnewformModalLabel"
}
const _hoisted_1121 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }),
  /*#__PURE__*/_createTextVNode(" You are editing this form. ")
], -1)
const _hoisted_1122 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_1123 = { class: "modal-body create-template-block bg-light" }
const _hoisted_1124 = { class: "row" }
const _hoisted_1125 = { class: "col-3" }
const _hoisted_1126 = { class: "\n                                    form-element-wrapper\n                                    block-list\n                                    position-relative\n                                    w-100\n                                  " }
const _hoisted_1127 = /*#__PURE__*/_createTextVNode(" Section ")
const _hoisted_1128 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_1129 = /*#__PURE__*/_createTextVNode(" Text field ")
const _hoisted_1130 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_1131 = /*#__PURE__*/_createTextVNode(" Textarea ")
const _hoisted_1132 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_1133 = /*#__PURE__*/_createTextVNode(" Select ")
const _hoisted_1134 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_1135 = /*#__PURE__*/_createTextVNode(" Radio ")
const _hoisted_1136 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_1137 = /*#__PURE__*/_createTextVNode(" checkbox ")
const _hoisted_1138 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_1139 = { class: "col-lg-9" }
const _hoisted_1140 = { class: "card drag-wrapper" }
const _hoisted_1141 = { class: "form-wrap pt-0" }
const _hoisted_1142 = { class: "edit-form" }
const _hoisted_1143 = { class: "form-group" }
const _hoisted_1144 = { class: "edit-action" }
const _hoisted_1145 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1146 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Form", -1)
const _hoisted_1147 = { class: "form-group" }
const _hoisted_1148 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Short Description", -1)
const _hoisted_1149 = { class: "form-wrap pt-0" }
const _hoisted_1150 = { key: 0 }
const _hoisted_1151 = { class: "form-group" }
const _hoisted_1152 = { class: "edit-action" }
const _hoisted_1153 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1154 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1155 = { for: "inputPassword" }
const _hoisted_1156 = { key: 1 }
const _hoisted_1157 = { class: "form-block form-title" }
const _hoisted_1158 = { class: "edit-action" }
const _hoisted_1159 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1160 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1161 = { class: "title" }
const _hoisted_1162 = {
  key: 2,
  class: "form-group"
}
const _hoisted_1163 = { class: "form-wrap pt-0" }
const _hoisted_1164 = { class: "edit-action" }
const _hoisted_1165 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1166 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1167 = { for: "" }
const _hoisted_1168 = { class: "d-inline ml-1" }
const _hoisted_1169 = {
  key: 3,
  class: "form-group"
}
const _hoisted_1170 = { class: "edit-action" }
const _hoisted_1171 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1172 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1173 = { for: "" }
const _hoisted_1174 = {
  id: "cars",
  class: "form-control"
}
const _hoisted_1175 = {
  key: 4,
  class: "form-group"
}
const _hoisted_1176 = { class: "edit-action" }
const _hoisted_1177 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1178 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1179 = { class: "d-inline-block ml-2" }
const _hoisted_1180 = { key: 5 }
const _hoisted_1181 = { class: "form-group" }
const _hoisted_1182 = { class: "edit-action" }
const _hoisted_1183 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1184 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1185 = { for: "inputPassword" }
const _hoisted_1186 = { class: "modal-footer d-block" }
const _hoisted_1187 = { class: "row" }
const _hoisted_1188 = { class: "col-lg-6" }
const _hoisted_1189 = { class: "share-form-block form-inline" }
const _hoisted_1190 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "mr-2"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mr-2" }),
  /*#__PURE__*/_createTextVNode(" Share this Form : ")
], -1)
const _hoisted_1191 = {
  key: 0,
  class: "form-wrap pt-0 ml-2"
}
const _hoisted_1192 = { class: "tooltip-block" }
const _hoisted_1193 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_1194 = { class: "tooltip-msg" }
const _hoisted_1195 = { class: "mb-0" }
const _hoisted_1196 = { class: "col-lg-6" }
const _hoisted_1197 = { class: "col-button" }
const _hoisted_1198 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_1199 = { class: "modal-wrap xl-size" }
const _hoisted_1200 = {
  class: "modal fade",
  id: "editSelectedElement",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1201 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1202 = { class: "modal-content" }
const _hoisted_1203 = { class: "modal-header" }
const _hoisted_1204 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1205 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1206 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_1207 = { class: "modal-body" }
const _hoisted_1208 = { class: "form-wrap pt-0" }
const _hoisted_1209 = { key: 0 }
const _hoisted_1210 = { class: "form-group" }
const _hoisted_1211 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Form", -1)
const _hoisted_1212 = { class: "form-group" }
const _hoisted_1213 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Short Description", -1)
const _hoisted_1214 = { key: 1 }
const _hoisted_1215 = { class: "form-group" }
const _hoisted_1216 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Section", -1)
const _hoisted_1217 = { class: "form-group" }
const _hoisted_1218 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Section Short Description", -1)
const _hoisted_1219 = { key: 2 }
const _hoisted_1220 = { class: "form-group" }
const _hoisted_1221 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1222 = { key: 3 }
const _hoisted_1223 = { class: "form-group" }
const _hoisted_1224 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1225 = { key: 4 }
const _hoisted_1226 = { class: "form-wrap pt-0" }
const _hoisted_1227 = { class: "form-group" }
const _hoisted_1228 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1229 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1230 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_1231 = { class: "col-lg-1" }
const _hoisted_1232 = { class: "form-check" }
const _hoisted_1233 = { class: "col-lg-5" }
const _hoisted_1234 = {
  key: 0,
  class: "col-lg-1 pl-0"
}
const _hoisted_1235 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1236 = { class: "text-right" }
const _hoisted_1237 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1238 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_1239 = { key: 5 }
const _hoisted_1240 = { class: "form-wrap pt-0" }
const _hoisted_1241 = { class: "form-group" }
const _hoisted_1242 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1243 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1244 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_1245 = { class: "col-lg-1" }
const _hoisted_1246 = { class: "col-lg-5" }
const _hoisted_1247 = {
  key: 0,
  class: "col-lg-1 pl-0"
}
const _hoisted_1248 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1249 = { class: "text-right" }
const _hoisted_1250 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1251 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_1252 = { key: 6 }
const _hoisted_1253 = { class: "form-wrap pt-0" }
const _hoisted_1254 = { class: "form-group" }
const _hoisted_1255 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1256 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1257 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_1258 = { class: "col-lg-1" }
const _hoisted_1259 = { class: "col-lg-5" }
const _hoisted_1260 = {
  key: 0,
  class: "col-lg-1 pl-0"
}
const _hoisted_1261 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1262 = { class: "text-right" }
const _hoisted_1263 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1264 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_1265 = { class: "modal-footer" }
const _hoisted_1266 = { class: "modal-wrap confirmation-modal" }
const _hoisted_1267 = {
  class: "modal",
  id: "deleteSelectedElement",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1268 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1269 = { class: "modal-content" }
const _hoisted_1270 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\"> Delete Confirmation </h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><div class=\"form-wrap pt-0\"><p> Are you sure you want to delete following form item ? This process can not be undone. </p></div></div>", 2)
const _hoisted_1272 = { class: "modal-footer" }
const _hoisted_1273 = { class: "modal-wrap form-edit" }
const _hoisted_1274 = {
  class: "modal fade",
  id: "confirmNewForm",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1275 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1276 = { class: "modal-content" }
const _hoisted_1277 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\"> Confirmation New Form </h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><div class=\"form-wrap pt-0\"><p> Are you sure you want to save new form without sending to anyone and without any Message !!! </p></div></div>", 2)
const _hoisted_1279 = { class: "modal-footer" }
const _hoisted_1280 = { class: "modal-wrap confirmation-modal" }
const _hoisted_1281 = {
  class: "modal",
  id: "confirmEditForm",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1282 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1283 = { class: "modal-content" }
const _hoisted_1284 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\"> Confirmation Form </h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><div class=\"form-wrap pt-0\"><p> Are you sure you want to save the form without sending to anyone? </p></div></div>", 2)
const _hoisted_1286 = { class: "modal-footer" }
const _hoisted_1287 = { class: "modal-wrap xl-size" }
const _hoisted_1288 = {
  class: "modal fade",
  id: "addfieldModal1",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1289 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_1290 = { class: "modal-content" }
const _hoisted_1291 = { class: "modal-header" }
const _hoisted_1292 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1293 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_1294 = { class: "modal-body" }
const _hoisted_1295 = { class: "form-wrap pt-0" }
const _hoisted_1296 = { class: "form-wrap pt-0" }
const _hoisted_1297 = { key: 0 }
const _hoisted_1298 = { class: "form-group" }
const _hoisted_1299 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1300 = { class: "form-group" }
const _hoisted_1301 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Description", -1)
const _hoisted_1302 = { key: 1 }
const _hoisted_1303 = { class: "form-group" }
const _hoisted_1304 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1305 = { class: "form-group" }
const _hoisted_1306 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Description", -1)
const _hoisted_1307 = { key: 2 }
const _hoisted_1308 = { class: "form-group" }
const _hoisted_1309 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1310 = { key: 3 }
const _hoisted_1311 = { class: "form-group" }
const _hoisted_1312 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1313 = { key: 4 }
const _hoisted_1314 = { class: "form-wrap pt-0" }
const _hoisted_1315 = { class: "form-group" }
const _hoisted_1316 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1317 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1318 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_1319 = { class: "col-lg-1" }
const _hoisted_1320 = { class: "col-lg-5" }
const _hoisted_1321 = { class: "col-lg-1 pl-0" }
const _hoisted_1322 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1323 = { class: "text-right" }
const _hoisted_1324 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1325 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_1326 = { key: 5 }
const _hoisted_1327 = { class: "form-wrap pt-0" }
const _hoisted_1328 = { class: "form-group" }
const _hoisted_1329 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1330 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1331 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_1332 = { class: "col-lg-1" }
const _hoisted_1333 = { class: "col-lg-5" }
const _hoisted_1334 = { class: "col-lg-1 pl-0" }
const _hoisted_1335 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1336 = { class: "text-right" }
const _hoisted_1337 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1338 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_1339 = { key: 6 }
const _hoisted_1340 = { class: "form-wrap pt-0" }
const _hoisted_1341 = { class: "form-group" }
const _hoisted_1342 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_1343 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1344 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_1345 = { class: "col-lg-1" }
const _hoisted_1346 = { class: "form-check" }
const _hoisted_1347 = { class: "col-lg-5" }
const _hoisted_1348 = { class: "col-lg-1 pl-0" }
const _hoisted_1349 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1350 = { class: "text-right" }
const _hoisted_1351 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1352 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_1353 = { class: "form-group" }
const _hoisted_1354 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Add at", -1)
const _hoisted_1355 = /*#__PURE__*/_createVNode("option", { value: "top" }, "Top", -1)
const _hoisted_1356 = /*#__PURE__*/_createVNode("option", { value: "bottom" }, "Bottom", -1)
const _hoisted_1357 = { class: "modal-footer" }
const _hoisted_1358 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_1359 = { class: "modal-wrap xl-size" }
const _hoisted_1360 = {
  class: "modal fade",
  id: "senduserdModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1361 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_1362 = { class: "modal-content" }
const _hoisted_1363 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Send to Users"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_1364 = { class: "modal-body" }
const _hoisted_1365 = { class: "form-wrap pt-0" }
const _hoisted_1366 = { class: "form-group" }
const _hoisted_1367 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite Existing member", -1)
const _hoisted_1368 = { class: "mb-0" }
const _hoisted_1369 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_1370 = { class: "form-group" }
const _hoisted_1371 = /*#__PURE__*/_createVNode("label", { for: "" }, "Message", -1)
const _hoisted_1372 = { class: "modal-footer" }
const _hoisted_1373 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_1374 = { class: "modal-wrap xl-size" }
const _hoisted_1375 = {
  class: "modal fade",
  id: "sendformModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1376 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_1377 = { class: "modal-content" }
const _hoisted_1378 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Send to Form"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_1379 = { class: "modal-body" }
const _hoisted_1380 = { class: "form-wrap pt-0" }
const _hoisted_1381 = { class: "form-group" }
const _hoisted_1382 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite Existing member", -1)
const _hoisted_1383 = { class: "mb-0" }
const _hoisted_1384 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_1385 = { class: "form-group" }
const _hoisted_1386 = /*#__PURE__*/_createVNode("label", { for: "" }, "Message", -1)
const _hoisted_1387 = { class: "modal-footer" }
const _hoisted_1388 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_1389 = { class: "modal-wrap default-modal" }
const _hoisted_1390 = {
  class: "modal fade",
  id: "deleteSelectedAttachment",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1391 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1392 = { class: "modal-content" }
const _hoisted_1393 = { class: "modal-header" }
const _hoisted_1394 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Delete Confirmation ", -1)
const _hoisted_1395 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1396 = { class: "modal-body" }
const _hoisted_1397 = { class: "form-wrap pt-0" }
const _hoisted_1398 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_1399 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_1400 = { class: "modal-footer" }
const _hoisted_1401 = { class: "modal-wrap default-modal" }
const _hoisted_1402 = {
  class: "modal fade",
  id: "deleteReplySelectedAttachment",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1403 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1404 = { class: "modal-content" }
const _hoisted_1405 = { class: "modal-header" }
const _hoisted_1406 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Delete Confirmation ", -1)
const _hoisted_1407 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1408 = { class: "modal-body" }
const _hoisted_1409 = { class: "form-wrap pt-0" }
const _hoisted_1410 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_1411 = { class: "modal-footer" }
const _hoisted_1412 = { class: "send-to modal-wrap xl-size" }
const _hoisted_1413 = {
  class: "modal fade",
  id: "showFormViewModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1414 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_1415 = { class: "modal-content" }
const _hoisted_1416 = { class: "modal-header" }
const _hoisted_1417 = { class: "d-block" }
const _hoisted_1418 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1419 = { class: "text-muted" }
const _hoisted_1420 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1421 = { class: "modal-body" }
const _hoisted_1422 = { class: "form-wrap pt-0" }
const _hoisted_1423 = { disabled: "" }
const _hoisted_1424 = { key: 7 }
const _hoisted_1425 = { class: "modal-footer justify-content-between" }
const _hoisted_1426 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_1427 = { class: "mb-0" }
const _hoisted_1428 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_1429 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_1430 = { key: 0 }
const _hoisted_1431 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_1432 = { class: "modal-wrap xl-size" }
const _hoisted_1433 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1434 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_1435 = { class: "modal-content" }
const _hoisted_1436 = { class: "modal-header" }
const _hoisted_1437 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1438 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_1439 = { class: "modal-body" }
const _hoisted_1440 = /*#__PURE__*/_createVNode("p", { class: "error-field-text" }, " Fields marked with an asterisk (*) are required. ", -1)
const _hoisted_1441 = { class: "form-group" }
const _hoisted_1442 = {
  key: 0,
  class: "form-group"
}
const _hoisted_1443 = { for: "" }
const _hoisted_1444 = {
  key: 0,
  class: "required"
}
const _hoisted_1445 = {
  key: 1,
  class: "form-group"
}
const _hoisted_1446 = { for: "" }
const _hoisted_1447 = {
  key: 0,
  class: "required"
}
const _hoisted_1448 = { class: "canvas-wrap" }
const _hoisted_1449 = {
  key: 2,
  class: "form-group"
}
const _hoisted_1450 = { for: "" }
const _hoisted_1451 = {
  key: 0,
  class: "required"
}
const _hoisted_1452 = {
  key: 3,
  class: "form-group"
}
const _hoisted_1453 = { for: "" }
const _hoisted_1454 = {
  key: 0,
  class: "required"
}
const _hoisted_1455 = { key: 0 }
const _hoisted_1456 = { key: 1 }
const _hoisted_1457 = {
  key: 4,
  class: "form-group"
}
const _hoisted_1458 = { for: "" }
const _hoisted_1459 = {
  key: 0,
  class: "required"
}
const _hoisted_1460 = { key: 0 }
const _hoisted_1461 = { key: 1 }
const _hoisted_1462 = {
  key: 5,
  class: "form-group"
}
const _hoisted_1463 = {
  key: 0,
  class: "required"
}
const _hoisted_1464 = { key: 0 }
const _hoisted_1465 = { key: 1 }
const _hoisted_1466 = {
  key: 6,
  class: "form-group"
}
const _hoisted_1467 = {
  key: 0,
  class: "required"
}
const _hoisted_1468 = { class: "modal-footer" }
const _hoisted_1469 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_1470 = { class: "modal-wrap default-modal" }
const _hoisted_1471 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendoption",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1472 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_1473 = { class: "modal-content" }
const _hoisted_1474 = { class: "modal-header" }
const _hoisted_1475 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-chevron-left fa-w-10",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-left",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
  })
], -1)
const _hoisted_1476 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "send option")
], -1)
const _hoisted_1477 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1478 = { class: "modal-body" }
const _hoisted_1479 = { class: "form-wrap pt-0" }
const _hoisted_1480 = { class: "form-header p-0" }
const _hoisted_1481 = {
  key: 0,
  class: "heading"
}
const _hoisted_1482 = { class: "heading" }
const _hoisted_1483 = { class: "form-group" }
const _hoisted_1484 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Choose member", -1)
const _hoisted_1485 = { class: "mb-0" }
const _hoisted_1486 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_1487 = { class: "form-group" }
const _hoisted_1488 = /*#__PURE__*/_createVNode("label", { for: "" }, "Additional message", -1)
const _hoisted_1489 = { class: "modal-footer d-block" }
const _hoisted_1490 = { class: "row align-items-end no-gutters" }
const _hoisted_1491 = /*#__PURE__*/_createVNode("div", { class: "col-lg-6" }, null, -1)
const _hoisted_1492 = { class: "col-lg-6" }
const _hoisted_1493 = { class: "col-button" }
const _hoisted_1494 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_1495 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "removecommunication",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1496 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1497 = { class: "modal-content" }
const _hoisted_1498 = { class: "modal-header" }
const _hoisted_1499 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Delete ", -1)
const _hoisted_1500 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1501 = { class: "modal-body" }
const _hoisted_1502 = /*#__PURE__*/_createVNode("p", null, "Message :", -1)
const _hoisted_1503 = { class: "text-primary" }
const _hoisted_1504 = { class: "modal-footer" }
const _hoisted_1505 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_1506 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "removeReplyConverstion",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1507 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1508 = { class: "modal-content" }
const _hoisted_1509 = { class: "modal-header" }
const _hoisted_1510 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Delete Reply Communication ? ", -1)
const _hoisted_1511 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1512 = { class: "modal-body" }
const _hoisted_1513 = /*#__PURE__*/_createVNode("p", null, "Message :", -1)
const _hoisted_1514 = { class: "text-primary" }
const _hoisted_1515 = { class: "modal-footer" }
const _hoisted_1516 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_1517 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "forwardCommunication",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1518 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1519 = { class: "modal-content" }
const _hoisted_1520 = { class: "modal-header" }
const _hoisted_1521 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Forward Message to Group ", -1)
const _hoisted_1522 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1523 = { class: "modal-body" }
const _hoisted_1524 = { class: "editor-wrap" }
const _hoisted_1525 = { class: "mt-3 reply-block" }
const _hoisted_1526 = { class: "iconed-box-wrap" }
const _hoisted_1527 = {
  key: 0,
  class: "small-fig-wrap"
}
const _hoisted_1528 = {
  key: 1,
  class: "chat-desc-wrap"
}
const _hoisted_1529 = {
  key: 0,
  class: "image-in-chat"
}
const _hoisted_1530 = { class: "shadowed-card bg-white" }
const _hoisted_1531 = {
  key: 0,
  class: "image-box"
}
const _hoisted_1532 = { class: "\n                                                  embed-responsive embed-responsive-16by9\n                                                " }
const _hoisted_1533 = /*#__PURE__*/_createVNode("p", { class: "vjs-no-js" }, [
  /*#__PURE__*/_createTextVNode(" To view this video please enable JavaScript, and consider upgrading to a web browser that "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://videojs.com/html5-video-support/",
    target: "_blank"
  }, " supports HTML5 video ")
], -1)
const _hoisted_1534 = { class: "file-name bg-light p-2" }
const _hoisted_1535 = {
  key: 1,
  class: "image-box"
}
const _hoisted_1536 = /*#__PURE__*/_createVNode("div", { class: "image-file-wrap" }, null, -1)
const _hoisted_1537 = { class: "file-name bg-light p-2" }
const _hoisted_1538 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1539 = {
  key: 2,
  class: "image-box"
}
const _hoisted_1540 = { class: "same-ht-img" }
const _hoisted_1541 = { class: "file-name bg-light p-2" }
const _hoisted_1542 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1543 = {
  key: 3,
  class: "image-box"
}
const _hoisted_1544 = { class: "same-ht-img" }
const _hoisted_1545 = { class: "file-name bg-light p-2" }
const _hoisted_1546 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1547 = {
  key: 4,
  class: "image-box"
}
const _hoisted_1548 = { class: "image-wrapp" }
const _hoisted_1549 = { class: "file-name bg-light p-2" }
const _hoisted_1550 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-download" }, null, -1)
const _hoisted_1551 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_1552 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solid fa-share" }, null, -1)
const _hoisted_1553 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_1554 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1555 = {
  key: 5,
  class: "image-box"
}
const _hoisted_1556 = { class: "image-wrapp" }
const _hoisted_1557 = { class: "same-ht-img" }
const _hoisted_1558 = { class: "file-name bg-light p-2" }
const _hoisted_1559 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1560 = {
  key: 6,
  class: "pdf-in-chat border-0 p-0"
}
const _hoisted_1561 = { class: "pdf-wrapp" }
const _hoisted_1562 = { class: "bg-light p-2" }
const _hoisted_1563 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_1564 = { class: "modal-footer" }
const _hoisted_1565 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_1566 = {
  class: "modal fade",
  id: "removependingmember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_1567 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1568 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_1569 = { class: "modal-header border-0" }
const _hoisted_1570 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1571 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_1572 = {
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_1573 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_1574 = /*#__PURE__*/_createTextVNode(" Are you sure ? you want to remove ")
const _hoisted_1575 = { class: "modal-footer" }
const _hoisted_1576 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_1577 = {
  class: "modal fade",
  id: "resendinvitationpendingmember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_1578 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1579 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_1580 = { class: "modal-header" }
const _hoisted_1581 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_1582 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1583 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_1584 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, " Reinviting user will:")
], -1)
const _hoisted_1585 = { class: "block-list" }
const _hoisted_1586 = { class: "modal-footer" }
const _hoisted_1587 = { class: "modal-wrap default-modal" }
const _hoisted_1588 = {
  class: "modal fade",
  id: "renameModal",
  tabindex: "-1",
  "aria-labelledby": "renameModalLabel",
  "aria-hidden": "true"
}
const _hoisted_1589 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_1590 = { class: "modal-content" }
const _hoisted_1591 = { class: "modal-header" }
const _hoisted_1592 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "renameModalLabel"
}, "Rename", -1)
const _hoisted_1593 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1594 = { class: "modal-body" }
const _hoisted_1595 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_1596 = { class: "modal-footer" }
const _hoisted_1597 = { class: "modal-wrap default-modal" }
const _hoisted_1598 = {
  class: "modal fade lg-size",
  id: "viewImageModal",
  tabindex: -1,
  "aria-labelledby": "viewImageModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_1599 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_1600 = { class: "modal-content" }
const _hoisted_1601 = { class: "modal-header" }
const _hoisted_1602 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "viewImageModalLabel"
}, "Image List", -1)
const _hoisted_1603 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1604 = { class: "modal-body" }
const _hoisted_1605 = {
  key: 0,
  class: "image-gallery-wrap"
}
const _hoisted_1606 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_1607 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_1608 = { class: "modal-wrap default-modal" }
const _hoisted_1609 = {
  class: "modal fade lg-size",
  id: "viewReplyImageModal",
  tabindex: -1,
  "aria-labelledby": "viewReplyImageModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_1610 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_1611 = { class: "modal-content" }
const _hoisted_1612 = { class: "modal-header" }
const _hoisted_1613 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "viewReplyImageModalLabel"
}, "Image List", -1)
const _hoisted_1614 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1615 = { class: "modal-body" }
const _hoisted_1616 = { class: "image-gallery-wrap" }
const _hoisted_1617 = { class: "gallery-image" }
const _hoisted_1618 = /*#__PURE__*/_createTextVNode("state.approvedMembersCount ")
const _hoisted_1619 = { class: "modal-wrap default-modal" }
const _hoisted_1620 = {
  class: "modal fade",
  id: "pdfview",
  tabindex: "-1",
  "aria-labelledby": "namerenameLabel",
  "aria-hidden": "true"
}
const _hoisted_1621 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_1622 = { class: "modal-content" }
const _hoisted_1623 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "namerenameLabel"
  }, "View Pdf"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_1624 = { class: "modal-body" }
const _hoisted_1625 = {
  key: 2,
  class: "iframe",
  style: {"height":"800px"}
}
const _hoisted_1626 = {
  key: 0,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_1627 = { class: "modal-wrap default-modal" }
const _hoisted_1628 = {
  class: "modal fade",
  id: "namerename",
  tabindex: "-1",
  "aria-labelledby": "namerenameLabel",
  "aria-hidden": "true"
}
const _hoisted_1629 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_1630 = { class: "modal-content" }
const _hoisted_1631 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "namerenameLabel"
  }, "Rename File"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_1632 = { class: "modal-body" }
const _hoisted_1633 = { class: "form-group mb-0" }
const _hoisted_1634 = { class: "modal-footer" }
const _hoisted_1635 = { class: "modal-wrap default-modal lg-size" }
const _hoisted_1636 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createPrivateChannel",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_1637 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_1638 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_1639 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_1640 = { class: "modal-content" }
const _hoisted_1641 = { class: "modal-header" }
const _hoisted_1642 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Create Private Group "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Create project to collaborate with other members. ")
], -1)
const _hoisted_1643 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1644 = { class: "modal-body" }
const _hoisted_1645 = { class: "form-group pt-0" }
const _hoisted_1646 = { key: 0 }
const _hoisted_1647 = { class: "form-group" }
const _hoisted_1648 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Create Channel With Project Member", -1)
const _hoisted_1649 = { class: "mb-0" }
const _hoisted_1650 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_1651 = { class: "form-group" }
const _hoisted_1652 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Invite with email", -1)
const _hoisted_1653 = { class: "input-btn" }
const _hoisted_1654 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_1655 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_1656 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_1657 = {
  key: 2,
  class: "table-wrap"
}
const _hoisted_1658 = { class: "table table-bordered table-shadowed my-3 font-12" }
const _hoisted_1659 = /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "Email"),
    /*#__PURE__*/_createVNode("td", null, "Mobile Number"),
    /*#__PURE__*/_createVNode("td", null, "First Name"),
    /*#__PURE__*/_createVNode("td", null, "Last Name"),
    /*#__PURE__*/_createVNode("td", null, "Action")
  ])
], -1)
const _hoisted_1660 = { class: "form-group mb-0" }
const _hoisted_1661 = { class: "form-group" }
const _hoisted_1662 = { class: "input-group" }
const _hoisted_1663 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_1664 = { class: "form-group mb-0" }
const _hoisted_1665 = { class: "form-group mb-0" }
const _hoisted_1666 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_1667 = { class: "modal-footer" }
const _hoisted_1668 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_1669 = {
  class: "modal fade",
  id: "modifyChannelHistoryBymember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_1670 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_1671 = { class: "modal-content" }
const _hoisted_1672 = { class: "modal-header border-0" }
const _hoisted_1673 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_1674 = { class: "modal-body" }
const _hoisted_1675 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Include Conversation History ?", -1)
const _hoisted_1676 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Choose whether the listed user can see past messages and files once they're added to the conversation. ", -1)
const _hoisted_1677 = { class: "form-group mt-3" }
const _hoisted_1678 = /*#__PURE__*/_createTextVNode(" From Invitation Accepted ")
const _hoisted_1679 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_1680 = /*#__PURE__*/_createTextVNode(" From Today ")
const _hoisted_1681 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_1682 = /*#__PURE__*/_createTextVNode(" From The Beginning ")
const _hoisted_1683 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_1684 = /*#__PURE__*/_createTextVNode(" Custom ")
const _hoisted_1685 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_1686 = {
  key: 0,
  class: "row"
}
const _hoisted_1687 = { class: "col-md-3" }
const _hoisted_1688 = { class: "form-group" }
const _hoisted_1689 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Editor = _resolveComponent("Editor")
  const _component_ChannelChatWelcomeMessage = _resolveComponent("ChannelChatWelcomeMessage")
  const _component_MyDriveFilesUpload = _resolveComponent("MyDriveFilesUpload")
  const _component_Slide = _resolveComponent("Slide")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Carousel = _resolveComponent("Carousel")
  const _component_MemberCard = _resolveComponent("MemberCard")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_v_pagination = _resolveComponent("v-pagination")
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_DigitalSignature = _resolveComponent("DigitalSignature")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")
  const _component_DocusignDocumentListModel = _resolveComponent("DocusignDocumentListModel")
  const _component_showShareDocusignDocumentModel = _resolveComponent("showShareDocusignDocumentModel")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_AdminDetailModel = _resolveComponent("AdminDetailModel")
  const _component_ChatChannelAppMessageReceiver = _resolveComponent("ChatChannelAppMessageReceiver")
  const _component_ChannelChatMembers = _resolveComponent("ChannelChatMembers")
  const _component_ChatChannelAppInviteMember = _resolveComponent("ChatChannelAppInviteMember")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state.ui.showLoader)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (!_ctx.state.ui.isLoading.docuSignIframe && !_ctx.state.ui.isLoading.docuSignIframeOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_ctx.state.ui.isLoading.communicationList &&
      _ctx.state.ui.isPostLoading.getCommunicationList &&
      !_ctx.state.ui.isLoading.communicationListAPICall && !_ctx.state.ui.isLoading.loaded
    )
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _hoisted_5
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.goToAttachmentRow)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: _ctx.state.data.replyClassStatus
      ? 'chat-wrapper clearfix active'
      : 'chat-wrapper'
      
          }, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.item.error.erorList,
                hasError: _ctx.state.item.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    (_ctx.state.channel.project)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          (_ctx.state.data.userType != 'public_user')
                            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                _createVNode(_component_router_link, {
                                  class: "absolute-link",
                                  to: {
                    name: 'admin-project-details',
                    params: { projectId: _ctx.state.projectId },
                  }
                                }, null, 8, ["to"]),
                                _hoisted_14,
                                _createVNode("p", null, [
                                  _hoisted_15,
                                  _createTextVNode(" " + _toDisplayString(_ctx.state.channel.project.name), 1)
                                ])
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_16, [
                                _hoisted_17,
                                _hoisted_18,
                                _createVNode("p", null, [
                                  _hoisted_19,
                                  _createTextVNode(" " + _toDisplayString(_ctx.state.channel.project.name), 1)
                                ])
                              ])),
                          _createVNode("div", _hoisted_20, [
                            _createVNode("ul", null, [
                              (_ctx.state.channel)
                                ? (_openBlock(), _createBlock("li", _hoisted_21, [
                                    _createVNode("h3", {
                                      onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFullText = true)),
                                      onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFullText = false))
                                    }, [
                                      _hoisted_22,
                                      _createTextVNode(" " + _toDisplayString(_ctx.showFullText ? _ctx.state.channel.name : _ctx.truncate(_ctx.state.channel.name, 30)), 1)
                                    ], 32)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("li", null, [
                                _createVNode("small", _hoisted_23, [
                                  _hoisted_24,
                                  _hoisted_25,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatToMMDDYYYY_HHMMSS(_ctx.state.channel.created_date)), 1)
                                ])
                              ]),
                              (_ctx.state.data.approvalDiscussionInvitationId)
                                ? (_openBlock(), _createBlock("li", _hoisted_26, [
                                    _createVNode(_component_router_link, {
                                      to: {
                        name: 'user-project-acknowledgement',
                        params: { invitationId: _ctx.state.data.approvalDiscussionInvitationId },
                      }
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_27
                                      ]),
                                      _: 1
                                    }, 8, ["to"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _createVNode("div", null, [
                          (_ctx.state.memberList && _ctx.state.memberList.length)
                            ? (_openBlock(), _createBlock("span", _hoisted_31, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.memberList.slice(
                        0,
                        3
                      ), (member, memberIndex) => {
                                  return (_openBlock(), _createBlock("a", {
                                    href: "javascript:void(0)",
                                    key: memberIndex
                                  }, [
                                    _createVNode("span", {
                                      class: member.user.online_status === 'online'
                          ? 'status-icon'
                          : 'status-icon gray-icon'
                          
                                    }, null, 2),
                                    (member.user.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          src: member.user.image,
                                          alt: member.full_name,
                                          title: member.user.email
                                        }, null, 8, ["src", "alt", "title"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg'
                          ,
                                          alt: "",
                                          title: member.user.email
                                        }, null, 8, ["src", "title"]))
                                  ]))
                                }), 128)),
                                (_ctx.state.memberList && _ctx.state.memberList.length > 3)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 0,
                                      href: "javascript:void(0)",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showChannelMembers(_ctx.state.memberList)))
                                    }, [
                                      _createVNode("span", _hoisted_32, "+" + _toDisplayString(_ctx.state.memberList.length - 3), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("a", {
                            class: "ml-3 mr-1",
                            href: "javascript:void(0)",
                            id: "menu-toggle",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.detailsModal && _ctx.detailsModal(...args))),
                            title: "See Details"
                          }, [
                            _hoisted_33
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.state.totalSearchResult)
                ? (_openBlock(), _createBlock("div", _hoisted_34, _toDisplayString(_ctx.state.totalSearchResultCount) + " results", 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.searchAllMessage && _ctx.searchAllMessage(...args)))
                  }, [
                    _hoisted_37
                  ])
                ]),
                (_ctx.state.data.clearBtn)
                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchClearMessage()))
                      }, [
                        _hoisted_39
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control bg-light",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.search = $event)),
                  placeholder: "Press enter to search",
                  onKeyDown: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchAllMessage && _ctx.searchAllMessage(...args)), ["enter"])),
                  onKeyup: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchAllMessage && _ctx.searchAllMessage(...args)), ["delete"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.data.search]
                ])
              ]),
              (_ctx.state.ui.isPostLoading.loadLatestMessages)
                ? (_openBlock(), _createBlock("div", _hoisted_40, [
                    _hoisted_41
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.unreadMessage > 0 && !_ctx.state.ui.isPostLoading.loadLatestMessages)
                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.scrollToLast && _ctx.scrollToLast(...args)))
                    }, [
                      _createVNode("span", null, _toDisplayString(_ctx.state.data.unreadMessage) + " New Message", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_43, [
                _createVNode("div", {
                  class: ["chat-body", { 'active-dropzone': _ctx.state.data.active }],
                  id: "chat-body-content",
                  onScrollPassive: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                  onDrop: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.onDocumentChange($event)), ["prevent"])),
                  onDragover: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.dragOverHandler($event)), ["prevent"])),
                  onDragenter: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"])),
                  onDragleave: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"])),
                  ref: "scrollContainerRef"
                }, [
                  (_ctx.state.ui.isPostLoading.getCommunicationList && !_ctx.state.ui.isLoading.loaded)
                    ? (_openBlock(), _createBlock("div", _hoisted_44, [
                        (_ctx.state.ui.isPostLoading.getCommunicationList && !_ctx.state.ui.isLoading.loaded)
                          ? (_openBlock(), _createBlock("div", _hoisted_45, [
                              _hoisted_46,
                              _hoisted_47,
                              _hoisted_48,
                              _hoisted_49
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_50,
                  (_ctx.state.communicationList && _ctx.state.communicationList.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_51, [
                        _createVNode("ul", _hoisted_52, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.communicationList, (communication, communicationIndex) => {
                            return (_openBlock(), _createBlock("li", {
                              class: "message",
                              key: communicationIndex,
                              id: `${communication.id}`
                            }, [
                              _createVNode("div", {
                                class: (communication.message_status === 0 && communication.user.email != _ctx.state.activeUserDetails.email) || (communication.message_status === 1 && communication.user.email != _ctx.state.activeUserDetails.email) ? 'chat-block-unread' : ''
                              }, [
                                _createVNode("div", {
                                  class: communication.active ||
                      _ctx.state.data.isCommunicationFile == communication.id
                      ? 'chat-block active'
                      : 'chat-block'
                      ,
                                  id: communication.id
                                }, [
                                  communication
                                    ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                        (communication.user)
                                          ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                              (communication.user.image)
                                                ? (_openBlock(), _createBlock("img", {
                                                    key: 0,
                                                    src: communication.user.image,
                                                    alt: ""
                                                  }, null, 8, ["src"]))
                                                : (_openBlock(), _createBlock("img", {
                                                    key: 1,
                                                    src: _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                            : 'img/no-user.jpg'
                            ,
                                                    alt: ""
                                                  }, null, 8, ["src"]))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (communication.user)
                                          ? (_openBlock(), _createBlock("h5", _hoisted_55, [
                                              _createTextVNode(_toDisplayString(communication.user.full_name || communication.user.email ||
                          communication.user.mobile_number) + " ", 1),
                                              _createVNode("span", null, _toDisplayString(communication.currentTime), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (communication.allowEdit)
                                          ? (_openBlock(), _createBlock("div", _hoisted_56, [
                                              _createVNode("div", _hoisted_57, [
                                                _createVNode(_component_Editor, {
                                                  showEnterSetting: false,
                                                  onEnterSetting: _ctx.enterSetting,
                                                  onEnterKeyPressed: _ctx.editChatCommunicationEnterSetting,
                                                  modelValue: communication.message,
                                                  "onUpdate:modelValue": ($event: any) => (communication.message = $event)
                                                }, null, 8, ["onEnterSetting", "onEnterKeyPressed", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createVNode("div", _hoisted_58, [
                                                (!_ctx.enableEnterKey)
                                                  ? (_openBlock(), _createBlock("p", _hoisted_59, [
                                                      _hoisted_60
                                                    ]))
                                                  : (_openBlock(), _createBlock("p", _hoisted_61, [
                                                      _hoisted_62
                                                    ]))
                                              ]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "btn default-btn mr-2",
                                                onClick: _withModifiers(($event: any) => (
                            _ctx.sendEditedCommunication(communication)
                            ), ["prevent"])
                                              }, "Send ", 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "btn secondary-btn",
                                                onClick: ($event: any) => (_ctx.cancelSelectedEdit(communication))
                                              }, "Cancel", 8, ["onClick"])
                                            ]))
                                          : (_openBlock(), _createBlock("div", _hoisted_63, [
                                              _createVNode("div", null, [
                                                (communication.deleted_at)
                                                  ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                                      _createVNode("div", _hoisted_65, [
                                                        _createVNode("p", null, [
                                                          _hoisted_66,
                                                          _createVNode("small", _hoisted_67, " (deleted at: " + _toDisplayString(communication.deletedLocalTime) + ")", 1)
                                                        ])
                                                      ])
                                                    ]))
                                                  : (communication.is_edited === 0)
                                                    ? (_openBlock(), _createBlock("div", _hoisted_68, [
                                                        _createVNode("div", _hoisted_69, [
                                                          (communication.message)
                                                            ? (_openBlock(), _createBlock("p", {
                                                                key: 0,
                                                                class: "mr-2",
                                                                innerHTML: `${communication.message}`
                                                              }, null, 8, ["innerHTML"]))
                                                            : _createCommentVNode("", true),
                                                          (communication.communicationEstimation)
                                                            ? (_openBlock(), _createBlock("div", _hoisted_70, [
                                                                _createVNode("a", {
                                                                  href: "javascript:void(0)",
                                                                  class: "green-text",
                                                                  onClick: ($event: any) => (_ctx.viewDetailsFromChat(communication.communicationEstimation))
                                                                }, " View Estimate", 8, ["onClick"])
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        (communication.forward)
                                                          ? (_openBlock(), _createBlock("div", _hoisted_71, [
                                                              _createVNode("div", _hoisted_72, [
                                                                (communication.forward.communication.user)
                                                                  ? (_openBlock(), _createBlock("div", _hoisted_73, [
                                                                      _createVNode("img", {
                                                                        src: communication.forward.communication.user.image,
                                                                        title: communication.forward.communication.user.full_name,
                                                                        alt: ""
                                                                      }, null, 8, ["src", "title"])
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (communication.forward.communication.user)
                                                                  ? (_openBlock(), _createBlock("div", _hoisted_74, [
                                                                      _createVNode("p", null, [
                                                                        _createVNode("strong", null, _toDisplayString(communication.forward.communication.user.full_name), 1)
                                                                      ]),
                                                                      (communication.forward.communication.responses_count > 0)
                                                                        ? (_openBlock(), _createBlock("p", _hoisted_75, [
                                                                            _createVNode("small", null, [
                                                                              _createVNode("a", {
                                                                                href: "javascript:void(0)",
                                                                                onClick: _withModifiers(($event: any) => (_ctx.replyCommunication(communication.forward.communication)), ["prevent"])
                                                                              }, [
                                                                                _createVNode("strong", _hoisted_76, _toDisplayString(communication.forward.communication.responses_count) + " Reply", 1)
                                                                              ], 8, ["onClick"])
                                                                            ]),
                                                                            _hoisted_77,
                                                                            _createVNode("span", _hoisted_78, _toDisplayString(communication.forward.communication.responses[
                                        communication.forward.communication.responses.length - 1
                                        ].createdLatest), 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              (communication.forward.communication.message != null)
                                                                ? (_openBlock(), _createBlock("p", _hoisted_79, [
                                                                    _createVNode("small", {
                                                                      innerHTML: `${communication.forward.communication.message}`
                                                                    }, null, 8, ["innerHTML"])
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (communication.forward.communication.is_edited === 1)
                                                                ? (_openBlock(), _createBlock("small", _hoisted_80, " (edited @ " + _toDisplayString(communication.forward.communication.editedUpdated) + ")", 1))
                                                                : _createCommentVNode("", true),
                                                              (communication.forward.attachments &&
                                  communication.forward.attachments.length
                                )
                                                                ? (_openBlock(), _createBlock("div", _hoisted_81, [
                                                                    _createVNode("ul", null, [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.forward.attachments, (image, imageIndex) => {
                                                                        return (_openBlock(), _createBlock("li", { key: imageIndex }, [
                                                                          (image.status &&
                                        image.status.code === 'deleted' &&
                                        image.status.name === 'Deleted'
                                      )
                                                                            ? (_openBlock(), _createBlock("div", _hoisted_82, [
                                                                                _createVNode("img", {
                                                                                  src: _ctx.state.data.imageBaseUrl
                                          ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                                          : 'img/deletedimage.jpg'
                                          ,
                                                                                  alt: ""
                                                                                }, null, 8, ["src"]),
                                                                                _createVNode("div", _hoisted_83, [
                                                                                  _createVNode("p", null, [
                                                                                    _createVNode("strong", null, _toDisplayString(image.file_name), 1),
                                                                                    _hoisted_84,
                                                                                    _hoisted_85
                                                                                  ]),
                                                                                  _createVNode("p", null, [
                                                                                    _hoisted_86,
                                                                                    _createVNode("strong", null, _toDisplayString(image.deleted_at), 1)
                                                                                  ])
                                                                                ])
                                                                              ]))
                                                                            : (_openBlock(), _createBlock("div", _hoisted_87, [
                                                                                (image.file_type === 'mp4' ||
                                          image.file_type === 'mov' ||
                                          image.file_type === 'wmv' ||
                                          image.file_type === 'webm' ||
                                          image.file_type === 'ogg' ||
                                          image.file_type === 'avi' ||
                                          image.file_type === 'x-ms-wmv'
                                        )
                                                                                  ? (_openBlock(), _createBlock("div", _hoisted_88, [
                                                                                      _createVNode("div", _hoisted_89, [
                                                                                        _createVNode("video", {
                                                                                          id: `my-player${imageIndex}`,
                                                                                          class: "video-js",
                                                                                          controls: "",
                                                                                          preload: "auto",
                                                                                          poster: "img/convorally-logo.png",
                                                                                          "data-setup": "{}"
                                                                                        }, [
                                                                                          _createVNode("source", {
                                                                                            src: image.file_link,
                                                                                            type: `video/${image.file_type}`
                                                                                          }, null, 8, ["src", "type"]),
                                                                                          _hoisted_90
                                                                                        ], 8, ["id"])
                                                                                      ]),
                                                                                      _createVNode("div", _hoisted_91, [
                                                                                        _createVNode("p", {
                                                                                          class: "font-weight-bold",
                                                                                          innerHTML: `${image.file_name}`
                                                                                        }, null, 8, ["innerHTML"]),
                                                                                        _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                      ])
                                                                                    ]))
                                                                                  : (image.file_type === 'doc' ||
                                          image.file_type === 'docx'
                                        )
                                                                                    ? (_openBlock(), _createBlock("div", _hoisted_92, [
                                                                                        _hoisted_93,
                                                                                        _createVNode("div", _hoisted_94, [
                                                                                          _createVNode("p", {
                                                                                            class: "font-weight-bold",
                                                                                            onClick: _withModifiers(($event: any) => (
                                              _ctx.downloadFile(image.file_link)
                                              ), ["prevent"]),
                                                                                            innerHTML: `${image.file_name}`
                                                                                          }, null, 8, ["onClick", "innerHTML"]),
                                                                                          _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                        ])
                                                                                      ]))
                                                                                    : (image.file_type === 'xls' ||
                                          image.file_type === 'xlsx' ||
                                          image.file_type === 'xlsm' ||
                                          image.file_type === 'xlsb' ||
                                          image.file_type === 'xltx')
                                                                                      ? (_openBlock(), _createBlock("div", _hoisted_95, [
                                                                                          _createVNode("div", {
                                                                                            class: "image-wrapp",
                                                                                            onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                                                                          }, [
                                                                                            _createVNode("div", _hoisted_96, [
                                                                                              _createVNode("img", {
                                                                                                src: `${_ctx.state.data.imageBaseUrl}img/excel.png`,
                                                                                                alt: "",
                                                                                                height: "150",
                                                                                                width: "180"
                                                                                              }, null, 8, ["src"])
                                                                                            ]),
                                                                                            _createVNode("div", _hoisted_97, [
                                                                                              _createVNode("p", {
                                                                                                class: "font-weight-bold",
                                                                                                innerHTML: `${image.file_name}`
                                                                                              }, null, 8, ["innerHTML"]),
                                                                                              _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                            ])
                                                                                          ], 8, ["onClick"])
                                                                                        ]))
                                                                                      : (image.file_type === 'ppt' ||
                                          image.file_type === 'pptm' ||
                                          image.file_type === 'pptx'
                                        )
                                                                                        ? (_openBlock(), _createBlock("div", _hoisted_98, [
                                                                                            _createVNode("div", {
                                                                                              class: "image-wrapp",
                                                                                              onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                                                                            }, [
                                                                                              _createVNode("div", _hoisted_99, [
                                                                                                _createVNode("img", {
                                                                                                  src: `${_ctx.state.data.imageBaseUrl}img/ppt.png`,
                                                                                                  alt: "",
                                                                                                  height: "150",
                                                                                                  width: "180"
                                                                                                }, null, 8, ["src"])
                                                                                              ]),
                                                                                              _createVNode("div", _hoisted_100, [
                                                                                                _createVNode("p", {
                                                                                                  class: "font-weight-bold",
                                                                                                  innerHTML: `${image.file_name}`
                                                                                                }, null, 8, ["innerHTML"]),
                                                                                                _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                              ])
                                                                                            ], 8, ["onClick"])
                                                                                          ]))
                                                                                        : (image.file_type === 'zip' || image.file_type === 'rar' || image.file_type === 'tar')
                                                                                          ? (_openBlock(), _createBlock("div", _hoisted_101, [
                                                                                              _createVNode("div", _hoisted_102, [
                                                                                                _createVNode("div", {
                                                                                                  class: "same-ht-img",
                                                                                                  onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                                                                }, [
                                                                                                  _createVNode("img", {
                                                                                                    src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/file.jpg` : 'img/file.jpg',
                                                                                                    alt: ""
                                                                                                  }, null, 8, ["src"])
                                                                                                ], 8, ["onClick"]),
                                                                                                _createVNode("div", _hoisted_103, [
                                                                                                  _createVNode("p", {
                                                                                                    class: "font-weight-bold",
                                                                                                    innerHTML: `${image.file_name}`
                                                                                                  }, null, 8, ["innerHTML"]),
                                                                                                  _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1),
                                                                                                  _createVNode("a", {
                                                                                                    href: "javascript:void(0)",
                                                                                                    class: "btn default-btn d-block mt-1 btn-sm",
                                                                                                    onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                                                                  }, [
                                                                                                    _hoisted_104,
                                                                                                    _hoisted_105
                                                                                                  ], 8, ["onClick"])
                                                                                                ])
                                                                                              ]),
                                                                                              (_ctx.channelStatus)
                                                                                                ? (_openBlock(), _createBlock("a", {
                                                                                                    key: 0,
                                                                                                    title: "Forward",
                                                                                                    onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                                                    class: "remove-image share-icon"
                                                                                                  }, [
                                                                                                    _hoisted_106
                                                                                                  ], 8, ["onClick"]))
                                                                                                : _createCommentVNode("", true),
                                                                                              (communication.editStatus && _ctx.channelStatus)
                                                                                                ? (_openBlock(), _createBlock("a", {
                                                                                                    key: 1,
                                                                                                    title: "Rename",
                                                                                                    onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                                                    class: "remove-image edit-icon"
                                                                                                  }, [
                                                                                                    _hoisted_107
                                                                                                  ], 8, ["onClick"]))
                                                                                                : _createCommentVNode("", true),
                                                                                              (communication.editStatus && _ctx.channelStatus)
                                                                                                ? (_openBlock(), _createBlock("a", {
                                                                                                    key: 2,
                                                                                                    href: "javascript:void(0)",
                                                                                                    class: "remove-image",
                                                                                                    onClick: _withModifiers(($event: any) => (
                                              _ctx.selectedCommunicationImageToDelete(
                                                communication,
                                                image
                                              )
                                              ), ["prevent"])
                                                                                                  }, [
                                                                                                    _hoisted_108
                                                                                                  ], 8, ["onClick"]))
                                                                                                : _createCommentVNode("", true)
                                                                                            ]))
                                                                                          : (image.file_type != 'pdf')
                                                                                            ? (_openBlock(), _createBlock("div", _hoisted_109, [
                                                                                                _createVNode("div", {
                                                                                                  class: "image-wrapp",
                                                                                                  onClick: ($event: any) => (_ctx.clickImage(communication.forward.attachments, imageIndex))
                                                                                                }, [
                                                                                                  _createVNode("div", _hoisted_110, [
                                                                                                    _createVNode("img", {
                                                                                                      src: image.file_link,
                                                                                                      alt: "",
                                                                                                      height: "150",
                                                                                                      width: "180"
                                                                                                    }, null, 8, ["src"])
                                                                                                  ]),
                                                                                                  _createVNode("div", _hoisted_111, [
                                                                                                    _createVNode("p", {
                                                                                                      class: "font-weight-bold",
                                                                                                      innerHTML: `${image.file_name}`
                                                                                                    }, null, 8, ["innerHTML"]),
                                                                                                    _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                                  ])
                                                                                                ], 8, ["onClick"])
                                                                                              ]))
                                                                                            : (_openBlock(), _createBlock("div", _hoisted_112, [
                                                                                                _createVNode("div", {
                                                                                                  onClick: ($event: any) => (_ctx.viewPdf(image.file_link))
                                                                                                }, [
                                                                                                  _createVNode("div", _hoisted_113, [
                                                                                                    _createVNode("embed", {
                                                                                                      src: image.file_link,
                                                                                                      frameBorder: "0",
                                                                                                      scrolling: "auto",
                                                                                                      height: "100%",
                                                                                                      width: "100%"
                                                                                                    }, null, 8, ["src"])
                                                                                                  ]),
                                                                                                  _createVNode("div", _hoisted_114, [
                                                                                                    _createVNode("p", {
                                                                                                      class: "font-weight-bold",
                                                                                                      innerHTML: `${image.file_name}`
                                                                                                    }, null, 8, ["innerHTML"]),
                                                                                                    _createVNode("p", _hoisted_115, _toDisplayString(image.convertedFileSize), 1),
                                                                                                    (communication.user)
                                                                                                      ? (_openBlock(), _createBlock("p", _hoisted_116, " Sent by : " + _toDisplayString(communication.user.full_name), 1))
                                                                                                      : _createCommentVNode("", true)
                                                                                                  ])
                                                                                                ], 8, ["onClick"])
                                                                                              ]))
                                                                              ]))
                                                                        ]))
                                                                      }), 128))
                                                                    ])
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (communication.forward.communication.share_history &&
                                  communication.forward.communication.share_history.length
                                )
                                                                ? (_openBlock(), _createBlock("div", _hoisted_117, [
                                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.forward.communication.share_history, (sharedDocument, sharedIndex) => {
                                                                      return (_openBlock(), _createBlock("div", { key: sharedIndex }, [
                                                                        (sharedDocument.documents &&
                                      sharedDocument.documents.length
                                    )
                                                                          ? (_openBlock(), _createBlock("div", _hoisted_118, [
                                                                              _createVNode("ul", null, [
                                                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(sharedDocument.documents, (document, documentIndex) => {
                                                                                  return (_openBlock(), _createBlock("li", { key: documentIndex }, [
                                                                                    _createVNode("div", _hoisted_119, [
                                                                                      (document.deleted_at)
                                                                                        ? (_openBlock(), _createBlock("div", _hoisted_120, [
                                                                                            _createVNode("img", {
                                                                                              src: _ctx.state.data.imageBaseUrl
                                                ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                                                : 'img/deletedimage.jpg'
                                                ,
                                                                                              alt: ""
                                                                                            }, null, 8, ["src"]),
                                                                                            _createVNode("div", _hoisted_121, [
                                                                                              _createVNode("p", null, [
                                                                                                _createVNode("strong", null, _toDisplayString(document.filename), 1),
                                                                                                _hoisted_122,
                                                                                                _hoisted_123
                                                                                              ]),
                                                                                              _createVNode("p", null, [
                                                                                                _hoisted_124,
                                                                                                _createVNode("strong", null, _toDisplayString(document.deleted_at), 1)
                                                                                              ])
                                                                                            ])
                                                                                          ]))
                                                                                        : (document.file.filetype === 'mp4' ||
                                              document.file.filetype === 'mov' ||
                                              document.file.filetype === 'MOV' ||
                                              document.file.filetype === 'wmv' ||
                                              document.file.filetype === 'webm' ||
                                              document.file.filetype === 'ogg' ||
                                              document.file.filetype === 'avi' ||
                                              document.file.filetype === 'x-ms-wmv'
                                            )
                                                                                          ? (_openBlock(), _createBlock("div", _hoisted_125, [
                                                                                              _createVNode("div", _hoisted_126, [
                                                                                                _createVNode("video", {
                                                                                                  id: `my-player${documentIndex}`,
                                                                                                  class: "video-js",
                                                                                                  controls: "",
                                                                                                  preload: "auto",
                                                                                                  poster: "img/convorally-logo.png",
                                                                                                  "data-setup": "{}"
                                                                                                }, [
                                                                                                  _createVNode("source", {
                                                                                                    src: document.file.file_url,
                                                                                                    type: `video/${document.file.filetype}`
                                                                                                  }, null, 8, ["src", "type"]),
                                                                                                  _hoisted_127
                                                                                                ], 8, ["id"])
                                                                                              ]),
                                                                                              (document.file)
                                                                                                ? (_openBlock(), _createBlock("div", _hoisted_128, [
                                                                                                    _createVNode("p", {
                                                                                                      class: "font-weight-bold",
                                                                                                      innerHTML: `${document.filename}`
                                                                                                    }, null, 8, ["innerHTML"]),
                                                                                                    _createVNode("p", _hoisted_129, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1)
                                                                                                  ]))
                                                                                                : _createCommentVNode("", true)
                                                                                            ]))
                                                                                          : (document.file.filetype === 'doc' ||
                                              document.file.filetype === 'docx'
                                            )
                                                                                            ? (_openBlock(), _createBlock("div", _hoisted_130, [
                                                                                                _hoisted_131,
                                                                                                _createVNode("div", _hoisted_132, [
                                                                                                  _createVNode("h5", {
                                                                                                    onClick: _withModifiers(($event: any) => (
                                                  _ctx.downloadFile(document.file.file_url)
                                                  ), ["prevent"])
                                                                                                  }, _toDisplayString(document.filename), 9, ["onClick"]),
                                                                                                  (document.file)
                                                                                                    ? (_openBlock(), _createBlock("p", _hoisted_133, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1))
                                                                                                    : _createCommentVNode("", true)
                                                                                                ])
                                                                                              ]))
                                                                                            : (document.file.filetype === 'xlsx' ||
                                              document.file.filetype === 'xls' ||
                                              document.file.filetype === 'xlsm' ||
                                              document.file.filetype === 'xlsb' ||
                                              document.file.filetype === 'xltx'
                                            )
                                                                                              ? (_openBlock(), _createBlock("div", _hoisted_134, [
                                                                                                  _createVNode("div", _hoisted_135, [
                                                                                                    _createVNode("div", _hoisted_136, [
                                                                                                      _createVNode("div", _hoisted_137, [
                                                                                                        _createVNode("img", {
                                                                                                          src: `${_ctx.state.data.imageBaseUrl}img/excel.png`,
                                                                                                          alt: "",
                                                                                                          height: "150",
                                                                                                          width: "180"
                                                                                                        }, null, 8, ["src"])
                                                                                                      ])
                                                                                                    ])
                                                                                                  ]),
                                                                                                  _createVNode("div", _hoisted_138, [
                                                                                                    _createVNode("h5", {
                                                                                                      onClick: _withModifiers(($event: any) => (
                                                  _ctx.downloadFile(document.file.file_url)
                                                  ), ["prevent"])
                                                                                                    }, [
                                                                                                      _createVNode("p", {
                                                                                                        class: "font-weight-bold",
                                                                                                        innerHTML: `${document.filename}`
                                                                                                      }, null, 8, ["innerHTML"])
                                                                                                    ], 8, ["onClick"]),
                                                                                                    (document.file)
                                                                                                      ? (_openBlock(), _createBlock("p", _hoisted_139, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1))
                                                                                                      : _createCommentVNode("", true)
                                                                                                  ])
                                                                                                ]))
                                                                                              : (document.file.filetype === 'ppt' ||
                                              document.file.filetype === 'pptm' ||
                                              document.file.filetype === 'pptx'
                                            )
                                                                                                ? (_openBlock(), _createBlock("div", _hoisted_140, [
                                                                                                    _createVNode("div", _hoisted_141, [
                                                                                                      _createVNode("div", _hoisted_142, [
                                                                                                        _createVNode("div", _hoisted_143, [
                                                                                                          _createVNode("img", {
                                                                                                            src: `${_ctx.state.data.imageBaseUrl}img/ppt.png`,
                                                                                                            alt: "",
                                                                                                            height: "150",
                                                                                                            width: "180"
                                                                                                          }, null, 8, ["src"])
                                                                                                        ])
                                                                                                      ])
                                                                                                    ]),
                                                                                                    _createVNode("div", _hoisted_144, [
                                                                                                      _createVNode("h5", {
                                                                                                        onClick: _withModifiers(($event: any) => (
                                                  _ctx.downloadFile(document.file.file_url)
                                                  ), ["prevent"])
                                                                                                      }, _toDisplayString(document.filename), 9, ["onClick"]),
                                                                                                      (document.file)
                                                                                                        ? (_openBlock(), _createBlock("p", _hoisted_145, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1))
                                                                                                        : _createCommentVNode("", true)
                                                                                                    ])
                                                                                                  ]))
                                                                                                : (document.file.filetype === 'jpg' ||
                                              document.file.filetype === 'jpeg' ||
                                              document.file.filetype === 'png'
                                            )
                                                                                                  ? (_openBlock(), _createBlock("div", _hoisted_146, [
                                                                                                      _createVNode("img", {
                                                                                                        src: document.file.file_url,
                                                                                                        alt: "",
                                                                                                        height: "150",
                                                                                                        width: "180",
                                                                                                        onClick: _withModifiers(($event: any) => (
                                                  _ctx.downloadFile(document.file.file_url)
                                                  ), ["prevent"])
                                                                                                      }, null, 8, ["src", "onClick"]),
                                                                                                      (document.file)
                                                                                                        ? (_openBlock(), _createBlock("div", _hoisted_147, [
                                                                                                            _createVNode("p", {
                                                                                                              class: "font-weight-bold",
                                                                                                              innerHTML: `${document.filename}`
                                                                                                            }, null, 8, ["innerHTML"]),
                                                                                                            _createVNode("p", _hoisted_148, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1)
                                                                                                          ]))
                                                                                                        : _createCommentVNode("", true),
                                                                                                      _hoisted_149,
                                                                                                      _hoisted_150
                                                                                                    ]))
                                                                                                  : (_openBlock(), _createBlock("div", _hoisted_151, [
                                                                                                      _createVNode("div", {
                                                                                                        onClick: ($event: any) => (_ctx.viewPdf(document.file.file_url))
                                                                                                      }, [
                                                                                                        _createVNode("div", _hoisted_152, [
                                                                                                          _createVNode("embed", {
                                                                                                            src: document.file.file_url,
                                                                                                            frameBorder: "0",
                                                                                                            scrolling: "auto",
                                                                                                            height: "100%",
                                                                                                            width: "100%"
                                                                                                          }, null, 8, ["src"])
                                                                                                        ]),
                                                                                                        _createVNode("div", _hoisted_153, [
                                                                                                          (document.file)
                                                                                                            ? (_openBlock(), _createBlock("h5", _hoisted_154, [
                                                                                                                _createVNode("p", {
                                                                                                                  class: "font-weight-bold",
                                                                                                                  innerHTML: `${document.filename}`
                                                                                                                }, null, 8, ["innerHTML"])
                                                                                                              ]))
                                                                                                            : _createCommentVNode("", true),
                                                                                                          (document.file)
                                                                                                            ? (_openBlock(), _createBlock("p", _hoisted_155, _toDisplayString(document.file.convertedFileSize), 1))
                                                                                                            : _createCommentVNode("", true),
                                                                                                          (document.user)
                                                                                                            ? (_openBlock(), _createBlock("p", _hoisted_156, " Sent by : " + _toDisplayString(document.user.full_name), 1))
                                                                                                            : _createCommentVNode("", true)
                                                                                                        ])
                                                                                                      ], 8, ["onClick"])
                                                                                                    ]))
                                                                                    ])
                                                                                  ]))
                                                                                }), 128))
                                                                              ])
                                                                            ]))
                                                                          : _createCommentVNode("", true)
                                                                      ]))
                                                                    }), 128))
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createBlock("div", _hoisted_157, [
                                                        _createVNode("div", _hoisted_158, [
                                                          (communication.message)
                                                            ? (_openBlock(), _createBlock("p", {
                                                                key: 0,
                                                                class: "mr-2",
                                                                innerHTML: `${communication.message}`
                                                              }, null, 8, ["innerHTML"]))
                                                            : _createCommentVNode("", true),
                                                          (communication.communicationEstimation)
                                                            ? (_openBlock(), _createBlock("div", _hoisted_159, [
                                                                _createVNode("a", {
                                                                  href: "javascript:void(0)",
                                                                  class: "green-text",
                                                                  onClick: ($event: any) => (_ctx.viewDetailsFromChat(communication.communicationEstimation))
                                                                }, " View Estimate", 8, ["onClick"])
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _createVNode("small", _hoisted_160, " (edited @ " + _toDisplayString(communication.editedUpdated) + ")", 1),
                                                        (communication.forward)
                                                          ? (_openBlock(), _createBlock("div", _hoisted_161, [
                                                              _createVNode("div", _hoisted_162, [
                                                                (communication.forward.communication.user)
                                                                  ? (_openBlock(), _createBlock("div", _hoisted_163, [
                                                                      _createVNode("img", {
                                                                        src: communication.forward.communication.user.image,
                                                                        title: communication.forward.communication.user.full_name,
                                                                        alt: ""
                                                                      }, null, 8, ["src", "title"])
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (communication.forward.communication.user)
                                                                  ? (_openBlock(), _createBlock("div", _hoisted_164, [
                                                                      _createVNode("p", null, [
                                                                        _createVNode("strong", null, _toDisplayString(communication.forward.communication.user.full_name), 1)
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              (communication.forward.communication.message != null)
                                                                ? (_openBlock(), _createBlock("p", _hoisted_165, [
                                                                    _createVNode("small", {
                                                                      innerHTML: `${communication.forward.communication.message}`
                                                                    }, null, 8, ["innerHTML"])
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (communication.forward.communication.is_edited === 1)
                                                                ? (_openBlock(), _createBlock("small", _hoisted_166, " (edited @ " + _toDisplayString(communication.forward.communication.editedUpdated) + ")", 1))
                                                                : _createCommentVNode("", true),
                                                              (communication.forward.attachments &&
                                  communication.forward.attachments.length
                                )
                                                                ? (_openBlock(), _createBlock("div", _hoisted_167, [
                                                                    _createVNode("ul", null, [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.forward.attachments, (image, imageIndex) => {
                                                                        return (_openBlock(), _createBlock("li", { key: imageIndex }, [
                                                                          (image.status &&
                                        image.status.code === 'deleted' &&
                                        image.status.name === 'Deleted'
                                      )
                                                                            ? (_openBlock(), _createBlock("div", _hoisted_168, [
                                                                                _createVNode("img", {
                                                                                  src: _ctx.state.data.imageBaseUrl
                                          ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                                          : 'img/deletedimage.jpg'
                                          ,
                                                                                  alt: ""
                                                                                }, null, 8, ["src"]),
                                                                                _createVNode("div", _hoisted_169, [
                                                                                  _createVNode("p", null, [
                                                                                    _createVNode("strong", null, _toDisplayString(image.file_name), 1),
                                                                                    _hoisted_170,
                                                                                    _hoisted_171
                                                                                  ]),
                                                                                  _createVNode("p", null, [
                                                                                    _hoisted_172,
                                                                                    _createVNode("strong", null, _toDisplayString(image.deleted_at), 1)
                                                                                  ])
                                                                                ])
                                                                              ]))
                                                                            : (_openBlock(), _createBlock("div", _hoisted_173, [
                                                                                (image.file_type === 'mp4' ||
                                          image.file_type === 'mov' ||
                                          image.file_type === 'wmv' ||
                                          image.file_type === 'webm' ||
                                          image.file_type === 'ogg' ||
                                          image.file_type === 'avi' ||
                                          image.file_type === 'x-ms-wmv'
                                        )
                                                                                  ? (_openBlock(), _createBlock("div", _hoisted_174, [
                                                                                      _createVNode("div", _hoisted_175, [
                                                                                        _createVNode("video", {
                                                                                          id: `my-player${imageIndex}`,
                                                                                          class: "video-js",
                                                                                          controls: "",
                                                                                          preload: "auto",
                                                                                          poster: "img/convorally-logo.png",
                                                                                          "data-setup": "{}"
                                                                                        }, [
                                                                                          _createVNode("source", {
                                                                                            src: image.file_link,
                                                                                            type: `video/${image.file_type}`
                                                                                          }, null, 8, ["src", "type"]),
                                                                                          _hoisted_176
                                                                                        ], 8, ["id"])
                                                                                      ]),
                                                                                      _createVNode("div", _hoisted_177, [
                                                                                        _createVNode("p", {
                                                                                          class: "font-weight-bold",
                                                                                          innerHTML: `${image.file_name}`
                                                                                        }, null, 8, ["innerHTML"]),
                                                                                        _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                      ])
                                                                                    ]))
                                                                                  : (image.file_type === 'doc' ||
                                          image.file_type === 'docx'
                                        )
                                                                                    ? (_openBlock(), _createBlock("div", _hoisted_178, [
                                                                                        _hoisted_179,
                                                                                        _createVNode("div", _hoisted_180, [
                                                                                          _createVNode("p", {
                                                                                            class: "font-weight-bold",
                                                                                            onClick: _withModifiers(($event: any) => (
                                              _ctx.downloadFile(image.file_link)
                                              ), ["prevent"]),
                                                                                            innerHTML: `${image.file_name}`
                                                                                          }, null, 8, ["onClick", "innerHTML"]),
                                                                                          _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                        ])
                                                                                      ]))
                                                                                    : (image.file_type === 'xls' ||
                                          image.file_type === 'xlsx' ||
                                          image.file_type === 'xlsm' ||
                                          image.file_type === 'xlsb' ||
                                          image.file_type === 'xltx')
                                                                                      ? (_openBlock(), _createBlock("div", _hoisted_181, [
                                                                                          _createVNode("div", {
                                                                                            class: "image-wrapp",
                                                                                            onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                                                                          }, [
                                                                                            _createVNode("div", _hoisted_182, [
                                                                                              _createVNode("img", {
                                                                                                src: `${_ctx.state.data.imageBaseUrl}img/excel.png`,
                                                                                                alt: "",
                                                                                                height: "150",
                                                                                                width: "180"
                                                                                              }, null, 8, ["src"])
                                                                                            ]),
                                                                                            _createVNode("div", _hoisted_183, [
                                                                                              _createVNode("p", {
                                                                                                class: "font-weight-bold",
                                                                                                innerHTML: `${image.file_name}`
                                                                                              }, null, 8, ["innerHTML"]),
                                                                                              _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                            ])
                                                                                          ], 8, ["onClick"])
                                                                                        ]))
                                                                                      : (image.file_type === 'ppt' ||
                                          image.file_type === 'pptm' ||
                                          image.file_type === 'pptx'
                                        )
                                                                                        ? (_openBlock(), _createBlock("div", _hoisted_184, [
                                                                                            _createVNode("div", {
                                                                                              class: "image-wrapp",
                                                                                              onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                                                                            }, [
                                                                                              _createVNode("div", _hoisted_185, [
                                                                                                _createVNode("img", {
                                                                                                  src: `${_ctx.state.data.imageBaseUrl}img/ppt.png`,
                                                                                                  alt: "",
                                                                                                  height: "150",
                                                                                                  width: "180"
                                                                                                }, null, 8, ["src"])
                                                                                              ]),
                                                                                              _createVNode("div", _hoisted_186, [
                                                                                                _createVNode("p", {
                                                                                                  class: "font-weight-bold",
                                                                                                  innerHTML: `${image.file_name}`
                                                                                                }, null, 8, ["innerHTML"]),
                                                                                                _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                              ])
                                                                                            ], 8, ["onClick"]),
                                                                                            (_ctx.channelStatus)
                                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                                  key: 0,
                                                                                                  title: "Forward",
                                                                                                  onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                                                  class: "remove-image share-icon"
                                                                                                }, [
                                                                                                  _hoisted_187
                                                                                                ], 8, ["onClick"]))
                                                                                              : _createCommentVNode("", true),
                                                                                            (communication.editStatus && _ctx.channelStatus)
                                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                                  key: 1,
                                                                                                  title: "Rename",
                                                                                                  onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                                                  class: "remove-image edit-icon"
                                                                                                }, [
                                                                                                  _hoisted_188
                                                                                                ], 8, ["onClick"]))
                                                                                              : _createCommentVNode("", true),
                                                                                            (communication.editStatus && _ctx.channelStatus)
                                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                                  key: 2,
                                                                                                  href: "javascript:void(0)",
                                                                                                  class: "remove-image",
                                                                                                  onClick: _withModifiers(($event: any) => (
                                              _ctx.selectedCommunicationImageToDelete(
                                                communication,
                                                image
                                              )
                                              ), ["prevent"])
                                                                                                }, [
                                                                                                  _hoisted_189
                                                                                                ], 8, ["onClick"]))
                                                                                              : _createCommentVNode("", true)
                                                                                          ]))
                                                                                        : (image.file_type === 'zip' || image.file_type === 'rar' || image.file_type === 'tar')
                                                                                          ? (_openBlock(), _createBlock("div", _hoisted_190, [
                                                                                              _createVNode("div", _hoisted_191, [
                                                                                                _createVNode("div", _hoisted_192, [
                                                                                                  _createVNode("img", {
                                                                                                    src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/file.jpg` : 'img/file.jpg',
                                                                                                    alt: ""
                                                                                                  }, null, 8, ["src"])
                                                                                                ]),
                                                                                                _createVNode("div", _hoisted_193, [
                                                                                                  _createVNode("p", {
                                                                                                    class: "font-weight-bold",
                                                                                                    innerHTML: `${image.file_name}`
                                                                                                  }, null, 8, ["innerHTML"]),
                                                                                                  _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1),
                                                                                                  _createVNode("a", {
                                                                                                    href: "javascript:void(0)",
                                                                                                    class: "btn default-btn d-block mt-1 btn-sm",
                                                                                                    onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                                                                  }, [
                                                                                                    _hoisted_194,
                                                                                                    _hoisted_195
                                                                                                  ], 8, ["onClick"])
                                                                                                ])
                                                                                              ]),
                                                                                              (_ctx.channelStatus)
                                                                                                ? (_openBlock(), _createBlock("a", {
                                                                                                    key: 0,
                                                                                                    title: "Forward",
                                                                                                    onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                                                    class: "remove-image share-icon"
                                                                                                  }, [
                                                                                                    _hoisted_196
                                                                                                  ], 8, ["onClick"]))
                                                                                                : _createCommentVNode("", true),
                                                                                              (communication.editStatus && _ctx.channelStatus)
                                                                                                ? (_openBlock(), _createBlock("a", {
                                                                                                    key: 1,
                                                                                                    title: "Rename",
                                                                                                    onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                                                    class: "remove-image edit-icon"
                                                                                                  }, [
                                                                                                    _hoisted_197
                                                                                                  ], 8, ["onClick"]))
                                                                                                : _createCommentVNode("", true),
                                                                                              (communication.editStatus && _ctx.channelStatus)
                                                                                                ? (_openBlock(), _createBlock("a", {
                                                                                                    key: 2,
                                                                                                    href: "javascript:void(0)",
                                                                                                    class: "remove-image",
                                                                                                    onClick: _withModifiers(($event: any) => (
                                              _ctx.selectedCommunicationImageToDelete(
                                                communication,
                                                image
                                              )
                                              ), ["prevent"])
                                                                                                  }, [
                                                                                                    _hoisted_198
                                                                                                  ], 8, ["onClick"]))
                                                                                                : _createCommentVNode("", true)
                                                                                            ]))
                                                                                          : (image.file_type != 'pdf')
                                                                                            ? (_openBlock(), _createBlock("div", _hoisted_199, [
                                                                                                _createVNode("div", {
                                                                                                  class: "image-wrapp",
                                                                                                  onClick: ($event: any) => (_ctx.clickImage(communication.forward.attachments, imageIndex))
                                                                                                }, [
                                                                                                  _createVNode("div", _hoisted_200, [
                                                                                                    _createVNode("img", {
                                                                                                      src: image.file_link,
                                                                                                      alt: "",
                                                                                                      height: "150",
                                                                                                      width: "180"
                                                                                                    }, null, 8, ["src"])
                                                                                                  ]),
                                                                                                  _createVNode("div", _hoisted_201, [
                                                                                                    _createVNode("p", {
                                                                                                      class: "font-weight-bold",
                                                                                                      innerHTML: `${image.file_name}`
                                                                                                    }, null, 8, ["innerHTML"]),
                                                                                                    _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                                                  ])
                                                                                                ], 8, ["onClick"])
                                                                                              ]))
                                                                                            : (_openBlock(), _createBlock("div", _hoisted_202, [
                                                                                                _createTextVNode(_toDisplayString(image.file_type), 1),
                                                                                                _createVNode("div", {
                                                                                                  onClick: ($event: any) => (_ctx.viewPdf(image.file_link))
                                                                                                }, [
                                                                                                  _createVNode("div", _hoisted_203, [
                                                                                                    _createVNode("embed", {
                                                                                                      src: image.file_link,
                                                                                                      frameBorder: "0",
                                                                                                      scrolling: "auto",
                                                                                                      height: "100%",
                                                                                                      width: "100%"
                                                                                                    }, null, 8, ["src"])
                                                                                                  ]),
                                                                                                  _createVNode("div", _hoisted_204, [
                                                                                                    _createVNode("p", {
                                                                                                      class: "font-weight-bold",
                                                                                                      innerHTML: `${image.file_name}`
                                                                                                    }, null, 8, ["innerHTML"]),
                                                                                                    _createVNode("p", _hoisted_205, _toDisplayString(image.convertedFileSize), 1),
                                                                                                    (communication.user)
                                                                                                      ? (_openBlock(), _createBlock("p", _hoisted_206, " Sent by : " + _toDisplayString(communication.user.full_name), 1))
                                                                                                      : _createCommentVNode("", true)
                                                                                                  ])
                                                                                                ], 8, ["onClick"])
                                                                                              ]))
                                                                              ]))
                                                                        ]))
                                                                      }), 128))
                                                                    ])
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                              ])
                                            ])),
                                        (communication.responses_count)
                                          ? (_openBlock(), _createBlock("div", {
                                              key: 4,
                                              class: communication.responses['matchCount']
                          ? 'thread-box mt-2 thread-active highlighted-text'
                          : 'thread-box mt-2 thread'
                          ,
                                              onClick: _withModifiers(($event: any) => (_ctx.replyCommunication(communication)), ["prevent"])
                                            }, [
                                              _createVNode("div", _hoisted_207, [
                                                _createVNode("ul", null, [
                                                  (communication.uniqueResponse &&
                                communication.uniqueResponse.length
                              )
                                                    ? (_openBlock(), _createBlock("li", _hoisted_208, [
                                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.uniqueResponse, (response, responseIndex) => {
                                                          return (_openBlock(), _createBlock("div", {
                                                            class: "stacked-img",
                                                            key: responseIndex
                                                          }, [
                                                            (response.response_by.image)
                                                              ? (_openBlock(), _createBlock("img", {
                                                                  key: 0,
                                                                  src: response.response_by.image,
                                                                  alt: "",
                                                                  title: response.response_by.email
                                                                }, null, 8, ["src", "title"]))
                                                              : (_openBlock(), _createBlock("img", {
                                                                  key: 1,
                                                                  src: _ctx.state.data.imageBaseUrl
                                    ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                    : 'img/no-user.jpg'
                                    ,
                                                                  alt: "",
                                                                  title: response.response_by.email
                                                                }, null, 8, ["src", "title"]))
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  _createVNode("li", null, [
                                                    _createVNode("a", _hoisted_209, [
                                                      _createVNode("strong", null, _toDisplayString(communication.responses_count) + " replies ", 1),
                                                      (communication.responses.length)
                                                        ? (_openBlock(), _createBlock("span", _hoisted_210, _toDisplayString(communication.responses[
                                    communication.responses.length - 1
                                    ].createdLatest), 1))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ], 10, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (communication.form_data)
                                          ? (_openBlock(), _createBlock("div", {
                                              key: 5,
                                              class: "form-msg",
                                              onClick: ($event: any) => (_ctx.showFormView(communication))
                                            }, [
                                              _hoisted_211,
                                              (communication.form_data.sent_to_users &&
                            communication.form_data.sent_to_users.length
                          )
                                                ? (_openBlock(), _createBlock("p", _hoisted_212, [
                                                    _hoisted_213,
                                                    _createVNode("span", null, _toDisplayString(communication.form_data.form_name
                              ? communication.form_data.form_name
                              : communication.form_data.client_document_name), 1),
                                                    _hoisted_214,
                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.form_data
                              .sent_to_users, (user, userIndex) => {
                                                      return (_openBlock(), _createBlock("span", { key: userIndex }, [
                                                        _createTextVNode(_toDisplayString(user.email), 1),
                                                        (userIndex <
                                communication.form_data.sent_to_users.length - 1
                              )
                                                          ? (_openBlock(), _createBlock("span", _hoisted_215, ", "))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createBlock("p", _hoisted_216, [
                                                    _hoisted_217,
                                                    _createVNode("span", null, _toDisplayString(communication.form_data.form_name), 1)
                                                  ]))
                                            ], 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (communication.communication_envelope)
                                          ? (_openBlock(), _createBlock("div", {
                                              key: 6,
                                              class: "form-msg",
                                              onClick: ($event: any) => (_ctx.showDocusignShareDocumentModel(communication.communication_envelope.envelope.uuid, communication.communication_envelope))
                                            }, [
                                              _hoisted_218,
                                              (communication.communication_envelope.envelope.recipients &&
                            communication.communication_envelope.envelope.recipients.length
                          )
                                                ? (_openBlock(), _createBlock("p", _hoisted_219, [
                                                    _hoisted_220,
                                                    _createVNode("span", null, _toDisplayString(communication.communication_envelope.envelope.name), 1),
                                                    _createTextVNode(" form " + _toDisplayString(communication.user.full_name) + " to ", 1),
                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.communication_envelope.envelope.recipients, (user, userIndex) => {
                                                      return (_openBlock(), _createBlock("span", { key: userIndex }, [
                                                        _createTextVNode(_toDisplayString(user.full_name), 1),
                                                        (userIndex <
                                communication.communication_envelope.envelope.recipients.length - 1
                              )
                                                          ? (_openBlock(), _createBlock("span", _hoisted_221, ", "))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createBlock("p", _hoisted_222, [
                                                    _hoisted_223,
                                                    _createVNode("span", null, _toDisplayString(communication.communication_envelope.envelope.name), 1)
                                                  ]))
                                            ], 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (communication.attachments &&
                          communication.attachments.length
                        )
                                          ? (_openBlock(), _createBlock("div", _hoisted_224, [
                                              _createVNode("ul", null, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.attachments, (image, imageIndex) => {
                                                  return (_openBlock(), _createBlock("li", { key: imageIndex }, [
                                                    (image.status &&
                                image.status.code === 'deleted' &&
                                image.status.name === 'Deleted'
                              )
                                                      ? (_openBlock(), _createBlock("div", _hoisted_225, [
                                                          _createVNode("img", {
                                                            src: _ctx.state.data.imageBaseUrl
                                  ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                                  : 'img/deletedimage.jpg'
                                  ,
                                                            alt: ""
                                                          }, null, 8, ["src"]),
                                                          _createVNode("div", _hoisted_226, [
                                                            _createVNode("p", null, [
                                                              _createVNode("strong", null, _toDisplayString(image.file_name), 1),
                                                              _hoisted_227,
                                                              _hoisted_228
                                                            ]),
                                                            _createVNode("p", null, [
                                                              _hoisted_229,
                                                              _createVNode("strong", null, _toDisplayString(image.deleted_at), 1)
                                                            ])
                                                          ])
                                                        ]))
                                                      : (_openBlock(), _createBlock("div", _hoisted_230, [
                                                          (image.file_type === 'mp4' ||
                                  image.file_type === 'mov' ||
                                  image.file_type === 'wmv' ||
                                  image.file_type === 'webm' ||
                                  image.file_type === 'ogg' ||
                                  image.file_type === 'avi' ||
                                  image.file_type === 'x-ms-wmv'
                                )
                                                            ? (_openBlock(), _createBlock("div", _hoisted_231, [
                                                                _createVNode("div", _hoisted_232, [
                                                                  _createVNode("video", {
                                                                    id: `my-player${imageIndex}`,
                                                                    class: "video-js",
                                                                    controls: "",
                                                                    preload: "auto",
                                                                    poster: "img/convorally-logo.png",
                                                                    "data-setup": "{}"
                                                                  }, [
                                                                    _createVNode("source", {
                                                                      src: image.file_link,
                                                                      type: `video/${image.file_type}`
                                                                    }, null, 8, ["src", "type"]),
                                                                    _hoisted_233
                                                                  ], 8, ["id"])
                                                                ]),
                                                                _createVNode("div", _hoisted_234, [
                                                                  _createVNode("p", {
                                                                    class: "font-weight-bold",
                                                                    innerHTML: `${image.file_name}`
                                                                  }, null, 8, ["innerHTML"]),
                                                                  _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                ])
                                                              ]))
                                                            : (image.file_type === 'doc' ||
                                  image.file_type === 'docx'
                                )
                                                              ? (_openBlock(), _createBlock("div", _hoisted_235, [
                                                                  _hoisted_236,
                                                                  _createVNode("div", _hoisted_237, [
                                                                    _createVNode("p", {
                                                                      class: "font-weight-bold",
                                                                      onClick: _withModifiers(($event: any) => (
                                      _ctx.downloadFile(image.file_link)
                                      ), ["prevent"]),
                                                                      innerHTML: `${image.file_name}`
                                                                    }, null, 8, ["onClick", "innerHTML"]),
                                                                    _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                  ]),
                                                                  (_ctx.channelStatus)
                                                                    ? (_openBlock(), _createBlock("a", {
                                                                        key: 0,
                                                                        title: "Forward",
                                                                        onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                        class: "remove-image share-icon"
                                                                      }, [
                                                                        _hoisted_238
                                                                      ], 8, ["onClick"]))
                                                                    : _createCommentVNode("", true),
                                                                  (communication.editStatus && _ctx.channelStatus)
                                                                    ? (_openBlock(), _createBlock("a", {
                                                                        key: 1,
                                                                        title: "Rename",
                                                                        onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                        class: "remove-image edit-icon"
                                                                      }, [
                                                                        _hoisted_239
                                                                      ], 8, ["onClick"]))
                                                                    : _createCommentVNode("", true),
                                                                  (communication.editStatus && _ctx.channelStatus)
                                                                    ? (_openBlock(), _createBlock("a", {
                                                                        key: 2,
                                                                        href: "javascript:void(0)",
                                                                        class: "remove-image",
                                                                        onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                      }, [
                                                                        _hoisted_240
                                                                      ], 8, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ]))
                                                              : (image.file_type === 'xls' ||
                                  image.file_type === 'xlsx' ||
                                  image.file_type === 'xlsm' ||
                                  image.file_type === 'xlsb' ||
                                  image.file_type === 'xltx')
                                                                ? (_openBlock(), _createBlock("div", _hoisted_241, [
                                                                    _createVNode("div", {
                                                                      class: "image-wrapp",
                                                                      onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                                                    }, [
                                                                      _createVNode("div", _hoisted_242, [
                                                                        _createVNode("img", {
                                                                          src: `${_ctx.state.data.imageBaseUrl}img/excel.png`,
                                                                          alt: "",
                                                                          height: "150",
                                                                          width: "180"
                                                                        }, null, 8, ["src"])
                                                                      ]),
                                                                      _createVNode("div", _hoisted_243, [
                                                                        _createVNode("p", {
                                                                          class: "font-weight-bold",
                                                                          innerHTML: `${image.file_name}`
                                                                        }, null, 8, ["innerHTML"]),
                                                                        _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                      ])
                                                                    ], 8, ["onClick"]),
                                                                    (_ctx.channelStatus)
                                                                      ? (_openBlock(), _createBlock("a", {
                                                                          key: 0,
                                                                          title: "Forward",
                                                                          onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                          class: "remove-image share-icon"
                                                                        }, [
                                                                          _hoisted_244
                                                                        ], 8, ["onClick"]))
                                                                      : _createCommentVNode("", true),
                                                                    (communication.editStatus && _ctx.channelStatus)
                                                                      ? (_openBlock(), _createBlock("a", {
                                                                          key: 1,
                                                                          title: "Rename",
                                                                          onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                          class: "remove-image edit-icon"
                                                                        }, [
                                                                          _hoisted_245
                                                                        ], 8, ["onClick"]))
                                                                      : _createCommentVNode("", true),
                                                                    (communication.editStatus && _ctx.channelStatus)
                                                                      ? (_openBlock(), _createBlock("a", {
                                                                          key: 2,
                                                                          href: "javascript:void(0)",
                                                                          class: "remove-image",
                                                                          onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                        }, [
                                                                          _hoisted_246
                                                                        ], 8, ["onClick"]))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                : (image.file_type === 'ppt' ||
                                  image.file_type === 'pptm' ||
                                  image.file_type === 'pptx'
                                )
                                                                  ? (_openBlock(), _createBlock("div", _hoisted_247, [
                                                                      _createVNode("div", {
                                                                        class: "image-wrapp",
                                                                        onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                                                      }, [
                                                                        _createVNode("div", _hoisted_248, [
                                                                          _createVNode("img", {
                                                                            src: `${_ctx.state.data.imageBaseUrl}img/ppt.png`,
                                                                            alt: "",
                                                                            height: "150",
                                                                            width: "180"
                                                                          }, null, 8, ["src"])
                                                                        ]),
                                                                        _createVNode("div", _hoisted_249, [
                                                                          _createVNode("p", {
                                                                            class: "font-weight-bold",
                                                                            innerHTML: `${image.file_name}`
                                                                          }, null, 8, ["innerHTML"]),
                                                                          _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                        ])
                                                                      ], 8, ["onClick"]),
                                                                      (_ctx.channelStatus)
                                                                        ? (_openBlock(), _createBlock("a", {
                                                                            key: 0,
                                                                            title: "Forward",
                                                                            onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                            class: "remove-image share-icon"
                                                                          }, [
                                                                            _hoisted_250
                                                                          ], 8, ["onClick"]))
                                                                        : _createCommentVNode("", true),
                                                                      (communication.editStatus && _ctx.channelStatus)
                                                                        ? (_openBlock(), _createBlock("a", {
                                                                            key: 1,
                                                                            title: "Rename",
                                                                            onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                            class: "remove-image edit-icon"
                                                                          }, [
                                                                            _hoisted_251
                                                                          ], 8, ["onClick"]))
                                                                        : _createCommentVNode("", true),
                                                                      (communication.editStatus && _ctx.channelStatus)
                                                                        ? (_openBlock(), _createBlock("a", {
                                                                            key: 2,
                                                                            href: "javascript:void(0)",
                                                                            class: "remove-image",
                                                                            onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                          }, [
                                                                            _hoisted_252
                                                                          ], 8, ["onClick"]))
                                                                        : _createCommentVNode("", true)
                                                                    ]))
                                                                  : (image.file_type === 'zip' || image.file_type === 'rar' || image.file_type === 'tar')
                                                                    ? (_openBlock(), _createBlock("div", _hoisted_253, [
                                                                        _createVNode("div", _hoisted_254, [
                                                                          _createVNode("div", {
                                                                            class: "same-ht-img",
                                                                            onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                                          }, [
                                                                            _createVNode("img", {
                                                                              src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/file.jpg` : 'img/file.jpg',
                                                                              alt: ""
                                                                            }, null, 8, ["src"])
                                                                          ], 8, ["onClick"]),
                                                                          _createVNode("div", _hoisted_255, [
                                                                            _createVNode("p", {
                                                                              class: "font-weight-bold",
                                                                              innerHTML: `${image.file_name}`
                                                                            }, null, 8, ["innerHTML"]),
                                                                            _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1),
                                                                            _createVNode("a", {
                                                                              href: "javascript:void(0)",
                                                                              class: "btn default-btn d-block mt-1 btn-sm",
                                                                              onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                                            }, [
                                                                              _hoisted_256,
                                                                              _hoisted_257
                                                                            ], 8, ["onClick"])
                                                                          ])
                                                                        ]),
                                                                        (_ctx.channelStatus)
                                                                          ? (_openBlock(), _createBlock("a", {
                                                                              key: 0,
                                                                              title: "Forward",
                                                                              onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                              class: "remove-image share-icon"
                                                                            }, [
                                                                              _hoisted_258
                                                                            ], 8, ["onClick"]))
                                                                          : _createCommentVNode("", true),
                                                                        (communication.editStatus && _ctx.channelStatus)
                                                                          ? (_openBlock(), _createBlock("a", {
                                                                              key: 1,
                                                                              title: "Rename",
                                                                              onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                              class: "remove-image edit-icon"
                                                                            }, [
                                                                              _hoisted_259
                                                                            ], 8, ["onClick"]))
                                                                          : _createCommentVNode("", true),
                                                                        (communication.editStatus && _ctx.channelStatus)
                                                                          ? (_openBlock(), _createBlock("a", {
                                                                              key: 2,
                                                                              href: "javascript:void(0)",
                                                                              class: "remove-image",
                                                                              onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                            }, [
                                                                              _hoisted_260
                                                                            ], 8, ["onClick"]))
                                                                          : _createCommentVNode("", true)
                                                                      ]))
                                                                    : (image.file_type == 'csv')
                                                                      ? (_openBlock(), _createBlock("div", _hoisted_261, [
                                                                          _createVNode("div", _hoisted_262, [
                                                                            _createVNode("div", {
                                                                              class: "same-ht-img",
                                                                              onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                                            }, [
                                                                              _createVNode("img", {
                                                                                src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/csv.png` : 'img/csv.png',
                                                                                alt: ""
                                                                              }, null, 8, ["src"])
                                                                            ], 8, ["onClick"]),
                                                                            _createVNode("div", _hoisted_263, [
                                                                              _createVNode("p", {
                                                                                class: "font-weight-bold",
                                                                                innerHTML: `${image.file_name}`
                                                                              }, null, 8, ["innerHTML"]),
                                                                              _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                            ])
                                                                          ]),
                                                                          (_ctx.channelStatus)
                                                                            ? (_openBlock(), _createBlock("a", {
                                                                                key: 0,
                                                                                title: "Forward",
                                                                                onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                                class: "remove-image share-icon"
                                                                              }, [
                                                                                _hoisted_264
                                                                              ], 8, ["onClick"]))
                                                                            : _createCommentVNode("", true),
                                                                          (communication.editStatus && _ctx.channelStatus)
                                                                            ? (_openBlock(), _createBlock("a", {
                                                                                key: 1,
                                                                                title: "Rename",
                                                                                onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                                class: "remove-image edit-icon"
                                                                              }, [
                                                                                _hoisted_265
                                                                              ], 8, ["onClick"]))
                                                                            : _createCommentVNode("", true),
                                                                          (communication.editStatus && _ctx.channelStatus)
                                                                            ? (_openBlock(), _createBlock("a", {
                                                                                key: 2,
                                                                                href: "javascript:void(0)",
                                                                                class: "remove-image",
                                                                                onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                              }, [
                                                                                _hoisted_266
                                                                              ], 8, ["onClick"]))
                                                                            : _createCommentVNode("", true)
                                                                        ]))
                                                                      : (image.file_type != 'pdf')
                                                                        ? (_openBlock(), _createBlock("div", _hoisted_267, [
                                                                            _createVNode("div", {
                                                                              class: "image-wrapp",
                                                                              onClick: ($event: any) => (_ctx.clickImage(communication.attachments, imageIndex))
                                                                            }, [
                                                                              _createVNode("div", _hoisted_268, [
                                                                                _createVNode("img", {
                                                                                  src: image.file_link,
                                                                                  alt: "",
                                                                                  height: "150",
                                                                                  width: "180"
                                                                                }, null, 8, ["src"])
                                                                              ]),
                                                                              _createVNode("div", _hoisted_269, [
                                                                                _createVNode("p", {
                                                                                  class: "font-weight-bold",
                                                                                  innerHTML: `${image.file_name}`
                                                                                }, null, 8, ["innerHTML"]),
                                                                                _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1)
                                                                              ])
                                                                            ], 8, ["onClick"]),
                                                                            (_ctx.channelStatus)
                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                  key: 0,
                                                                                  title: "Forward",
                                                                                  onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                                  class: "remove-image share-icon"
                                                                                }, [
                                                                                  _hoisted_270
                                                                                ], 8, ["onClick"]))
                                                                              : _createCommentVNode("", true),
                                                                            (communication.editStatus && _ctx.channelStatus)
                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                  key: 1,
                                                                                  title: "Rename",
                                                                                  onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                                  class: "remove-image edit-icon"
                                                                                }, [
                                                                                  _hoisted_271
                                                                                ], 8, ["onClick"]))
                                                                              : _createCommentVNode("", true),
                                                                            (communication.editStatus && _ctx.channelStatus)
                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                  key: 2,
                                                                                  href: "javascript:void(0)",
                                                                                  class: "remove-image",
                                                                                  onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                                }, [
                                                                                  _hoisted_272
                                                                                ], 8, ["onClick"]))
                                                                              : _createCommentVNode("", true)
                                                                          ]))
                                                                        : (_openBlock(), _createBlock("div", _hoisted_273, [
                                                                            _createVNode("div", {
                                                                              onClick: ($event: any) => (_ctx.viewPdf(image.file_link))
                                                                            }, [
                                                                              _createVNode("div", _hoisted_274, [
                                                                                _createVNode("embed", {
                                                                                  src: image.file_link,
                                                                                  frameBorder: "0",
                                                                                  scrolling: "auto",
                                                                                  height: "100%",
                                                                                  width: "100%"
                                                                                }, null, 8, ["src"])
                                                                              ]),
                                                                              _createVNode("div", _hoisted_275, [
                                                                                _createVNode("p", {
                                                                                  class: "font-weight-bold",
                                                                                  innerHTML: `${image.file_name}`
                                                                                }, null, 8, ["innerHTML"]),
                                                                                _createVNode("p", _hoisted_276, _toDisplayString(image.convertedFileSize), 1),
                                                                                (communication.user)
                                                                                  ? (_openBlock(), _createBlock("p", _hoisted_277, " Sent by : " + _toDisplayString(communication.user.full_name), 1))
                                                                                  : _createCommentVNode("", true)
                                                                              ])
                                                                            ], 8, ["onClick"]),
                                                                            (_ctx.channelStatus)
                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                  key: 0,
                                                                                  title: "Forward",
                                                                                  onClick: ($event: any) => (_ctx.forwardMessage(communication, image)),
                                                                                  class: "remove-image share-icon"
                                                                                }, [
                                                                                  _hoisted_278
                                                                                ], 8, ["onClick"]))
                                                                              : _createCommentVNode("", true),
                                                                            (communication.editStatus && _ctx.channelStatus)
                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                  key: 1,
                                                                                  title: "Rename",
                                                                                  onClick: ($event: any) => (_ctx.renameDoc(communication, image)),
                                                                                  class: "remove-image edit-icon"
                                                                                }, [
                                                                                  _hoisted_279
                                                                                ], 8, ["onClick"]))
                                                                              : _createCommentVNode("", true),
                                                                            (communication.editStatus && _ctx.channelStatus)
                                                                              ? (_openBlock(), _createBlock("a", {
                                                                                  key: 2,
                                                                                  href: "javascript:void(0)",
                                                                                  class: "remove-image",
                                                                                  onClick: _withModifiers(($event: any) => (
                                      _ctx.selectedCommunicationImageToDelete(
                                        communication,
                                        image
                                      )
                                      ), ["prevent"])
                                                                                }, [
                                                                                  _hoisted_280
                                                                                ], 8, ["onClick"]))
                                                                              : _createCommentVNode("", true)
                                                                          ]))
                                                        ]))
                                                  ]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (communication.share_history &&
                          communication.share_history.length
                        )
                                          ? (_openBlock(), _createBlock("div", _hoisted_281, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.share_history, (sharedDocument, sharedIndex) => {
                                                return (_openBlock(), _createBlock("div", { key: sharedIndex }, [
                                                  (sharedDocument.documents &&
                              sharedDocument.documents.length
                            )
                                                    ? (_openBlock(), _createBlock("div", _hoisted_282, [
                                                        _createVNode("ul", null, [
                                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(sharedDocument.documents, (document, documentIndex) => {
                                                            return (_openBlock(), _createBlock("li", { key: documentIndex }, [
                                                              _createVNode("div", _hoisted_283, [
                                                                (document.deleted_at)
                                                                  ? (_openBlock(), _createBlock("div", _hoisted_284, [
                                                                      _createVNode("img", {
                                                                        src: _ctx.state.data.imageBaseUrl
                                        ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                                        : 'img/deletedimage.jpg'
                                        ,
                                                                        alt: ""
                                                                      }, null, 8, ["src"]),
                                                                      _createVNode("div", _hoisted_285, [
                                                                        _createVNode("p", null, [
                                                                          _createVNode("strong", null, _toDisplayString(document.filename), 1),
                                                                          _hoisted_286,
                                                                          _hoisted_287
                                                                        ]),
                                                                        _createVNode("p", null, [
                                                                          _hoisted_288,
                                                                          _createVNode("strong", null, _toDisplayString(document.deleted_at), 1)
                                                                        ])
                                                                      ])
                                                                    ]))
                                                                  : (document.file.filetype === 'mp4' ||
                                      document.file.filetype === 'mov' ||
                                      document.file.filetype === 'MOV' ||
                                      document.file.filetype === 'wmv' ||
                                      document.file.filetype === 'webm' ||
                                      document.file.filetype === 'ogg' ||
                                      document.file.filetype === 'avi' ||
                                      document.file.filetype === 'x-ms-wmv'
                                    )
                                                                    ? (_openBlock(), _createBlock("div", _hoisted_289, [
                                                                        _createVNode("div", _hoisted_290, [
                                                                          _createVNode("video", {
                                                                            id: `my-player${documentIndex}`,
                                                                            class: "video-js",
                                                                            controls: "",
                                                                            preload: "auto",
                                                                            poster: "img/convorally-logo.png",
                                                                            "data-setup": "{}"
                                                                          }, [
                                                                            _createVNode("source", {
                                                                              src: document.file.file_url,
                                                                              type: `video/${document.file.filetype}`
                                                                            }, null, 8, ["src", "type"]),
                                                                            _hoisted_291
                                                                          ], 8, ["id"])
                                                                        ]),
                                                                        (document.file)
                                                                          ? (_openBlock(), _createBlock("div", _hoisted_292, [
                                                                              _createVNode("p", {
                                                                                class: "font-weight-bold",
                                                                                innerHTML: `${document.filename}`
                                                                              }, null, 8, ["innerHTML"]),
                                                                              _createVNode("p", _hoisted_293, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true)
                                                                      ]))
                                                                    : (document.file.filetype === 'doc' ||
                                      document.file.filetype === 'docx'
                                    )
                                                                      ? (_openBlock(), _createBlock("div", _hoisted_294, [
                                                                          _hoisted_295,
                                                                          _createVNode("div", _hoisted_296, [
                                                                            _createVNode("h5", {
                                                                              onClick: _withModifiers(($event: any) => (
                                          _ctx.downloadFile(document.file.file_url)
                                          ), ["prevent"])
                                                                            }, _toDisplayString(document.filename), 9, ["onClick"]),
                                                                            (document.file)
                                                                              ? (_openBlock(), _createBlock("p", _hoisted_297, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1))
                                                                              : _createCommentVNode("", true)
                                                                          ]),
                                                                          _createVNode("a", {
                                                                            title: "Rename",
                                                                            onClick: ($event: any) => (
                                        _ctx.selectedDocumentToEdit(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ),
                                                                            "data-toggle": "modal",
                                                                            class: "remove-image edit-icon"
                                                                          }, [
                                                                            _hoisted_298
                                                                          ], 8, ["onClick"]),
                                                                          _createVNode("a", {
                                                                            href: "javascript:void(0)",
                                                                            class: "remove-image",
                                                                            onClick: _withModifiers(($event: any) => (
                                        _ctx.selectedDocumentToDelete(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ), ["prevent"])
                                                                          }, [
                                                                            _hoisted_299
                                                                          ], 8, ["onClick"])
                                                                        ]))
                                                                      : (document.file.filetype === 'xlsx' ||
                                      document.file.filetype === 'xls' ||
                                      document.file.filetype === 'xlsm' ||
                                      document.file.filetype === 'xlsb' ||
                                      document.file.filetype === 'xltx'
                                    )
                                                                        ? (_openBlock(), _createBlock("div", _hoisted_300, [
                                                                            _createVNode("div", _hoisted_301, [
                                                                              _createVNode("div", _hoisted_302, [
                                                                                _createVNode("div", _hoisted_303, [
                                                                                  _createVNode("img", {
                                                                                    src: `${_ctx.state.data.imageBaseUrl}img/excel.png`,
                                                                                    alt: "",
                                                                                    height: "150",
                                                                                    width: "180"
                                                                                  }, null, 8, ["src"])
                                                                                ])
                                                                              ])
                                                                            ]),
                                                                            _createVNode("div", _hoisted_304, [
                                                                              _createVNode("h5", {
                                                                                onClick: _withModifiers(($event: any) => (
                                          _ctx.downloadFile(document.file.file_url)
                                          ), ["prevent"])
                                                                              }, [
                                                                                _createVNode("p", {
                                                                                  class: "font-weight-bold",
                                                                                  innerHTML: `${document.filename}`
                                                                                }, null, 8, ["innerHTML"])
                                                                              ], 8, ["onClick"]),
                                                                              (document.file)
                                                                                ? (_openBlock(), _createBlock("p", _hoisted_305, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1))
                                                                                : _createCommentVNode("", true)
                                                                            ]),
                                                                            _createVNode("a", {
                                                                              title: "Rename",
                                                                              onClick: ($event: any) => (
                                        _ctx.selectedDocumentToEdit(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ),
                                                                              "data-toggle": "modal",
                                                                              class: "remove-image edit-icon"
                                                                            }, [
                                                                              _hoisted_306
                                                                            ], 8, ["onClick"]),
                                                                            _createVNode("a", {
                                                                              href: "javascript:void(0)",
                                                                              class: "remove-image",
                                                                              onClick: _withModifiers(($event: any) => (
                                        _ctx.selectedDocumentToDelete(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ), ["prevent"])
                                                                            }, [
                                                                              _hoisted_307
                                                                            ], 8, ["onClick"])
                                                                          ]))
                                                                        : (document.file.filetype === 'ppt' ||
                                      document.file.filetype === 'pptm' ||
                                      document.file.filetype === 'pptx'
                                    )
                                                                          ? (_openBlock(), _createBlock("div", _hoisted_308, [
                                                                              _createVNode("div", _hoisted_309, [
                                                                                _createVNode("div", _hoisted_310, [
                                                                                  _createVNode("div", _hoisted_311, [
                                                                                    _createVNode("img", {
                                                                                      src: `${_ctx.state.data.imageBaseUrl}img/ppt.png`,
                                                                                      alt: "",
                                                                                      height: "150",
                                                                                      width: "180"
                                                                                    }, null, 8, ["src"])
                                                                                  ])
                                                                                ])
                                                                              ]),
                                                                              _createVNode("div", _hoisted_312, [
                                                                                _createVNode("h5", {
                                                                                  onClick: _withModifiers(($event: any) => (
                                          _ctx.downloadFile(document.file.file_url)
                                          ), ["prevent"])
                                                                                }, _toDisplayString(document.filename), 9, ["onClick"]),
                                                                                (document.file)
                                                                                  ? (_openBlock(), _createBlock("p", _hoisted_313, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1))
                                                                                  : _createCommentVNode("", true)
                                                                              ]),
                                                                              _createVNode("a", {
                                                                                title: "Rename",
                                                                                onClick: ($event: any) => (
                                        _ctx.selectedDocumentToEdit(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ),
                                                                                "data-toggle": "modal",
                                                                                class: "remove-image edit-icon"
                                                                              }, [
                                                                                _hoisted_314
                                                                              ], 8, ["onClick"]),
                                                                              _createVNode("a", {
                                                                                href: "javascript:void(0)",
                                                                                class: "remove-image",
                                                                                onClick: _withModifiers(($event: any) => (
                                        _ctx.selectedDocumentToDelete(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ), ["prevent"])
                                                                              }, [
                                                                                _hoisted_315
                                                                              ], 8, ["onClick"])
                                                                            ]))
                                                                          : (document.file.filetype === 'jpg' ||
                                      document.file.filetype === 'jpeg' ||
                                      document.file.filetype === 'png'
                                    )
                                                                            ? (_openBlock(), _createBlock("div", _hoisted_316, [
                                                                                _createVNode("img", {
                                                                                  src: document.file.file_url,
                                                                                  alt: "",
                                                                                  height: "150",
                                                                                  width: "180",
                                                                                  onClick: _withModifiers(($event: any) => (
                                        _ctx.downloadFile(document.file.file_url)
                                        ), ["prevent"])
                                                                                }, null, 8, ["src", "onClick"]),
                                                                                (document.file)
                                                                                  ? (_openBlock(), _createBlock("div", _hoisted_317, [
                                                                                      _createVNode("p", {
                                                                                        class: "font-weight-bold",
                                                                                        innerHTML: `${document.filename}`
                                                                                      }, null, 8, ["innerHTML"]),
                                                                                      _createVNode("p", _hoisted_318, " (" + _toDisplayString(document.file.convertedFileSize) + ") ", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                _createVNode("a", {
                                                                                  title: "Rename",
                                                                                  onClick: ($event: any) => (
                                        _ctx.selectedDocumentToEdit(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ),
                                                                                  "data-toggle": "modal",
                                                                                  class: "remove-image edit-icon"
                                                                                }, [
                                                                                  _hoisted_319
                                                                                ], 8, ["onClick"]),
                                                                                _createVNode("a", {
                                                                                  href: "javascript:void(0)",
                                                                                  class: "remove-image",
                                                                                  onClick: _withModifiers(($event: any) => (
                                        _ctx.selectedDocumentToDelete(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ), ["prevent"])
                                                                                }, [
                                                                                  _hoisted_320
                                                                                ], 8, ["onClick"])
                                                                              ]))
                                                                            : (_openBlock(), _createBlock("div", _hoisted_321, [
                                                                                _createVNode("div", {
                                                                                  onClick: ($event: any) => (_ctx.viewPdf(document.file.file_url))
                                                                                }, [
                                                                                  _createVNode("div", _hoisted_322, [
                                                                                    _createVNode("embed", {
                                                                                      src: document.file.file_url,
                                                                                      frameBorder: "0",
                                                                                      scrolling: "auto",
                                                                                      height: "100%",
                                                                                      width: "100%"
                                                                                    }, null, 8, ["src"])
                                                                                  ]),
                                                                                  _createVNode("div", _hoisted_323, [
                                                                                    (document.file)
                                                                                      ? (_openBlock(), _createBlock("h5", _hoisted_324, [
                                                                                          _createVNode("p", {
                                                                                            class: "font-weight-bold",
                                                                                            innerHTML: `${document.filename}`
                                                                                          }, null, 8, ["innerHTML"])
                                                                                        ]))
                                                                                      : _createCommentVNode("", true),
                                                                                    (document.file)
                                                                                      ? (_openBlock(), _createBlock("p", _hoisted_325, _toDisplayString(document.file.convertedFileSize), 1))
                                                                                      : _createCommentVNode("", true),
                                                                                    (document.user)
                                                                                      ? (_openBlock(), _createBlock("p", _hoisted_326, " Sent by : " + _toDisplayString(document.user.full_name), 1))
                                                                                      : _createCommentVNode("", true)
                                                                                  ])
                                                                                ], 8, ["onClick"]),
                                                                                _createVNode("a", {
                                                                                  title: "Rename",
                                                                                  onClick: ($event: any) => (
                                        _ctx.selectedDocumentToEdit(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ),
                                                                                  "data-toggle": "modal",
                                                                                  class: "remove-image edit-icon"
                                                                                }, [
                                                                                  _hoisted_327
                                                                                ], 8, ["onClick"]),
                                                                                _createVNode("a", {
                                                                                  href: "javascript:void(0)",
                                                                                  class: "remove-image",
                                                                                  onClick: _withModifiers(($event: any) => (
                                        _ctx.selectedDocumentToDelete(
                                          communication,
                                          sharedDocument,
                                          document
                                        )
                                        ), ["prevent"])
                                                                                }, [
                                                                                  _hoisted_328
                                                                                ], 8, ["onClick"])
                                                                              ]))
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (communication.messageSendStatus)
                                          ? (_openBlock(), _createBlock("div", _hoisted_329, [
                                              _hoisted_330
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!communication.messageSendStatus && _ctx.showEditor)
                                          ? (_openBlock(), _createBlock("div", _hoisted_331, [
                                              (communication.message &&
                            communication.editStatus &&
                            _ctx.channelStatus
                          )
                                                ? (_openBlock(), _createBlock("div", _hoisted_332, [
                                                    (!communication.deleted_at)
                                                      ? (_openBlock(), _createBlock("a", {
                                                          key: 0,
                                                          class: "round-icon mr-1",
                                                          onClick: ($event: any) => (_ctx.replyCommunication(communication))
                                                        }, [
                                                          _hoisted_333
                                                        ], 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (!communication.deleted_at)
                                                      ? (_openBlock(), _createBlock("a", {
                                                          key: 1,
                                                          class: "round-icon mr-1",
                                                          onClick: ($event: any) => (_ctx.forwardMessage(communication, null))
                                                        }, [
                                                          _hoisted_334
                                                        ], 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (!communication.allowEdit &&
                              !communication.deleted_at
                            )
                                                      ? (_openBlock(), _createBlock("a", {
                                                          key: 2,
                                                          class: "round-icon mr-1",
                                                          onClick: ($event: any) => (_ctx.selctedCommunication(communication))
                                                        }, [
                                                          _hoisted_335
                                                        ], 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (!communication.deleted_at)
                                                      ? (_openBlock(), _createBlock("a", {
                                                          key: 3,
                                                          class: "round-icon",
                                                          onClick: ($event: any) => (_ctx.selctedCommunicationForDelete(communication))
                                                        }, [
                                                          _hoisted_336
                                                        ], 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : (_openBlock(), _createBlock("div", _hoisted_337, [
                                                    (_ctx.channelStatus && !communication.deleted_at)
                                                      ? (_openBlock(), _createBlock("a", {
                                                          key: 0,
                                                          class: "round-icon mr-1",
                                                          onClick: ($event: any) => (_ctx.replyCommunication(communication))
                                                        }, [
                                                          _hoisted_338
                                                        ], 8, ["onClick"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.channelStatus && !communication.deleted_at)
                                                      ? (_openBlock(), _createBlock("a", {
                                                          key: 1,
                                                          class: "round-icon mr-1",
                                                          onClick: ($event: any) => (_ctx.forwardMessage(communication, null))
                                                        }, [
                                                          _hoisted_339
                                                        ], 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (communication.message_status === 0 && (communication.message_receivers && communication.message_receivers.length === 0) && !communication.messageSendStatus && (communication.user.email === _ctx.state.activeUserDetails.email))
                                          ? (_openBlock(), _createBlock("div", _hoisted_340, [
                                              _hoisted_341
                                            ]))
                                          : _createCommentVNode("", true),
                                        (communication.message_receivers && communication.message_receivers.length > 0)
                                          ? (_openBlock(), _createBlock("div", _hoisted_342, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(communication.message_receivers.slice(0, 3), (msgMember, msgMemberIndex) => {
                                                return (_openBlock(), _createBlock("a", {
                                                  title: "seen by abc at 11.30pm",
                                                  href: "javascript:void(0)",
                                                  key: msgMemberIndex
                                                }, [
                                                  (msgMember.status === 1)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_343, [
                                                        _createVNode("span", null, [
                                                          _createVNode("img", {
                                                            src: msgMember.image,
                                                            alt: msgMember.email,
                                                            title: `Delivered to ${msgMember.email}`
                                                          }, null, 8, ["src", "alt", "title"])
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createBlock("span", _hoisted_344, [
                                                        (msgMember.status === 2)
                                                          ? (_openBlock(), _createBlock("span", _hoisted_345, [
                                                              _hoisted_346
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        _createVNode("span", null, [
                                                          _createVNode("img", {
                                                            src: msgMember.image,
                                                            alt: msgMember.email,
                                                            title: `Seen by ${msgMember.email}`
                                                          }, null, 8, ["src", "alt", "title"])
                                                        ])
                                                      ]))
                                                ]))
                                              }), 128)),
                                              (communication.message_receivers.length > 3)
                                                ? (_openBlock(), _createBlock("a", {
                                                    key: 0,
                                                    href: "javascript:void(0)",
                                                    onClick: ($event: any) => (_ctx.allMessageReceivers(communication.message_receivers))
                                                  }, [
                                                    _createVNode("span", _hoisted_347, "+" + _toDisplayString(communication.message_receivers.length - 3), 1)
                                                  ], 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 10, ["id"])
                              ], 2)
                            ], 8, ["id"]))
                          }), 128))
                        ])
                      ], 512))
                    : (_openBlock(), _createBlock("div", _hoisted_348, [
                        _createVNode(_component_ChannelChatWelcomeMessage)
                      ]))
                ], 34),
                (_ctx.isLatestMessageButtonActive)
                  ? (_openBlock(), _createBlock("div", _hoisted_349, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadLatestMessages(1)))
                      }, [
                        _hoisted_350
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.channelStatus)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: ["msg-block", { 'active-dropzone': _ctx.state.data.active }],
                      onDrop: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.onDocumentChange($event)), ["prevent"])),
                      onDragover: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.dragOverHandler($event)), ["prevent"])),
                      onDragenter: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"])),
                      onDragleave: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"]))
                    }, [
                      _hoisted_351,
                      (_ctx.showEditor)
                        ? (_openBlock(), _createBlock("div", _hoisted_352, [
                            _createVNode(_component_Editor, {
                              loading: _ctx.state.postLoading,
                              showEnterSetting: true,
                              onEnterSetting: _ctx.enterSetting,
                              onEnterKeyPressed: _ctx.chatMessageEnterSetting,
                              modelValue: _ctx.state.message,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.message = $event)),
                              onPaste: _ctx.handleInputChatMessage
                            }, null, 8, ["loading", "onEnterSetting", "onEnterKeyPressed", "modelValue", "onPaste"]),
                            (_ctx.state.imageList && _ctx.state.imageList.length)
                              ? (_openBlock(), _createBlock("div", _hoisted_353, [
                                  _createVNode("div", _hoisted_354, [
                                    (_ctx.state.postLoading)
                                      ? (_openBlock(), _createBlock("div", _hoisted_355, [
                                          _createVNode("img", {
                                            src: _ctx.imageBaseUrl
                      ? `${_ctx.imageBaseUrl}img/loading.gif`
                      : 'img/loading.gif'
                      ,
                                            alt: ""
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Carousel, {
                                      height: 200,
                                      itemsToShow: 1,
                                      snapAlign: "center",
                                      breakpointMode: "carousel",
                                      breakpoints: {
                    540: { itemsToShow: 1, snapAlign: 'center', gap: 1 },
                    768: { itemsToShow: 3, snapAlign: 'start', gap: 4 },
                    960: { itemsToShow: 4, snapAlign: 'start', gap: 3 },
                    1140: { itemsToShow: 5, snapAlign: 'start', gap: 1 }
                  }
                                    }, {
                                      addons: _withCtx(() => [
                                        _createVNode(_component_Navigation)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.imageList, (image, index) => {
                                          return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_MyDriveFilesUpload, {
                                                dataFrom: 'chatchannel',
                                                dataClass: '',
                                                imageList: [image],
                                                onUploadImage: _ctx.getReadyImageListToUpload,
                                                onLatestEnabledTags: _ctx.latestEnabledTags,
                                                onRemoveSelectedImage: _ctx.removeSelectedImage,
                                                onOpenModal: _ctx.openRenameModal,
                                                onOpenLightbox: _ctx.clickChatImage
                                              }, null, 8, ["imageList", "onUploadImage", "onLatestEnabledTags", "onRemoveSelectedImage", "onOpenModal", "onOpenLightbox"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_356, [
                              _createVNode("ul", null, [
                                (!_ctx.isRecording && !_ctx.state.isFirefox)
                                  ? (_openBlock(), _createBlock("li", _hoisted_357, [
                                      _createVNode("div", {
                                        class: "mic-icons",
                                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.startRecording && _ctx.startRecording(...args)))
                                      }, [
                                        _hoisted_358
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.isFirefox)
                                  ? (_openBlock(), _createBlock("li", _hoisted_359, [
                                      _hoisted_360
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isRecording)
                                  ? (_openBlock(), _createBlock("li", _hoisted_361, [
                                      _createVNode("div", {
                                        class: "ripple-effect-icon",
                                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args)))
                                      }, [
                                        _hoisted_362
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (!_ctx.state.isPublicUser)
                                  ? (_openBlock(), _createBlock("li", _hoisted_363, [
                                      _createVNode("button", {
                                        id: "showSendTemplate",
                                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.showSendTemplate && _ctx.showSendTemplate(...args))),
                                        class: "add-templete-btn",
                                        title: "Add Template"
                                      }, [
                                        _hoisted_364
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode("li", null, [
                                  _hoisted_365,
                                  _createVNode("input", {
                                    type: "file",
                                    id: "create-document-upload",
                                    multiple: "",
                                    accept: "*.*",
                                    onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onDocumentChange($event)))
                                  }, null, 32)
                                ]),
                                _createVNode("li", null, [
                                  _createVNode("a", {
                                    id: "sendChatMessage",
                                    disabled: _ctx.state.postLoading && _ctx.state.imageList.length === 0
                      ,
                                    href: "javascript:void(0)",
                                    class: !_ctx.clearEditor
                        ? 'btn default-btn disabled'
                        : 'btn default-btn'
                        ,
                                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.createCommunicationList && _ctx.createCommunicationList(...args)))
                                  }, [
                                    (!_ctx.state.postLoading)
                                      ? (_openBlock(), _createBlock("span", _hoisted_366, " Send "))
                                      : (_openBlock(), _createBlock("span", _hoisted_367, [
                                          _hoisted_368
                                        ]))
                                  ], 10, ["disabled"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_369, [
                        (!_ctx.enableEnterKey)
                          ? (_openBlock(), _createBlock("p", _hoisted_370, [
                              _hoisted_371
                            ]))
                          : (_openBlock(), _createBlock("p", _hoisted_372, [
                              _hoisted_373
                            ]))
                      ]),
                      (_ctx.state.item.error.fileError)
                        ? (_openBlock(), _createBlock("p", _hoisted_374, " This file type is not supported .(Note: " + _toDisplayString(_ctx.state.valideFiles) + " is only supported) ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.item.error.videoError)
                        ? (_openBlock(), _createBlock("p", _hoisted_375, " This file type is not supported .(Note: .mp4/.webm/.ogg is only supported) "))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_376, [
                        (_ctx.state.data.userTyping)
                          ? (_openBlock(), _createBlock("p", _hoisted_377, _toDisplayString(_ctx.state.data.userTyping) + " typing... ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 34))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_378, [
                _hoisted_379,
                _hoisted_380,
                _createVNode("div", _hoisted_381, [
                  (_ctx.channelStatus)
                    ? (_openBlock(), _createBlock("div", _hoisted_382, [
                        (_ctx.state.channel.type == 4 && _ctx.isUserStatus && _ctx.showEditor)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              class: "btn default-btn p-1 text-white mr-2",
                              href: "javascript:void(0)",
                              onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.addNewMemberToChannel && _ctx.addNewMemberToChannel(...args)))
                            }, [
                              _hoisted_383,
                              _hoisted_384
                            ]))
                          : (_ctx.state.channel.type != 4 && _ctx.isUserStatus && _ctx.showEditor)
                            ? (_openBlock(), _createBlock("a", {
                                key: 1,
                                class: "btn default-btn p-1 text-white mr-2",
                                href: "javascript:void(0)",
                                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.addNewMemberToChannel && _ctx.addNewMemberToChannel(...args)))
                              }, [
                                _hoisted_385,
                                _hoisted_386
                              ]))
                            : _createCommentVNode("", true),
                        (!_ctx.state.data.isExport)
                          ? (_openBlock(), _createBlock("a", {
                              key: 2,
                              class: "btn default-btn p-1 text-white",
                              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.exportCommunicationPdf && _ctx.exportCommunicationPdf(...args))),
                              href: "javascript:void(0)"
                            }, [
                              _hoisted_387,
                              _hoisted_388
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_389, [
                    (_ctx.state.data.userType != 'public_user')
                      ? (_openBlock(), _createBlock("div", _hoisted_390, [
                          _createVNode("div", _hoisted_391, [
                            _createVNode("div", _hoisted_392, [
                              _createVNode("h5", _hoisted_393, [
                                _createVNode("button", _hoisted_394, " Members (" + _toDisplayString(_ctx.state.approvedMembersCount) + ") ", 1)
                              ]),
                              (_ctx.state.pendingMembersCount)
                                ? (_openBlock(), _createBlock("a", _hoisted_395, [
                                    _createTextVNode("View pending member (" + _toDisplayString(_ctx.state.pendingMembersCount) + ") ", 1),
                                    _hoisted_396
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("div", _hoisted_397, [
                            _createVNode("div", _hoisted_398, [
                              (_ctx.state.memberList && _ctx.state.memberList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_399, [
                                    _createVNode(_component_MemberCard, {
                                      channel: _ctx.state.channel,
                                      channelType: _ctx.state.owner.type,
                                      memberList: _ctx.state.memberList,
                                      pendingMembersCount: _ctx.state.pendingMembersCount,
                                      approvedMembersCount: _ctx.state.approvedMembersCount,
                                      isUserStatus: _ctx.isUserStatus,
                                      channelStatus: _ctx.channelStatus,
                                      ownerId: _ctx.state.ownerId,
                                      currentUserId: _ctx.state.data.userID,
                                      onRemovedMember: _ctx.removeMemberFromMemberList,
                                      onApproveMemberCountRemove: _ctx.removeActiveMemberCount
                                    }, null, 8, ["channel", "channelType", "memberList", "pendingMembersCount", "approvedMembersCount", "isUserStatus", "channelStatus", "ownerId", "currentUserId", "onRemovedMember", "onApproveMemberCountRemove"])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_400, [
                                    _createVNode(_component_ChannelChatWelcomeMessage)
                                  ]))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_401, [
                      _hoisted_402,
                      _createVNode("div", _hoisted_403, [
                        _createVNode("div", _hoisted_404, [
                          _createVNode("div", _hoisted_405, [
                            _createVNode("div", _hoisted_406, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "btn default-btn",
                                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.downloadProjectFiles && _ctx.downloadProjectFiles(...args)))
                              }, _toDisplayString(_ctx.state.ui.isPostLoading.downloadProjectFiles
                          ? "Downloading..."
                          : "Download files"), 1)
                            ]),
                            (_ctx.state.userRole.code === 'owner' ||
                        _ctx.state.userRole.code === 'co-owner'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_407, [
                                  (_ctx.channelStatus && _ctx.showEditor)
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: "javascript:void(0)",
                                        class: "btn default-btn danger",
                                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.closeChannel && _ctx.closeChannel(...args)))
                                      }, _toDisplayString(_ctx.state.ui.isPostLoading.closeChannel
                          ? "In Progress..."
                          : "Close channel"), 1))
                                    : (_openBlock(), _createBlock("a", {
                                        key: 1,
                                        href: "javascript:void(0)",
                                        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.channelClosedCheckNotification && _ctx.channelClosedCheckNotification(...args))),
                                        class: "btn default-btn danger",
                                        onclick: "return false;"
                                      }, "Channel Closed"))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_408, [
                      _hoisted_409,
                      _createVNode("div", _hoisted_410, [
                        (_ctx.state.sharedFormList.docs &&
                    _ctx.state.sharedFormList.docs.length
                  )
                          ? (_openBlock(), _createBlock("div", _hoisted_411, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.sharedFormList.docs, (form, formIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "shared-form-list",
                                  key: formIndex
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "floating-anchor",
                                    onClick: ($event: any) => (_ctx.viewSelectForm(form))
                                  }, null, 8, ["onClick"]),
                                  _hoisted_412,
                                  (form.title)
                                    ? (_openBlock(), _createBlock("h5", _hoisted_413, _toDisplayString(form.title), 1))
                                    : (_openBlock(), _createBlock("h5", _hoisted_414, "-")),
                                  _createVNode("p", null, [
                                    (form.owner &&
                          form.owner.created_by &&
                          form.owner.created_by.name
                        )
                                      ? (_openBlock(), _createBlock("strong", _hoisted_415, _toDisplayString(form.owner.created_by.name), 1))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(_toDisplayString(form.created_date), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.state.data.sharedFiles &&
                _ctx.state.data.sharedFiles.files &&
                _ctx.state.data.sharedFiles.files.length
              )
                      ? (_openBlock(), _createBlock("div", _hoisted_416, [
                          _hoisted_417,
                          _createVNode("div", _hoisted_418, [
                            _createVNode("div", _hoisted_419, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.sharedFiles.files, (file, fileIndex) => {
                                return (_openBlock(), _createBlock("span", { key: fileIndex }, [
                                  (!file.deleted_at)
                                    ? (_openBlock(), _createBlock("div", _hoisted_420, [
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          class: "floating-anchor",
                                          onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(file.file))
                                        }, null, 8, ["onClick"]),
                                        _hoisted_421,
                                        (file.filename)
                                          ? (_openBlock(), _createBlock("h5", _hoisted_422, _toDisplayString(file.filename), 1))
                                          : (_openBlock(), _createBlock("h5", _hoisted_423, "-"))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.state.data.sharedFiles &&
                _ctx.state.data.sharedFiles.attachments &&
                _ctx.state.data.sharedFiles.attachments.length
              )
                      ? (_openBlock(), _createBlock("div", _hoisted_424, [
                          _hoisted_425,
                          _createVNode("div", _hoisted_426, [
                            _createVNode("div", _hoisted_427, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .sharedFiles.attachments, (attachment, attachmentIndex) => {
                                return (_openBlock(), _createBlock("div", { key: attachmentIndex }, [
                                  (!attachment.deleted_at)
                                    ? (_openBlock(), _createBlock("div", _hoisted_428, [
                                        _createVNode("div", _hoisted_429, [
                                          (attachment.file_type === 'jpg' ||
                            attachment.file_type === 'jpeg' ||
                            attachment.file_type === 'png'
                          )
                                            ? (_openBlock(), _createBlock("img", {
                                                key: 0,
                                                src: attachment.file_link,
                                                alt: attachment.file_name,
                                                width: "500",
                                                height: "600"
                                              }, null, 8, ["src", "alt"]))
                                            : _createCommentVNode("", true),
                                          (attachment.file_type === 'xls' ||
                            attachment.file_type === 'xlsx' ||
                            attachment.file_type === 'pdf' ||
                            attachment.file_type === 'doc' ||
                            attachment.file_type === 'docx' ||
                            attachment.file_type === 'mp4' ||
                            attachment.file_type === 'Mp4' ||
                            attachment.file_type === 'mov' ||
                            attachment.file_type === 'MOV' ||
                            attachment.file_type === 'wmv' ||
                            attachment.file_type === 'webm' ||
                            attachment.file_type === 'ogg' ||
                            attachment.file_type === 'avi' ||
                            attachment.file_type === 'x-ms-wmv'
                          )
                                            ? (_openBlock(), _createBlock("embed", {
                                                key: 1,
                                                src: attachment.file_link,
                                                frameBorder: "0",
                                                scrolling: "auto",
                                                height: "100%",
                                                width: "100%"
                                              }, null, 8, ["src"]))
                                            : _createCommentVNode("", true),
                                          _createVNode("div", _hoisted_430, [
                                            _createVNode("ul", null, [
                                              _createVNode("li", null, [
                                                _createVNode("a", {
                                                  href: "javascript:void(0)",
                                                  title: "View File",
                                                  onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(attachment))
                                                }, [
                                                  _hoisted_431
                                                ], 8, ["onClick"])
                                              ]),
                                              _createVNode("li", null, [
                                                _createVNode("a", {
                                                  href: "javascript:void(0",
                                                  title: "Go to message",
                                                  onClick: ($event: any) => (_ctx.goToChatChannel(attachment))
                                                }, [
                                                  _hoisted_432
                                                ], 8, ["onClick"])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_433, [
                                          _createVNode("a", {
                                            href: "javascript:void(0)",
                                            class: "floating-anchor",
                                            onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(attachment))
                                          }, null, 8, ["onClick"]),
                                          (attachment.file_name)
                                            ? (_openBlock(), _createBlock("p", {
                                                key: 0,
                                                innerHTML: `${attachment.file_name}`
                                              }, null, 8, ["innerHTML"]))
                                            : (_openBlock(), _createBlock("h5", _hoisted_434, "-")),
                                          _createVNode("p", null, "Created Date- " + _toDisplayString(attachment.created_at), 1),
                                          _hoisted_435
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .sharedFiles.replyAttachments, (attachment, attachmentIndex) => {
                                return (_openBlock(), _createBlock("div", { key: attachmentIndex }, [
                                  (attachment.attachments && attachment.attachments.length)
                                    ? (_openBlock(), _createBlock("div", _hoisted_436, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(attachment.attachments, (replyAttachment, replyAtttachmentIndex) => {
                                          return (_openBlock(), _createBlock("div", { key: replyAtttachmentIndex }, [
                                            (!replyAttachment.deleted_at)
                                              ? (_openBlock(), _createBlock("div", _hoisted_437, [
                                                  _createVNode("div", _hoisted_438, [
                                                    (replyAttachment.file_type === 'jpg' ||
                                replyAttachment.file_type === 'jpeg' ||
                                replyAttachment.file_type === 'png'
                              )
                                                      ? (_openBlock(), _createBlock("img", {
                                                          key: 0,
                                                          src: replyAttachment.file_link,
                                                          alt: replyAttachment.file_name,
                                                          width: "500",
                                                          height: "600"
                                                        }, null, 8, ["src", "alt"]))
                                                      : _createCommentVNode("", true),
                                                    (replyAttachment.file_type === 'xls' ||
                                replyAttachment.file_type === 'xlsx' ||
                                replyAttachment.file_type === 'pdf' ||
                                replyAttachment.file_type === 'doc' ||
                                replyAttachment.file_type === 'docx' ||
                                replyAttachment.file_type === 'mp4' ||
                                replyAttachment.file_type === 'Mp4' ||
                                replyAttachment.file_type === 'mov' ||
                                replyAttachment.file_type === 'MOV' ||
                                replyAttachment.file_type === 'wmv' ||
                                replyAttachment.file_type === 'webm' ||
                                replyAttachment.file_type === 'ogg' ||
                                replyAttachment.file_type === 'avi' ||
                                replyAttachment.file_type === 'x-ms-wmv'
                              )
                                                      ? (_openBlock(), _createBlock("embed", {
                                                          key: 1,
                                                          src: replyAttachment.file_link,
                                                          frameBorder: "0",
                                                          scrolling: "auto",
                                                          height: "100%",
                                                          width: "100%"
                                                        }, null, 8, ["src"]))
                                                      : _createCommentVNode("", true),
                                                    _createVNode("div", _hoisted_439, [
                                                      _createVNode("ul", null, [
                                                        _createVNode("li", null, [
                                                          _createVNode("a", {
                                                            href: "javascript:void(0)",
                                                            title: "View File",
                                                            onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(replyAttachment))
                                                          }, [
                                                            _hoisted_440
                                                          ], 8, ["onClick"])
                                                        ]),
                                                        _createVNode("li", null, [
                                                          _createVNode("a", {
                                                            href: "javascript:void(0)",
                                                            title: "Go to message",
                                                            onClick: ($event: any) => (_ctx.goToChatChannel(attachment))
                                                          }, [
                                                            _hoisted_441
                                                          ], 8, ["onClick"])
                                                        ])
                                                      ])
                                                    ])
                                                  ]),
                                                  _createVNode("div", _hoisted_442, [
                                                    _createVNode("a", {
                                                      href: "javascript:void(0)",
                                                      class: "floating-anchor",
                                                      onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(replyAttachment))
                                                    }, null, 8, ["onClick"]),
                                                    (replyAttachment.file_name)
                                                      ? (_openBlock(), _createBlock("p", {
                                                          key: 0,
                                                          innerHTML: `${replyAttachment.file_name}`
                                                        }, null, 8, ["innerHTML"]))
                                                      : (_openBlock(), _createBlock("h5", _hoisted_443, "-")),
                                                    _createVNode("p", null, "Created Date- " + _toDisplayString(replyAttachment.created_at), 1),
                                                    _hoisted_444
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_445, [
                      _createVNode("div", _hoisted_446, [
                        _createVNode("h5", _hoisted_447, [
                          _createVNode("button", {
                            class: "btn collapsed",
                            "data-toggle": "collapse",
                            "data-target": "#collapseSix",
                            "aria-expanded": "false",
                            "aria-controls": "collapseSix",
                            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.exportCommunicationPdfList && _ctx.exportCommunicationPdfList(...args)))
                          }, " Exported PDF List ")
                        ])
                      ]),
                      _createVNode("div", _hoisted_448, [
                        _createVNode("div", _hoisted_449, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.exportPdfs, (exPdf, exPdfIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "pdf-card d-flex border rounded p-2 mb-2",
                              key: exPdfIndex
                            }, [
                              _hoisted_450,
                              _createVNode("div", _hoisted_451, [
                                _createVNode("p", _hoisted_452, _toDisplayString(exPdf.file_name), 1),
                                _createVNode("p", null, _toDisplayString(exPdf.created_at), 1)
                              ]),
                              _createVNode("div", _hoisted_453, [
                                _createVNode("a", {
                                  title: exPdf.file_name,
                                  href: exPdf.file_link,
                                  class: "btn default-btn btn-sm d-inline-block mt-1",
                                  target: "_blank",
                                  download: exPdf.file_name
                                }, [
                                  _hoisted_454
                                ], 8, ["title", "href", "download"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_455, [
              _createVNode("div", _hoisted_456, [
                _createVNode("div", _hoisted_457, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.closeReplyCommunication && _ctx.closeReplyCommunication(...args)))
                  }, [
                    _hoisted_458
                  ])
                ]),
                _createVNode("div", _hoisted_459, [
                  _hoisted_460,
                  (_ctx.state.data.selectedReplyUser.user &&
              _ctx.state.data.selectedReplyUser.user.full_name
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_461, _toDisplayString(_ctx.state.data.selectedReplyUser.user.full_name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_462, [
                _createVNode("div", _hoisted_463, [
                  _createVNode("div", _hoisted_464, [
                    _createVNode("div", _hoisted_465, [
                      _createVNode("div", _hoisted_466, [
                        (_ctx.state.data.selectedReplyUser.user &&
                    _ctx.state.data.selectedReplyUser.user.image
                  )
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: _ctx.state.data.selectedReplyUser.user.image,
                              title: _ctx.state.data.selectedReplyUser.user.email,
                              alt: ""
                            }, null, 8, ["src", "title"]))
                          : (_openBlock(), _createBlock("img", {
                              key: 1,
                              src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                    : 'img/no-user.jpg'
                    ,
                              alt: ""
                            }, null, 8, ["src"]))
                      ]),
                      _createVNode("div", _hoisted_467, [
                        (_ctx.state.data.selectedReplyUser.user &&
                    _ctx.state.data.selectedReplyUser.user.full_name
                  )
                          ? (_openBlock(), _createBlock("h5", _hoisted_468, [
                              _createTextVNode(_toDisplayString(_ctx.state.data.selectedReplyUser.user.full_name) + " ", 1),
                              (_ctx.state.data.selectedReplyUser &&
                      _ctx.state.data.selectedReplyUser.sentDate
                    )
                                ? (_openBlock(), _createBlock("span", _hoisted_469, _toDisplayString(_ctx.state.data.selectedReplyUser.sentDate), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.selectedReplyUser &&
                    _ctx.state.data.selectedReplyUser.message
                  )
                          ? (_openBlock(), _createBlock("p", {
                              key: 1,
                              innerHTML: `${_ctx.state.data.selectedReplyUser.message}`
                            }, null, 8, ["innerHTML"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.state.data.selectedReplyUser.attachments && _ctx.state.data.selectedReplyUser.attachments.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_470, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedReplyUser.attachments, (attachment, atcIndex) => {
                                return (_openBlock(), _createBlock("li", { key: atcIndex }, [
                                  _createVNode("div", _hoisted_471, [
                                    (!attachment.deleted_at)
                                      ? (_openBlock(), _createBlock("div", _hoisted_472, [
                                          (attachment.file_type === 'jpg' ||
                            attachment.file_type === 'jpeg' ||
                            attachment.file_type === 'png')
                                            ? (_openBlock(), _createBlock("div", _hoisted_473, [
                                                _createVNode("div", {
                                                  class: "same-ht-img",
                                                  onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(attachment))
                                                }, [
                                                  _createVNode("img", {
                                                    src: attachment.file_link,
                                                    alt: "",
                                                    height: "150",
                                                    width: "180"
                                                  }, null, 8, ["src"])
                                                ], 8, ["onClick"]),
                                                _createVNode("div", _hoisted_474, [
                                                  _createVNode("p", _hoisted_475, _toDisplayString(attachment.file_name), 1),
                                                  _createVNode("p", null, "(" + _toDisplayString(attachment.file_size) + ")", 1)
                                                ])
                                              ]))
                                            : (attachment.file_type === 'xls' ||
                            attachment.file_type === 'xlsx' ||
                            attachment.file_type === 'pdf' ||
                            attachment.file_type === 'doc' ||
                            attachment.file_type === 'docx' ||
                            attachment.file_type === 'mp4' ||
                            attachment.file_type === 'Mp4' ||
                            attachment.file_type === 'mov' ||
                            attachment.file_type === 'MOV' ||
                            attachment.file_type === 'wmv' ||
                            attachment.file_type === 'webm' ||
                            attachment.file_type === 'ogg' ||
                            attachment.file_type === 'avi' ||
                            attachment.file_type === 'x-ms-wmv'
                          )
                                              ? (_openBlock(), _createBlock("div", _hoisted_476, [
                                                  _createVNode("div", {
                                                    class: "same-ht-img",
                                                    onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(attachment))
                                                  }, [
                                                    _createVNode("embed", {
                                                      src: attachment.file_link,
                                                      frameBorder: "0",
                                                      scrolling: "auto",
                                                      height: "150",
                                                      width: "180"
                                                    }, null, 8, ["src"])
                                                  ], 8, ["onClick"]),
                                                  _createVNode("div", _hoisted_477, [
                                                    _createVNode("p", _hoisted_478, _toDisplayString(attachment.file_name), 1),
                                                    _createVNode("p", null, "(" + _toDisplayString(attachment.file_size) + ")", 1)
                                                  ])
                                                ]))
                                              : (_openBlock(), _createBlock("div", _hoisted_479, [
                                                  _createVNode("div", {
                                                    class: "same-ht-img",
                                                    onClick: ($event: any) => (_ctx.downloadFile(attachment.file_link))
                                                  }, [
                                                    _createVNode("img", {
                                                      src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/file.jpg` : 'img/file.jpg',
                                                      alt: ""
                                                    }, null, 8, ["src"])
                                                  ], 8, ["onClick"]),
                                                  _createVNode("div", _hoisted_480, [
                                                    _createVNode("p", _hoisted_481, _toDisplayString(attachment.file_name), 1),
                                                    _createVNode("p", null, "(" + _toDisplayString(attachment.file_size) + ")", 1),
                                                    _createVNode("a", {
                                                      href: "javascript:void(0)",
                                                      class: "btn default-btn d-block mt-1 btn-sm",
                                                      onClick: ($event: any) => (_ctx.downloadFile(attachment.file_link))
                                                    }, [
                                                      _hoisted_482,
                                                      _hoisted_483
                                                    ], 8, ["onClick"])
                                                  ])
                                                ])),
                                          _createVNode("a", {
                                            href: "javascript:void(0)",
                                            class: "remove-image",
                                            onClick: ($event: any) => (_ctx.deleteReplyImage(_ctx.response, attachment))
                                          }, [
                                            _hoisted_484
                                          ], 8, ["onClick"])
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_485, [
                                          _createVNode("img", {
                                            src: _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                            : 'img/deletedimage.jpg'
                            ,
                                            alt: ""
                                          }, null, 8, ["src"]),
                                          _createVNode("div", _hoisted_486, [
                                            _createVNode("p", null, [
                                              _createVNode("strong", null, _toDisplayString(attachment.file_name), 1),
                                              _hoisted_487,
                                              _hoisted_488
                                            ]),
                                            _createVNode("p", null, [
                                              _hoisted_489,
                                              _createVNode("strong", null, _toDisplayString(attachment.deleted_at), 1)
                                            ])
                                          ])
                                        ]))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_490, [
                    _createVNode("span", null, _toDisplayString(_ctx.state?.data?.selectedReplyUser?.responses?.length) + " Replies", 1)
                  ]),
                  (_ctx.state.data.selectedReplyUser.responses &&
              _ctx.state.data.selectedReplyUser.responses.length
            )
                    ? (_openBlock(), _createBlock("div", _hoisted_491, [
                        _createVNode("div", {
                          id: "thread-chat-body-content",
                          ref: "chatReplyThreadBody",
                          onScrollPassive: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.handleThreadScroll && _ctx.handleThreadScroll(...args)))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedReplyUser.responses, (response, responseIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "chat-block",
                              key: responseIndex,
                              id: `reply-${response.id}`
                            }, [
                              _createVNode("div", _hoisted_492, [
                                _createVNode("div", null, [
                                  _createVNode("div", _hoisted_493, [
                                    (response.response_by.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          src: response.response_by.image,
                                          alt: "",
                                          title: response.response_by.email
                                        }, null, 8, ["src", "title"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg'
                          ,
                                          alt: "",
                                          title: response.response_by.email
                                        }, null, 8, ["src", "title"]))
                                  ]),
                                  _createVNode("div", _hoisted_494, [
                                    (response.deleted_at)
                                      ? (_openBlock(), _createBlock("div", _hoisted_495, [
                                          _createVNode("h5", null, [
                                            _createTextVNode(_toDisplayString(response.response_by.full_name) + " ", 1),
                                            _createVNode("span", _hoisted_496, _toDisplayString(response.sentDate), 1)
                                          ]),
                                          _createVNode("p", null, [
                                            _hoisted_497,
                                            _createVNode("small", _hoisted_498, " (Deleted at: " + _toDisplayString(response.deleted_at) + ")", 1)
                                          ])
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_499, [
                                          _createVNode("h5", null, [
                                            _createTextVNode(_toDisplayString(response.response_by.full_name) + " ", 1),
                                            _createVNode("span", _hoisted_500, _toDisplayString(response.sentDate), 1)
                                          ]),
                                          (response.message)
                                            ? (_openBlock(), _createBlock("p", {
                                                key: 0,
                                                innerHTML: `${response.message}`
                                              }, null, 8, ["innerHTML"]))
                                            : _createCommentVNode("", true)
                                        ])),
                                    (response.attachments && response.attachments.length)
                                      ? (_openBlock(), _createBlock("div", _hoisted_501, [
                                          _createVNode("ul", null, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(response.attachments, (attachment, atcIndex) => {
                                              return (_openBlock(), _createBlock("li", { key: atcIndex }, [
                                                _createVNode("div", _hoisted_502, [
                                                  (!attachment.deleted_at)
                                                    ? (_openBlock(), _createBlock("div", _hoisted_503, [
                                                        (attachment.file_type === 'jpg' ||
                                    attachment.file_type === 'jpeg' ||
                                    attachment.file_type === 'png' || attachment.file_type === 'webp')
                                                          ? (_openBlock(), _createBlock("div", _hoisted_504, [
                                                              _createVNode("div", {
                                                                class: "same-ht-img",
                                                                onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(attachment))
                                                              }, [
                                                                _createVNode("img", {
                                                                  src: attachment.file_link,
                                                                  alt: "",
                                                                  height: "150",
                                                                  width: "180"
                                                                }, null, 8, ["src"])
                                                              ], 8, ["onClick"]),
                                                              _createVNode("div", _hoisted_505, [
                                                                _createVNode("p", _hoisted_506, _toDisplayString(attachment.file_name), 1),
                                                                _createVNode("p", null, "(" + _toDisplayString(attachment.file_size) + ")", 1)
                                                              ])
                                                            ]))
                                                          : (attachment.file_type === 'xls' ||
                                    attachment.file_type === 'xlsx' ||
                                    attachment.file_type === 'pdf' ||
                                    attachment.file_type === 'doc' ||
                                    attachment.file_type === 'docx' ||
                                    attachment.file_type === 'mp4' ||
                                    attachment.file_type === 'Mp4' ||
                                    attachment.file_type === 'mov' ||
                                    attachment.file_type === 'MOV' ||
                                    attachment.file_type === 'wmv' ||
                                    attachment.file_type === 'webm' ||
                                    attachment.file_type === 'ogg' ||
                                    attachment.file_type === 'avi' ||
                                    attachment.file_type === 'x-ms-wmv'
                                  )
                                                            ? (_openBlock(), _createBlock("div", _hoisted_507, [
                                                                _createVNode("div", {
                                                                  class: "same-ht-img",
                                                                  onClick: ($event: any) => (_ctx.viewSelectSharedDocuments(attachment))
                                                                }, [
                                                                  _createVNode("embed", {
                                                                    src: attachment.file_link,
                                                                    frameBorder: "0",
                                                                    scrolling: "auto",
                                                                    height: "150",
                                                                    width: "180"
                                                                  }, null, 8, ["src"])
                                                                ], 8, ["onClick"]),
                                                                _createVNode("div", _hoisted_508, [
                                                                  _createVNode("p", _hoisted_509, _toDisplayString(attachment.file_name), 1),
                                                                  _createVNode("p", null, "(" + _toDisplayString(attachment.file_size) + ")", 1)
                                                                ])
                                                              ]))
                                                            : (_openBlock(), _createBlock("div", _hoisted_510, [
                                                                _createVNode("div", {
                                                                  class: "same-ht-img",
                                                                  onClick: ($event: any) => (_ctx.downloadFile(attachment.file_link))
                                                                }, [
                                                                  _createVNode("img", {
                                                                    src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/file.jpg` : 'img/file.jpg',
                                                                    alt: ""
                                                                  }, null, 8, ["src"])
                                                                ], 8, ["onClick"]),
                                                                _createVNode("div", _hoisted_511, [
                                                                  _createVNode("p", _hoisted_512, _toDisplayString(attachment.file_name), 1),
                                                                  _createVNode("p", null, "(" + _toDisplayString(attachment.file_size) + ")", 1),
                                                                  _createVNode("a", {
                                                                    href: "javascript:void(0)",
                                                                    class: "btn default-btn d-block mt-1 btn-sm",
                                                                    onClick: ($event: any) => (_ctx.downloadFile(attachment.file_link))
                                                                  }, [
                                                                    _hoisted_513,
                                                                    _hoisted_514
                                                                  ], 8, ["onClick"])
                                                                ])
                                                              ])),
                                                        (_ctx.channelStatus)
                                                          ? (_openBlock(), _createBlock("a", {
                                                              key: 3,
                                                              href: "javascript:void(0)",
                                                              class: "remove-image",
                                                              onClick: ($event: any) => (_ctx.deleteReplyImage(response, attachment))
                                                            }, [
                                                              _hoisted_515
                                                            ], 8, ["onClick"]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createBlock("div", _hoisted_516, [
                                                        _createVNode("img", {
                                                          src: _ctx.state.data.imageBaseUrl
                                    ? `${_ctx.state.data.imageBaseUrl}img/deletedimage.jpg`
                                    : 'img/deletedimage.jpg'
                                    ,
                                                          alt: ""
                                                        }, null, 8, ["src"]),
                                                        _createVNode("div", _hoisted_517, [
                                                          _createVNode("p", null, [
                                                            _createVNode("strong", null, _toDisplayString(attachment.file_name), 1),
                                                            _hoisted_518,
                                                            _hoisted_519
                                                          ]),
                                                          _createVNode("p", null, [
                                                            _hoisted_520,
                                                            _createVNode("strong", null, _toDisplayString(attachment.deleted_at), 1)
                                                          ])
                                                        ])
                                                      ]))
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_521
                                  ]),
                                  (response.messageSendStatus)
                                    ? (_openBlock(), _createBlock("div", _hoisted_522, [
                                        _hoisted_523
                                      ]))
                                    : _createCommentVNode("", true),
                                  (response.message_status === 0 && (response.message_receivers && response.message_receivers.length === 0) && !response.messageSendStatus && (response.response_by.email === _ctx.state.activeUserDetails.email))
                                    ? (_openBlock(), _createBlock("div", _hoisted_524, [
                                        _hoisted_525
                                      ]))
                                    : _createCommentVNode("", true),
                                  (response.message_receivers && response.message_receivers.length > 0)
                                    ? (_openBlock(), _createBlock("div", _hoisted_526, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(response.message_receivers.slice(0, 1), (msgMember, msgMemberIndex) => {
                                          return (_openBlock(), _createBlock("a", {
                                            title: msgMember.status === 2 ? `Seen by ${msgMember.email}` : `Delivered to ${msgMember.email}`,
                                            href: "javascript:void(0)",
                                            key: msgMemberIndex
                                          }, [
                                            (msgMember.email != _ctx.state.activeUserDetails.email)
                                              ? (_openBlock(), _createBlock("div", _hoisted_527, [
                                                  (msgMember.status === 1)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_528, [
                                                        _createVNode("span", null, [
                                                          _createVNode("img", {
                                                            src: msgMember.image,
                                                            alt: msgMember.email,
                                                            title: `Delivered to ${msgMember.email}`
                                                          }, null, 8, ["src", "alt", "title"])
                                                        ])
                                                      ]))
                                                    : (_openBlock(), _createBlock("span", _hoisted_529, [
                                                        (msgMember.status === 2)
                                                          ? (_openBlock(), _createBlock("span", _hoisted_530, [
                                                              _hoisted_531
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        _createVNode("span", null, [
                                                          _createVNode("img", {
                                                            src: msgMember.image,
                                                            alt: msgMember.email,
                                                            title: `Seen by ${msgMember.email}`
                                                          }, null, 8, ["src", "alt", "title"])
                                                        ])
                                                      ]))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 8, ["title"]))
                                        }), 128)),
                                        (response.message_receivers.length > 1)
                                          ? (_openBlock(), _createBlock("a", {
                                              key: 0,
                                              href: "javascript:void(0)",
                                              onClick: ($event: any) => (_ctx.allMessageReceivers(response.message_receivers))
                                            }, [
                                              _createVNode("span", _hoisted_532, "+" + _toDisplayString(response.message_receivers.length - 1), 1)
                                            ], 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (response.allowEdit && _ctx.showEditor)
                                  ? (_openBlock(), _createBlock("div", _hoisted_533, [
                                      _createVNode("div", _hoisted_534, [
                                        _createVNode(_component_Editor, {
                                          showEnterSetting: false,
                                          onEnterSetting: _ctx.enterSetting,
                                          onEnterKeyPressed: _ctx.editChatCommunicationEnterSetting,
                                          modelValue: response.message,
                                          "onUpdate:modelValue": ($event: any) => (response.message = $event)
                                        }, null, 8, ["onEnterSetting", "onEnterKeyPressed", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _createVNode("div", _hoisted_535, [
                                        (!_ctx.enableEnterKey)
                                          ? (_openBlock(), _createBlock("p", _hoisted_536, [
                                              _hoisted_537
                                            ]))
                                          : (_openBlock(), _createBlock("p", _hoisted_538, [
                                              _hoisted_539
                                            ]))
                                      ]),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        class: "btn default-btn mr-2",
                                        onClick: _withModifiers(($event: any) => (
                        _ctx.sendEditedReplyCommunication(response)
                        ), ["prevent"])
                                      }, "Send ", 8, ["onClick"]),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        class: "btn secondary-btn",
                                        onClick: ($event: any) => (_ctx.cancelSelectedEdit(response))
                                      }, "Cancel", 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.channelStatus && _ctx.showEditor)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                      (!response.deleted_at && (response.response_by.email == _ctx.state.email))
                                        ? (_openBlock(), _createBlock("div", _hoisted_540, [
                                            _createVNode("a", {
                                              class: "round-icon  mr-1",
                                              onClick: ($event: any) => (_ctx.selctedReplyCommunication(response))
                                            }, [
                                              _hoisted_541
                                            ], 8, ["onClick"]),
                                            _createVNode("a", {
                                              class: "round-icon",
                                              onClick: ($event: any) => (_ctx.deleteReplyMessage(response))
                                            }, [
                                              _hoisted_542
                                            ], 8, ["onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ], 8, ["id"]))
                          }), 128))
                        ], 544)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.channelStatus && _ctx.showEditor)
                ? (_openBlock(), _createBlock("div", _hoisted_543, [
                    _createVNode("div", _hoisted_544, [
                      (_ctx.state.data.replyClassStatus)
                        ? (_openBlock(), _createBlock(_component_Editor, {
                            key: 0,
                            loading: _ctx.state.ui.isPostLoading.replyMessage,
                            showEnterSetting: false,
                            onEnterSetting: _ctx.enterSetting,
                            onEnterKeyPressed: _ctx.replyChatCommunicationEnterSetting,
                            modelValue: _ctx.state.data.replyMessage,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.state.data.replyMessage = $event)),
                            onPaste: _ctx.handleReplyInputChatMessage
                          }, null, 8, ["loading", "onEnterSetting", "onEnterKeyPressed", "modelValue", "onPaste"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_545, [
                        _createVNode("ul", null, [
                          (!_ctx.isReplyRecording && !_ctx.state.isFirefox)
                            ? (_openBlock(), _createBlock("li", _hoisted_546, [
                                _createVNode("div", {
                                  class: "mic-icons",
                                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.startReplyRecording && _ctx.startReplyRecording(...args)))
                                }, [
                                  _hoisted_547
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.isFirefox)
                            ? (_openBlock(), _createBlock("li", _hoisted_548, [
                                _hoisted_549
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isReplyRecording)
                            ? (_openBlock(), _createBlock("li", _hoisted_550, [
                                _createVNode("div", {
                                  class: "ripple-effect-icon",
                                  onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.stopReplyRecording && _ctx.stopReplyRecording(...args)))
                                }, [
                                  _hoisted_551
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("li", null, [
                            _createVNode("button", {
                              onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.showSendTemplate && _ctx.showSendTemplate(...args))),
                              class: "add-templete-btn",
                              title: "Add Template"
                            }, [
                              _hoisted_552
                            ])
                          ]),
                          _createVNode("li", null, [
                            _hoisted_553,
                            _createVNode("input", {
                              type: "file",
                              id: "thread-photo-add",
                              multiple: "",
                              accept: "*.*",
                              onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onDocumentUploadThread($event)))
                            }, null, 32)
                          ]),
                          _createVNode("li", null, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: !_ctx.state.threadImageList.length && !_ctx.relySelectedMessage
                    ? 'btn default-btn disabled'
                    : 'btn default-btn'
                    ,
                              onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.replyMessage && _ctx.replyMessage(...args)))
                            }, [
                              (!_ctx.state.ui.isPostLoading.replyMessage)
                                ? (_openBlock(), _createBlock("span", _hoisted_554, " Send "))
                                : (_openBlock(), _createBlock("span", _hoisted_555, [
                                    _hoisted_556
                                  ]))
                            ], 2)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_557, [
                      (!_ctx.enableEnterKey)
                        ? (_openBlock(), _createBlock("p", _hoisted_558, [
                            _hoisted_559
                          ]))
                        : (_openBlock(), _createBlock("p", _hoisted_560, [
                            _hoisted_561
                          ])),
                      (_ctx.state.threadImageList && _ctx.state.threadImageList.length)
                        ? (_openBlock(), _createBlock(_component_MyDriveFilesUpload, {
                            key: 2,
                            imageList: _ctx.state.threadImageList,
                            dataFrom: 'reply',
                            dataClass: 'col-lg-12 col-sm-6 px-2',
                            onUploadImage: _ctx.getReadyThreadImageListToUpload,
                            onLatestEnabledTags: _ctx.latestEnabledTags,
                            onRemoveSelectedImage: _ctx.removeSelectedThreadImage,
                            onOpenModal: _ctx.openRenameModal
                          }, null, 8, ["imageList", "onUploadImage", "onLatestEnabledTags", "onRemoveSelectedImage", "onOpenModal"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createVNode("div", _hoisted_562, [
            _createVNode("div", _hoisted_563, [
              _createVNode("div", _hoisted_564, [
                _createVNode("div", _hoisted_565, [
                  _createVNode("div", _hoisted_566, [
                    _hoisted_567,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_568
                    ])
                  ]),
                  _createVNode("div", _hoisted_569, [
                    _createVNode("div", _hoisted_570, [
                      _createVNode(_component_ErrorList, {
                        errors: _ctx.state.errorList,
                        hasError: _ctx.state.isErrorStatus
                      }, null, 8, ["errors", "hasError"]),
                      (!_ctx.state.data.invitationVerify.showStatus)
                        ? (_openBlock(), _createBlock("div", _hoisted_571, [
                            _createVNode("div", _hoisted_572, [
                              _createVNode("ul", null, [
                                _createVNode("li", null, [
                                  (!_ctx.state.data.inviteAsPublicUser)
                                    ? (_openBlock(), _createBlock("div", _hoisted_573, [
                                        _createVNode("div", _hoisted_574, [
                                          _withDirectives(_createVNode("input", {
                                            type: "checkbox",
                                            class: "custom-control-input",
                                            id: "guestSwitch",
                                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.state.data.inviteAsGuest = $event))
                                          }, null, 512), [
                                            [_vModelCheckbox, _ctx.state.data.inviteAsGuest]
                                          ]),
                                          _hoisted_575
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode("li", null, [
                                  (!_ctx.state.data.inviteAsGuest)
                                    ? (_openBlock(), _createBlock("div", _hoisted_576, [
                                        _createVNode("div", _hoisted_577, [
                                          _withDirectives(_createVNode("input", {
                                            type: "checkbox",
                                            class: "custom-control-input",
                                            id: "guestSwitch1",
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.state.data.inviteAsPublicUser = $event))
                                          }, null, 512), [
                                            [_vModelCheckbox, _ctx.state.data.inviteAsPublicUser]
                                          ]),
                                          _hoisted_578
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            (!_ctx.state.data.inviteAsGuest &&
                    !_ctx.state.data.inviteAsPublicUser
                  )
                              ? (_openBlock(), _createBlock("div", _hoisted_579, [
                                  _hoisted_580,
                                  _createVNode(_component_multiselect, {
                                    modelValue: _ctx.selectedUsers,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.selectedUsers = $event)),
                                    options: _ctx.allUsers,
                                    "close-on-select": "true",
                                    "clear-on-select": true,
                                    placeholder: "Search and select",
                                    label: "email",
                                    "track-by": "email",
                                    onSelect: _cache[46] || (_cache[46] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                                  }, null, 8, ["modelValue", "options"]),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "email-tag",
                                      key: userIndex
                                    }, [
                                      _createVNode("p", _hoisted_581, [
                                        _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                        }, [
                                          _hoisted_582
                                        ], 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.state.data.inviteAsPublicUser)
                              ? (_openBlock(), _createBlock("div", _hoisted_583, [
                                  _hoisted_584,
                                  _createVNode("div", _hoisted_585, [
                                    _withDirectives(_createVNode("input", {
                                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.state.inviteMember = $event)),
                                      type: "email",
                                      class: "form-control",
                                      id: "exampleInputEmail1",
                                      "aria-describedby": "emailHelp",
                                      placeholder: "Type email and press enter or click add button",
                                      onKeyup: _cache[48] || (_cache[48] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                                    }, null, 544), [
                                      [_vModelText, _ctx.state.inviteMember]
                                    ]),
                                    _createVNode("button", {
                                      onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                                    }, [
                                      _hoisted_586
                                    ])
                                  ]),
                                  (_ctx.state.inputError)
                                    ? (_openBlock(), _createBlock("p", _hoisted_587, "Please fill below field"))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.duplicate)
                                    ? (_openBlock(), _createBlock("p", _hoisted_588, "This email is already used below"))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.invite.invites && _ctx.state.invite.invites.length)
                                    ? (_openBlock(), _createBlock("div", _hoisted_589, [
                                        _createVNode("table", _hoisted_590, [
                                          _hoisted_591,
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                                            return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                              _createVNode("tr", null, [
                                                _createVNode("td", null, [
                                                  _createVNode("div", _hoisted_592, [
                                                    _withDirectives(_createVNode("input", {
                                                      type: "email",
                                                      class: "form-control",
                                                      readonly: "",
                                                      "onUpdate:modelValue": ($event: any) => (invite.email = $event)
                                                    }, null, 8, ["onUpdate:modelValue"]), [
                                                      [_vModelText, invite.email]
                                                    ])
                                                  ])
                                                ]),
                                                _createVNode("td", null, [
                                                  _createVNode("div", _hoisted_593, [
                                                    _withDirectives(_createVNode("input", {
                                                      type: "text",
                                                      class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                                      "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                                    }, null, 10, ["onUpdate:modelValue"]), [
                                                      [_vModelText, invite.first_name]
                                                    ])
                                                  ])
                                                ]),
                                                _createVNode("td", null, [
                                                  _createVNode("div", _hoisted_594, [
                                                    _withDirectives(_createVNode("input", {
                                                      type: "text",
                                                      class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                                      "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                                    }, null, 10, ["onUpdate:modelValue"]), [
                                                      [_vModelText, invite.last_name]
                                                    ])
                                                  ])
                                                ]),
                                                _createVNode("td", null, [
                                                  _createVNode("a", {
                                                    href: "javascript:void(0)",
                                                    onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                                  }, [
                                                    _hoisted_595
                                                  ], 8, ["onClick"])
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_596, [
                                  _hoisted_597,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.inviteAsPublic, (publicMember, indexPublicMember) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "row mb-3",
                                      key: indexPublicMember
                                    }, [
                                      _createVNode("div", _hoisted_598, [
                                        _createVNode("div", _hoisted_599, [
                                          _hoisted_600,
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "exampleFullName",
                                            placeholder: "Your Full Name",
                                            "onUpdate:modelValue": ($event: any) => (publicMember.name = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, publicMember.name]
                                          ])
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_601, [
                                        _createVNode("div", _hoisted_602, [
                                          _hoisted_603,
                                          _withDirectives(_createVNode("input", {
                                            type: "email",
                                            class: "form-control",
                                            id: "exampleEmailInput",
                                            placeholder: "abc@convorally.com",
                                            "onUpdate:modelValue": ($event: any) => (publicMember.email = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, publicMember.email]
                                          ])
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_604, [
                                        _createVNode("div", _hoisted_605, [
                                          _hoisted_606,
                                          _createVNode("div", _hoisted_607, [
                                            _hoisted_608,
                                            _withDirectives(_createVNode("input", {
                                              type: "number",
                                              class: "form-control",
                                              id: "exampleMobileNumber",
                                              placeholder: "mobile number only",
                                              "onUpdate:modelValue": ($event: any) => (publicMember.phone = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, publicMember.phone]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_609, [
                                        _hoisted_610,
                                        _createVNode("div", _hoisted_611, [
                                          _createVNode("div", _hoisted_612, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: "inlineCheckbox1",
                                              value: "true",
                                              "onUpdate:modelValue": ($event: any) => (publicMember.mailNotification = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, publicMember.mailNotification]
                                            ]),
                                            _hoisted_613
                                          ]),
                                          _createVNode("div", _hoisted_614, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: "inlineCheckbox2",
                                              value: "true",
                                              "onUpdate:modelValue": ($event: any) => (publicMember.smsNotification = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, publicMember.smsNotification]
                                            ]),
                                            _hoisted_615
                                          ])
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_616, [
                                        (indexPublicMember + 1 ==
                          _ctx.state.inviteAsPublic.length ||
                          _ctx.state.inviteAsPublic.length === 1
                        )
                                          ? (_openBlock(), _createBlock("button", {
                                              key: 0,
                                              class: "add-invite-section-btn",
                                              onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.changeInvitePublicMember && _ctx.changeInvitePublicMember(...args)))
                                            }, [
                                              _hoisted_617
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.state.inviteAsPublic &&
                          _ctx.state.inviteAsPublic.length > 1
                        )
                                          ? (_openBlock(), _createBlock("a", {
                                              key: 1,
                                              class: "text-danger",
                                              onClick: ($event: any) => (_ctx.deletePublicMember(publicMember)),
                                              href: "javascript:void(0)"
                                            }, [
                                              _hoisted_618
                                            ], 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: inviteIndex,
                                      class: "email-tag"
                                    }, [
                                      _createVNode("p", _hoisted_619, [
                                        _createTextVNode(_toDisplayString(invite) + " ", 1),
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                        }, [
                                          _hoisted_620
                                        ], 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_621, [
                            (_ctx.state.data.invitationVerify.registeredMemberList &&
                    _ctx.state.data.invitationVerify.registeredMemberList.length
                  )
                              ? (_openBlock(), _createBlock("div", _hoisted_622, [
                                  _createVNode("div", _hoisted_623, [
                                    _hoisted_624,
                                    _createVNode("ul", _hoisted_625, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .invitationVerify.registeredMemberList, (regMember, index) => {
                                        return (_openBlock(), _createBlock("li", { key: index }, [
                                          _createVNode("small", null, _toDisplayString(regMember), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.invitationVerify.pendingMemberList &&
                    _ctx.state.data.invitationVerify.pendingMemberList.length
                  )
                              ? (_openBlock(), _createBlock("div", _hoisted_626, [
                                  _createVNode("div", _hoisted_627, [
                                    _hoisted_628,
                                    _createVNode("ul", _hoisted_629, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .invitationVerify.pendingMemberList, (regMember, index) => {
                                        return (_openBlock(), _createBlock("li", { key: index }, [
                                          _createVNode("small", null, _toDisplayString(regMember), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.invitationVerify.newMemberList &&
                    _ctx.state.data.invitationVerify.newMemberList.length
                  )
                              ? (_openBlock(), _createBlock("div", _hoisted_630, [
                                  _createVNode("div", _hoisted_631, [
                                    _hoisted_632,
                                    _createVNode("ul", _hoisted_633, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .invitationVerify.newMemberList, (regMember, index) => {
                                        return (_openBlock(), _createBlock("li", { key: index }, [
                                          _createVNode("small", null, _toDisplayString(regMember), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ])
                  ]),
                  _createVNode("div", _hoisted_634, [
                    (!_ctx.state.data.invitationVerify.showStatus &&
                !_ctx.state.data.inviteAsPublicUser
              )
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.inviteAllUsers && _ctx.inviteAllUsers(...args)))
                        }, _toDisplayString(_ctx.state.ui.isPostLoading.verifyInvitation
                ? "Inviting..."
                : "Done"), 1))
                      : _createCommentVNode("", true),
                    (_ctx.state.data.inviteAsPublicUser)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "btn default-btn",
                          onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.inviteAllPublicUser && _ctx.inviteAllPublicUser(...args)))
                        }, "Done"))
                      : _createCommentVNode("", true),
                    (_ctx.state.data.invitationVerify.showStatus)
                      ? (_openBlock(), _createBlock("div", _hoisted_635, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            class: "btn secondary-btn mr-2",
                            onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.backInvitation && _ctx.backInvitation(...args)))
                          }, "Back"),
                          ((_ctx.state.data.invitationVerify.newMemberList &&
                  _ctx.state.data.invitationVerify.newMemberList.length) ||
                  (_ctx.state.data.invitationVerify.pendingMemberList &&
                    _ctx.state.data.invitationVerify.pendingMemberList.length)
                )
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "btn default-btn",
                                onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.inviteAllUsers && _ctx.inviteAllUsers(...args)))
                              }, _toDisplayString(_ctx.state.isLoading.inviteAllUsers ? "Sending..." : "Send"), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_636, [
            _createVNode("div", _hoisted_637, [
              _createVNode("div", _hoisted_638, [
                _createVNode("div", _hoisted_639, [
                  _createVNode("div", _hoisted_640, [
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.closeInvitationModal && _ctx.closeInvitationModal(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_641
                    ]),
                    _hoisted_642
                  ]),
                  _createVNode("div", _hoisted_643, [
                    _hoisted_644,
                    _createVNode("p", null, _toDisplayString(_ctx.state.invitationMessage), 1)
                  ]),
                  _createVNode("div", _hoisted_645, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn default-btn outline",
                      onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.addNewMemberToChannel && _ctx.addNewMemberToChannel(...args)))
                    }, "Invite more people"),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn default-btn outline danger",
                      "data-dismiss": "modal",
                      onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.closeInvitationModal && _ctx.closeInvitationModal(...args)))
                    }, "Close")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_646, [
            _createVNode("div", _hoisted_647, [
              _createVNode("div", _hoisted_648, [
                _createVNode("div", _hoisted_649, [
                  _hoisted_650,
                  _createVNode("div", _hoisted_651, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.pendingList, (member, pendingMemberIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "row align-items-center",
                        key: pendingMemberIndex
                      }, [
                        _createVNode("div", _hoisted_652, [
                          _createVNode("div", _hoisted_653, [
                            _createVNode("div", _hoisted_654, [
                              (member.user && member.user.image)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: member.user.image,
                                    alt: ""
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                        : 'img/no-user.jpg'
                        ,
                                    alt: ""
                                  }, null, 8, ["src"]))
                            ]),
                            (member && member.email)
                              ? (_openBlock(), _createBlock("p", _hoisted_655, _toDisplayString(member.email), 1))
                              : _createCommentVNode("", true),
                            (member && member.phone || member && member.mobile)
                              ? (_openBlock(), _createBlock("p", _hoisted_656, _toDisplayString(member.phone || member.mobile), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.isUserStatus && _ctx.state?.data?.projectDetail?.project?.status_id !== 2)
                          ? (_openBlock(), _createBlock("div", _hoisted_657, [
                              _createVNode("a", {
                                class: "btn default-btn outline orange p-1 mr-2",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.modifyUserConversationHistoryDate(member))
                              }, [
                                _hoisted_658
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                class: "btn default-btn outline orange p-1 mr-2",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.selectPendingMemberForDeletes(member))
                              }, [
                                _hoisted_659
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                class: "btn default-btn outline p-1",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.showResendInvitationConfirmation(member))
                              }, [
                                _hoisted_660
                              ], 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _hoisted_661
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_662, [
            _createVNode("div", _hoisted_663, [
              _createVNode("div", _hoisted_664, [
                _createVNode("div", _hoisted_665, [
                  _createVNode("div", _hoisted_666, [
                    _hoisted_667,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateupload && _ctx.hideTemplateupload(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_668
                    ])
                  ]),
                  _createVNode("div", _hoisted_669, [
                    _createVNode("div", _hoisted_670, [
                      _hoisted_671,
                      _createVNode("div", _hoisted_673, [
                        _hoisted_674,
                        _createVNode("div", _hoisted_675, [
                          _createVNode("div", _hoisted_676, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn default-btn outline",
                              onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.redirectToDynamicForm && _ctx.redirectToDynamicForm(...args))),
                              "data-dismiss": "modal"
                            }, [
                              _hoisted_677,
                              _hoisted_678
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_679, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "eg.Kitchen template, House template,etc",
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.state.searchBy = $event)),
                          onKeyup: _cache[61] || (_cache[61] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getChannelFormList && _ctx.getChannelFormList(...args)), ["enter"])),
                          onKeydown: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.getChannelFormList && _ctx.getChannelFormList(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.state.searchBy]
                        ]),
                        _hoisted_680
                      ]),
                      _hoisted_681,
                      _createVNode("div", _hoisted_682, [
                        _createVNode("div", _hoisted_683, [
                          _withDirectives(_createVNode("input", {
                            type: "radio",
                            id: "all",
                            name: "gender",
                            value: "all",
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.state.filter.type = $event)),
                            onChange: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.getChannelFormList && _ctx.getChannelFormList(...args)))
                          }, null, 544), [
                            [_vModelRadio, _ctx.state.filter.type]
                          ]),
                          _hoisted_684
                        ]),
                        _createVNode("div", _hoisted_685, [
                          _withDirectives(_createVNode("input", {
                            type: "radio",
                            id: "sent_by_me",
                            name: "gender",
                            value: "sent_by_me",
                            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.state.filter.type = $event)),
                            onChange: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.getChannelFormList && _ctx.getChannelFormList(...args)))
                          }, null, 544), [
                            [_vModelRadio, _ctx.state.filter.type]
                          ]),
                          _hoisted_686
                        ]),
                        _createVNode("div", _hoisted_687, [
                          _withDirectives(_createVNode("input", {
                            type: "radio",
                            id: "sent_to_me",
                            name: "gender",
                            value: "sent_to_me",
                            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.state.filter.type = $event)),
                            onChange: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.getChannelFormList && _ctx.getChannelFormList(...args)))
                          }, null, 544), [
                            [_vModelRadio, _ctx.state.filter.type]
                          ]),
                          _hoisted_688
                        ])
                      ]),
                      _createVNode("div", _hoisted_689, [
                        _createVNode("table", _hoisted_690, [
                          _hoisted_691,
                          (_ctx.templateList)
                            ? (_openBlock(), _createBlock("tbody", _hoisted_692, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (form, formIndex) => {
                                  return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                                    _createVNode("td", _hoisted_693, [
                                      _createVNode("div", null, [
                                        (form.title)
                                          ? (_openBlock(), _createBlock("h5", _hoisted_694, _toDisplayString(form.title), 1))
                                          : (_openBlock(), _createBlock("h5", _hoisted_695, "-")),
                                        (form.description)
                                          ? (_openBlock(), _createBlock("p", _hoisted_696, _toDisplayString(form.description), 1))
                                          : (_openBlock(), _createBlock("p", _hoisted_697, "-"))
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      (form.sentToUsers && form.sentToUsers.length)
                                        ? (_openBlock(), _createBlock("div", _hoisted_698, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.sentToUsers, (user, userIndex) => {
                                              return (_openBlock(), _createBlock("span", {
                                                class: "email-text",
                                                key: userIndex
                                              }, [
                                                _createTextVNode(_toDisplayString(user.email), 1),
                                                (userIndex < form.sentToUsers.length - 1)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_699, ", "))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("p", null, _toDisplayString(form.created_date), 1)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("p", null, _toDisplayString(form.updated_date), 1)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_700, [
                                        _createVNode("a", {
                                          title: "Edit & Send",
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.selectEditForm(form)),
                                          "data-dismiss": "modal",
                                          class: "btn default-btn outline secondary"
                                        }, [
                                          _hoisted_701
                                        ], 8, ["onClick"]),
                                        _createVNode("a", {
                                          title: "Send to",
                                          href: "javascript:void(0)",
                                          class: "btn default-btn mr-0 outline",
                                          "data-dismiss": "modal",
                                          onClick: ($event: any) => (_ctx.selectForm(form))
                                        }, [
                                          _hoisted_702
                                        ], 8, ["onClick"])
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.templateList && !_ctx.templateList.length)
                            ? (_openBlock(), _createBlock("tfoot", _hoisted_703, [
                                _hoisted_704
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_705, [
                          _createVNode("nav", _hoisted_706, [
                            _createVNode(_component_v_pagination, {
                              modelValue: _ctx.state.item.paging.getChannelFormList.currentPage
                        ,
                              "onUpdate:modelValue": [
                                _cache[69] || (_cache[69] = ($event: any) => (_ctx.state.item.paging.getChannelFormList.currentPage
                         = $event)),
                                _ctx.nextPage
                              ],
                              pages: _ctx.state.item.paging.getChannelFormList.totalPages,
                              "range-size": 1,
                              "active-color": "#DCEDFF"
                            }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_707, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      "data-dismiss": "modal",
                      onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateupload && _ctx.hideTemplateupload(...args)))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_708, [
            _createVNode("div", _hoisted_709, [
              _createVNode("div", _hoisted_710, [
                _createVNode("div", _hoisted_711, [
                  _createVNode("div", _hoisted_712, [
                    _hoisted_713,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      onClick: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.hideDigitizedtemplate && _ctx.hideDigitizedtemplate(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_714
                    ])
                  ]),
                  _createVNode("div", _hoisted_715, [
                    _createVNode("div", _hoisted_716, [
                      _hoisted_717,
                      _createVNode("div", _hoisted_719, [
                        _hoisted_720,
                        _createVNode("div", _hoisted_721, [
                          _createVNode("div", _hoisted_722, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn default-btn outline",
                              onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.redirectToDynamicForm && _ctx.redirectToDynamicForm(...args))),
                              "data-dismiss": "modal"
                            }, [
                              _hoisted_723,
                              _hoisted_724
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_725, [
                        (_ctx.state.data.clientDocuments &&
                    _ctx.state.data.clientDocuments.length
                  )
                          ? (_openBlock(), _createBlock("table", _hoisted_726, [
                              _hoisted_727,
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                        .clientDocuments, (document, documentIndex) => {
                                  return (_openBlock(), _createBlock("tr", { key: documentIndex }, [
                                    _createVNode("td", null, [
                                      _createVNode("p", null, [
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: ($event: any) => (_ctx.openPdf(document.file_path))
                                        }, [
                                          _createTextVNode(_toDisplayString(document.name) + " ", 1),
                                          _hoisted_728
                                        ], 8, ["onClick"]),
                                        _createVNode("small", null, [
                                          _createVNode("i", null, "(" + _toDisplayString(document.convertedFileSize) + ")", 1)
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      (document.client && document.client.email)
                                        ? (_openBlock(), _createBlock("p", _hoisted_729, [
                                            _createVNode("span", _hoisted_730, [
                                              (document.client.image)
                                                ? (_openBlock(), _createBlock("img", {
                                                    key: 0,
                                                    src: document.client.image,
                                                    alt: ""
                                                  }, null, 8, ["src"]))
                                                : (_openBlock(), _createBlock("img", {
                                                    key: 1,
                                                    src: _ctx.state.data.imageBaseUrl
                                ? `${_ctx.state.data.imageBaseUrl}img/avatar-1.jpg`
                                : 'img/avatar-1.jpg'
                                ,
                                                    alt: ""
                                                  }, null, 8, ["src"]))
                                            ]),
                                            _createTextVNode(" " + _toDisplayString(document.client.full_name), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("p", null, _toDisplayString(document.created_at), 1)
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        class: "btn default-btn mr-0 outline",
                                        onClick: ($event: any) => (_ctx.selectDigitizeForm(document))
                                      }, [
                                        _hoisted_731,
                                        _hoisted_732
                                      ], 8, ["onClick"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_733, [
                              _createVNode(_component_ChannelChatWelcomeMessage)
                            ]))
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_734, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      "data-dismiss": "modal",
                      onClick: _cache[73] || (_cache[73] = 
//@ts-ignore
(...args) => (_ctx.hideDigitizedtemplate && _ctx.hideDigitizedtemplate(...args)))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_735, [
            _createVNode("div", _hoisted_736, [
              _createVNode("div", _hoisted_737, [
                _createVNode("div", _hoisted_738, [
                  _hoisted_739,
                  _createVNode("div", _hoisted_740, [
                    _createVNode("div", _hoisted_741, [
                      _createVNode("div", _hoisted_742, [
                        _createVNode("div", _hoisted_743, [
                          _createVNode("ul", null, [
                            _createVNode("li", {
                              onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.showTextFieldAdd('section', 'Section')))
                            }, [
                              _hoisted_744,
                              _hoisted_745
                            ]),
                            _createVNode("li", {
                              onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.showTextFieldAdd('textbox', 'Text Box')))
                            }, [
                              _hoisted_746,
                              _hoisted_747
                            ]),
                            _createVNode("li", {
                              onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.showTextFieldAdd('textArea', 'TextArea')))
                            }, [
                              _hoisted_748,
                              _hoisted_749
                            ]),
                            _createVNode("li", {
                              onClick: _cache[77] || (_cache[77] = ($event: any) => (
                        _ctx.showTextFieldAdd('single_select', 'Select Option')
                        ))
                            }, [
                              _hoisted_750,
                              _hoisted_751
                            ]),
                            _createVNode("li", {
                              onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.showTextFieldAdd('radioButton', 'Radio Button')))
                            }, [
                              _hoisted_752,
                              _hoisted_753
                            ]),
                            _createVNode("li", {
                              onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.showTextFieldAdd('checkBox', 'Check Box')))
                            }, [
                              _hoisted_754,
                              _hoisted_755
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_756, [
                        _createVNode("div", _hoisted_757, [
                          _createVNode("div", null, [
                            _createVNode(_component_ErrorList, {
                              errors: _ctx.state.item.error.erorList,
                              hasError: _ctx.state.item.hasError
                            }, null, 8, ["errors", "hasError"]),
                            _createVNode(_component_ErrorList, {
                              errors: _ctx.state.item.error.erorListNewForm,
                              hasError: _ctx.state.item.hasError
                            }, null, 8, ["errors", "hasError"]),
                            _createVNode("div", _hoisted_758, [
                              _createVNode("div", _hoisted_759, [
                                _createVNode("div", _hoisted_760, [
                                  _createVNode("div", _hoisted_761, [
                                    (_ctx.state.newFormData.title &&
                                _ctx.state.newFormData.title.length
                              )
                                      ? (_openBlock(), _createBlock("a", {
                                          key: 0,
                                          href: "javascript:void(0)",
                                          "data-toggle": "modal",
                                          onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.showNewTitleInCreateFormEdit('title')))
                                        }, [
                                          _hoisted_762
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_763,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "inputPassword",
                                    placeholder: "Title Here",
                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.state.newFormData.title = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.newFormData.title]
                                  ])
                                ]),
                                _createVNode("div", _hoisted_764, [
                                  _hoisted_765,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "inputPassword",
                                    placeholder: "Description here",
                                    "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => (_ctx.state.newFormData.description = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.newFormData.description]
                                  ])
                                ])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.newFormData
                          .elements, (form, formIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: formIndex,
                                  onClick: ($event: any) => (_ctx.selectedElement(form))
                                }, [
                                  _createVNode("div", _hoisted_766, [
                                    (form.type === 'section')
                                      ? (_openBlock(), _createBlock("div", _hoisted_767, [
                                          _createVNode("div", _hoisted_768, [
                                            _createVNode("div", _hoisted_769, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'section'))
                                              }, [
                                                _hoisted_770
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (
                                    _ctx.showNewElementDelete(form, 'section')
                                    )
                                              }, [
                                                _hoisted_771
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("h3", _hoisted_772, _toDisplayString(form.title), 1),
                                            _createVNode("h5", null, _toDisplayString(form.description), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'textbox')
                                      ? (_openBlock(), _createBlock("div", _hoisted_773, [
                                          _createVNode("div", _hoisted_774, [
                                            _createVNode("div", _hoisted_775, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'textbox'))
                                              }, [
                                                _hoisted_776
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (
                                    _ctx.showNewElementDelete(form, 'textbox')
                                    )
                                              }, [
                                                _hoisted_777
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("label", _hoisted_778, _toDisplayString(form.title), 1),
                                            _withDirectives(_createVNode("input", {
                                              readonly: "",
                                              "onUpdate:modelValue": ($event: any) => (form.answer = $event),
                                              type: "text",
                                              class: "form-control",
                                              id: "inputPassword"
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, form.answer]
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'textArea')
                                      ? (_openBlock(), _createBlock("div", _hoisted_779, [
                                          _createVNode("div", _hoisted_780, [
                                            _createVNode("div", _hoisted_781, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (
                                    _ctx.showNewElementEdit(form, 'textArea')
                                    )
                                              }, [
                                                _hoisted_782
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (
                                    _ctx.showNewElementDelete(form, 'textArea')
                                    )
                                              }, [
                                                _hoisted_783
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("label", _hoisted_784, _toDisplayString(form.title), 1),
                                            _withDirectives(_createVNode("input", {
                                              readonly: "",
                                              "onUpdate:modelValue": ($event: any) => (form.answer = $event),
                                              type: "text",
                                              class: "form-control",
                                              id: "inputPassword"
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, form.answer]
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'checkBox')
                                      ? (_openBlock(), _createBlock("div", _hoisted_785, [
                                          _createVNode("div", _hoisted_786, [
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              "data-toggle": "modal",
                                              onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'checkBox'))
                                            }, [
                                              _hoisted_787
                                            ], 8, ["onClick"]),
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              class: "trash",
                                              onClick: ($event: any) => (
                                  _ctx.showNewElementDelete(form, 'checkBox')
                                  )
                                            }, [
                                              _hoisted_788
                                            ], 8, ["onClick"])
                                          ]),
                                          _createVNode("label", null, _toDisplayString(form.title), 1),
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                            return (_openBlock(), _createBlock("div", {
                                              class: "form-check form-check-inline",
                                              key: optionIndex
                                            }, [
                                              _withDirectives(_createVNode("input", {
                                                disabled: "",
                                                type: "checkbox",
                                                id: "vehicle1",
                                                name: "vehicle1",
                                                value: option.text,
                                                "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                              }, null, 8, ["value", "onUpdate:modelValue"]), [
                                                [_vModelCheckbox, option.selected]
                                              ]),
                                              _createVNode("label", _hoisted_789, _toDisplayString(option.text), 1)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'radioButton')
                                      ? (_openBlock(), _createBlock("div", _hoisted_790, [
                                          _createVNode("div", _hoisted_791, [
                                            _createVNode("div", _hoisted_792, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (
                                    _ctx.showNewElementEdit(form, 'radioButton')
                                    )
                                              }, [
                                                _hoisted_793
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (
                                    _ctx.showNewElementDelete(form, 'radioButton')
                                    )
                                              }, [
                                                _hoisted_794
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("label", _hoisted_795, _toDisplayString(form.title), 1),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                              return (_openBlock(), _createBlock("div", {
                                                class: "\n                                                  custom-control\n                                                  custom-radio\n                                                  custom-control-inline\n                                                ",
                                                key: optionIndex
                                              }, [
                                                _withDirectives(_createVNode("input", {
                                                  disabled: "",
                                                  type: "radio",
                                                  name: "customRadioInline1",
                                                  value: option.text,
                                                  "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                                }, null, 8, ["value", "onUpdate:modelValue"]), [
                                                  [_vModelRadio, option.selected]
                                                ]),
                                                _createVNode("label", null, _toDisplayString(option.text), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'single_select')
                                      ? (_openBlock(), _createBlock("div", _hoisted_796, [
                                          _createVNode("div", _hoisted_797, [
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              "data-toggle": "modal",
                                              onClick: ($event: any) => (
                                  _ctx.showNewElementEdit(form, 'single_select')
                                  )
                                            }, [
                                              _hoisted_798
                                            ], 8, ["onClick"]),
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              class: "trash",
                                              onClick: ($event: any) => (
                                  _ctx.showNewElementDelete(form, 'single_select')
                                  )
                                            }, [
                                              _hoisted_799
                                            ], 8, ["onClick"])
                                          ]),
                                          _createVNode("label", _hoisted_800, _toDisplayString(form.title), 1),
                                          _createVNode("select", _hoisted_801, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                              return (_openBlock(), _createBlock("option", {
                                                selected: option.text === option.selected,
                                                value: option.value,
                                                key: optionIndex
                                              }, _toDisplayString(option.text), 9, ["selected", "value"]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 8, ["onClick"]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_802, [
                    _createVNode("div", _hoisted_803, [
                      _createVNode("div", _hoisted_804, [
                        _createVNode("div", _hoisted_805, [
                          _hoisted_806,
                          (_ctx.state.privacyList && _ctx.state.privacyList.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_807, [
                                _withDirectives(_createVNode("select", {
                                  class: "custom-select form-control",
                                  "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_ctx.state.newFormData.privacy = $event))
                                }, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.privacyList, (item, itemIndex) => {
                                    return (_openBlock(), _createBlock("option", {
                                      value: item,
                                      key: itemIndex
                                    }, _toDisplayString(item.name), 9, ["value"]))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.state.newFormData.privacy]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_808, [
                            _hoisted_809,
                            _createVNode("div", _hoisted_810, [
                              _createVNode("h5", null, _toDisplayString(_ctx.state.newFormData.privacy.value), 1),
                              _createVNode("p", _hoisted_811, _toDisplayString(_ctx.formPrivacyMessage), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_812, [
                        _createVNode("div", _hoisted_813, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn default-btn primary-btn",
                            onClick: _cache[84] || (_cache[84] = 
//@ts-ignore
(...args) => (_ctx.showUserModal && _ctx.showUserModal(...args)))
                          }, " Send to users "),
                          _createVNode("button", {
                            type: "button",
                            class: "btn default-btn",
                            onClick: _cache[85] || (_cache[85] = 
//@ts-ignore
(...args) => (_ctx.showNewFormConformation && _ctx.showNewFormConformation(...args)))
                          }, " Save Changes "),
                          _hoisted_814
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_815, [
            _createVNode("div", _hoisted_816, [
              _createVNode("div", _hoisted_817, [
                _createVNode("div", _hoisted_818, [
                  _createVNode("div", _hoisted_819, [
                    _hoisted_820,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[86] || (_cache[86] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteSelectedElementInCreateNew && _ctx.hideDeleteSelectedElementInCreateNew(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_821
                    ])
                  ]),
                  _hoisted_822,
                  _createVNode("div", _hoisted_823, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[87] || (_cache[87] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteSelectedElementInCreateNew && _ctx.hideDeleteSelectedElementInCreateNew(...args)))
                    }, " No "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[88] || (_cache[88] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedElementOfCreateForm && _ctx.deleteSelectedElementOfCreateForm(...args)))
                    }, " Yes ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_824, [
            _createVNode("div", _hoisted_825, [
              _createVNode("div", _hoisted_826, [
                _createVNode("div", _hoisted_827, [
                  _createVNode("div", _hoisted_828, [
                    (_ctx.state.selectedElement.type === 'title' ||
                _ctx.state.selectedElement.type === 'textbox' ||
                _ctx.state.selectedElement.type === 'textArea'
              )
                      ? (_openBlock(), _createBlock("h5", _hoisted_829, " Edit " + _toDisplayString(_ctx.state.selectedElement.title), 1))
                      : (_openBlock(), _createBlock("h5", _hoisted_830, " Edit " + _toDisplayString(_ctx.state.selectedElement.element.title), 1)),
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[89] || (_cache[89] = 
//@ts-ignore
(...args) => (_ctx.hideEditCreateNewForm && _ctx.hideEditCreateNewForm(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_831
                    ])
                  ]),
                  _createVNode("div", _hoisted_832, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorList,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_833, [
                      (_ctx.state.selectedElement.type === 'title')
                        ? (_openBlock(), _createBlock("div", _hoisted_834, [
                            _createVNode("div", _hoisted_835, [
                              _hoisted_836,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Title Here",
                                "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ]),
                            _createVNode("div", _hoisted_837, [
                              _hoisted_838,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Description here",
                                "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => (_ctx.state.selectedElement.description = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.description]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'section')
                        ? (_openBlock(), _createBlock("div", _hoisted_839, [
                            _createVNode("div", _hoisted_840, [
                              _hoisted_841,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ]),
                            _createVNode("div", _hoisted_842, [
                              _hoisted_843,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (_ctx.state.selectedElement.description = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.description]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'textbox')
                        ? (_openBlock(), _createBlock("div", _hoisted_844, [
                            _createVNode("div", _hoisted_845, [
                              _hoisted_846,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'textArea')
                        ? (_openBlock(), _createBlock("div", _hoisted_847, [
                            _createVNode("div", _hoisted_848, [
                              _hoisted_849,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => (_ctx.state.selectedElement.title = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword"
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'checkBox')
                        ? (_openBlock(), _createBlock("div", _hoisted_850, [
                            _createVNode("div", _hoisted_851, [
                              _createVNode("div", _hoisted_852, [
                                _hoisted_853,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedElement.element.title]
                                ])
                              ]),
                              (_ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_854, [
                                    _hoisted_855,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_856, [
                                          _createVNode("div", _hoisted_857, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              name: "exampleRadios",
                                              id: "exampleRadios1",
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_858, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_859, [
                                          _createVNode("button", {
                                            type: "button",
                                            class: "option-btn",
                                            disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                            onClick: ($event: any) => (_ctx.removeCheckBoxinCustomEdit(row.text))
                                          }, [
                                            _hoisted_860
                                          ], 8, ["disabled", "onClick"])
                                        ])
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_861, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[97] || (_cache[97] = 
//@ts-ignore
(...args) => (_ctx.addCheckBoxinCustomEdit && _ctx.addCheckBoxinCustomEdit(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_862,
                                        _hoisted_863
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'single_select')
                        ? (_openBlock(), _createBlock("div", _hoisted_864, [
                            _createVNode("div", _hoisted_865, [
                              _createVNode("div", _hoisted_866, [
                                _hoisted_867,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedElement.element.title]
                                ])
                              ]),
                              (_ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_868, [
                                    _hoisted_869,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_870, [
                                          _createVNode("div", null, [
                                            _withDirectives(_createVNode("input", {
                                              type: "radio",
                                              name: "exampleRadios",
                                              id: "exampleRadios1",
                                              value: row.text,
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["value", "onUpdate:modelValue"]), [
                                              [_vModelRadio, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_871, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_872, [
                                          _createVNode("button", {
                                            type: "button",
                                            class: "option-btn",
                                            disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                            onClick: ($event: any) => (_ctx.removeSelectOptioninCustomEdit(row.text))
                                          }, [
                                            _hoisted_873
                                          ], 8, ["disabled", "onClick"])
                                        ])
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_874, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[99] || (_cache[99] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptionsinCustomEdit && _ctx.addSelectOptionsinCustomEdit(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_875,
                                        _hoisted_876
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'radioButton')
                        ? (_openBlock(), _createBlock("div", _hoisted_877, [
                            _createVNode("div", _hoisted_878, [
                              _createVNode("div", _hoisted_879, [
                                _hoisted_880,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedElement.element.title]
                                ])
                              ]),
                              (_ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_881, [
                                    _hoisted_882,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_883, [
                                          _createVNode("div", null, [
                                            _withDirectives(_createVNode("input", {
                                              type: "radio",
                                              name: "exampleRadios",
                                              value: row.text,
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["value", "onUpdate:modelValue"]), [
                                              [_vModelRadio, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_884, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_885, [
                                          _createVNode("button", {
                                            type: "button",
                                            class: "option-btn",
                                            disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                            onClick: ($event: any) => (_ctx.removeOptionsinCustomEdit(row.text))
                                          }, [
                                            _hoisted_886
                                          ], 8, ["disabled", "onClick"])
                                        ])
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_887, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[101] || (_cache[101] = 
//@ts-ignore
(...args) => (_ctx.addOptionsinCustomEdit && _ctx.addOptionsinCustomEdit(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_888,
                                        _hoisted_889
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_890, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[102] || (_cache[102] = 
//@ts-ignore
(...args) => (_ctx.hideEditCreateNewForm && _ctx.hideEditCreateNewForm(...args)))
                    }, " Close "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[103] || (_cache[103] = 
//@ts-ignore
(...args) => (_ctx.updateEditNewForm && _ctx.updateEditNewForm(...args)))
                    }, " Update ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_891, [
            _createVNode("div", _hoisted_892, [
              _createVNode("div", _hoisted_893, [
                _createVNode("div", _hoisted_894, [
                  _createVNode("div", _hoisted_895, [
                    _createVNode("h5", _hoisted_896, " Add " + _toDisplayString(_ctx.state.selected), 1),
                    _hoisted_897
                  ]),
                  _createVNode("div", _hoisted_898, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorList,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_899, [
                      (_ctx.state.type === 'title')
                        ? (_openBlock(), _createBlock("div", _hoisted_900, [
                            _createVNode("div", _hoisted_901, [
                              _hoisted_902,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => (_ctx.state.form.textField.title = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Title Here"
                              }, null, 512), [
                                [_vModelText, _ctx.state.form.textField.title]
                              ])
                            ]),
                            _createVNode("div", _hoisted_903, [
                              _hoisted_904,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => (_ctx.state.form.textField.description = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Description here"
                              }, null, 512), [
                                [_vModelText, _ctx.state.form.textField.description]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.type === 'section')
                        ? (_openBlock(), _createBlock("div", _hoisted_905, [
                            _createVNode("div", _hoisted_906, [
                              _hoisted_907,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => (_ctx.state.form.textField.title = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword"
                              }, null, 512), [
                                [_vModelText, _ctx.state.form.textField.title]
                              ])
                            ]),
                            _createVNode("div", _hoisted_908, [
                              _hoisted_909,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => (_ctx.state.form.textField.description = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword"
                              }, null, 512), [
                                [_vModelText, _ctx.state.form.textField.description]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.type === 'textbox')
                        ? (_openBlock(), _createBlock("div", _hoisted_910, [
                            _createVNode("div", _hoisted_911, [
                              _hoisted_912,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => (_ctx.state.form.textbox.title = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword"
                              }, null, 512), [
                                [_vModelText, _ctx.state.form.textbox.title]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.type === 'textArea')
                        ? (_openBlock(), _createBlock("div", _hoisted_913, [
                            _createVNode("div", _hoisted_914, [
                              _hoisted_915,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => (_ctx.state.form.textArea.title = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword"
                              }, null, 512), [
                                [_vModelText, _ctx.state.form.textArea.title]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.type === 'radioButton')
                        ? (_openBlock(), _createBlock("div", _hoisted_916, [
                            _createVNode("div", _hoisted_917, [
                              _createVNode("div", _hoisted_918, [
                                _hoisted_919,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => (_ctx.state.form.radioButton.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.radioButton.title]
                                ])
                              ]),
                              (_ctx.state.form.radioButton.select_values &&
                      _ctx.state.form.radioButton.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_920, [
                                    _hoisted_921,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.radioButton
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_922, [
                                          _createVNode("div", null, [
                                            _withDirectives(_createVNode("input", {
                                              type: "radio",
                                              name: "exampleRadios",
                                              value: row.text,
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["value", "onUpdate:modelValue"]), [
                                              [_vModelRadio, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_923, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        (rowIndex <=
                          _ctx.state.form.radioButton.select_values.length
                        )
                                          ? (_openBlock(), _createBlock("div", _hoisted_924, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "option-btn",
                                                disabled: _ctx.state.form.radioButton.select_values.length === 1
                            ,
                                                onClick: ($event: any) => (_ctx.removeOptions(row.text))
                                              }, [
                                                _hoisted_925
                                              ], 8, ["disabled", "onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_926, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[111] || (_cache[111] = 
//@ts-ignore
(...args) => (_ctx.addOptions && _ctx.addOptions(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_927,
                                        _hoisted_928
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.type === 'single_select')
                        ? (_openBlock(), _createBlock("div", _hoisted_929, [
                            _createVNode("div", _hoisted_930, [
                              _createVNode("div", _hoisted_931, [
                                _hoisted_932,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => (_ctx.state.form.selectOption.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.selectOption.title]
                                ])
                              ]),
                              (_ctx.state.form.selectOption.select_values &&
                      _ctx.state.form.selectOption.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_933, [
                                    _hoisted_934,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.selectOption
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_935, [
                                          _createVNode("div", null, [
                                            _withDirectives(_createVNode("input", {
                                              type: "radio",
                                              name: "exampleRadios",
                                              value: row.text,
                                              id: "exampleRadios1",
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["value", "onUpdate:modelValue"]), [
                                              [_vModelRadio, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_936, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        (rowIndex != 0)
                                          ? (_openBlock(), _createBlock("div", _hoisted_937, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "option-btn",
                                                disabled: _ctx.state.form.selectOption.select_values.length === 1
                            ,
                                                onClick: ($event: any) => (_ctx.removeSelectOption(row.text))
                                              }, [
                                                _hoisted_938
                                              ], 8, ["disabled", "onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_939, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[113] || (_cache[113] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptions && _ctx.addSelectOptions(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_940,
                                        _hoisted_941
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.type === 'checkBox')
                        ? (_openBlock(), _createBlock("div", _hoisted_942, [
                            _createVNode("div", _hoisted_943, [
                              _createVNode("div", _hoisted_944, [
                                _hoisted_945,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => (_ctx.state.form.checkBox.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.checkBox.title]
                                ])
                              ]),
                              (_ctx.state.form.checkBox.select_values &&
                      _ctx.state.form.checkBox.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_946, [
                                    _hoisted_947,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.checkBox
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_948, [
                                          _createVNode("div", _hoisted_949, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              name: "exampleRadios",
                                              id: "exampleRadios1",
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_950, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        (rowIndex != 0)
                                          ? (_openBlock(), _createBlock("div", _hoisted_951, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "option-btn",
                                                disabled: _ctx.state.form.checkBox.select_values.length === 1
                            ,
                                                onClick: ($event: any) => (_ctx.removeCheckBox(row.text))
                                              }, [
                                                _hoisted_952
                                              ], 8, ["disabled", "onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_953, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[115] || (_cache[115] = 
//@ts-ignore
(...args) => (_ctx.addCheckBox && _ctx.addCheckBox(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_954,
                                        _hoisted_955
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_956, [
                        _hoisted_957,
                        _withDirectives(_createVNode("select", {
                          class: "form-control custom-select",
                          "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => (_ctx.state.typePosition = $event))
                        }, [
                          _hoisted_958,
                          _hoisted_959
                        ], 512), [
                          [_vModelSelect, _ctx.state.typePosition]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_960, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[117] || (_cache[117] = 
//@ts-ignore
(...args) => (_ctx.addTextField && _ctx.addTextField(...args)))
                    }, " Add "),
                    _hoisted_961
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_962, [
            _createVNode("div", _hoisted_963, [
              _createVNode("div", _hoisted_964, [
                _createVNode("div", _hoisted_965, [
                  _createVNode("div", _hoisted_966, [
                    _createVNode("div", _hoisted_967, [
                      _createVNode("h5", _hoisted_968, [
                        _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                        _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                      ])
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "aria-label": "Close",
                      onClick: _cache[118] || (_cache[118] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
                    }, [
                      _hoisted_969
                    ])
                  ]),
                  _createVNode("div", _hoisted_970, [
                    _createVNode("div", _hoisted_971, [
                      _createVNode("form", null, [
                        _createVNode("fieldset", _hoisted_972, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.formData.elements, (element, elementIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "form-group",
                              key: elementIndex
                            }, [
                              (element.type === 'title')
                                ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                    key: 0,
                                    title: element.title,
                                    description: element.description,
                                    editStatus: false
                                  }, null, 8, ["title", "description"]))
                                : _createCommentVNode("", true),
                              (element.type === 'textbox')
                                ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                    key: 1,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'radioButton')
                                ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                    key: 2,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'single_select')
                                ? (_openBlock(), _createBlock(_component_SelectOption, {
                                    key: 3,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'checkBox')
                                ? (_openBlock(), _createBlock(_component_CheckBox, {
                                    key: 4,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'textArea')
                                ? (_openBlock(), _createBlock(_component_TextArea, {
                                    key: 5,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_973, [
                    _createVNode("div", _hoisted_974, [
                      _createVNode("div", _hoisted_975, [
                        _createVNode("div", _hoisted_976, [
                          _hoisted_977,
                          (_ctx.state.privacyList && _ctx.state.privacyList.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_978, [
                                _withDirectives(_createVNode("select", {
                                  class: "custom-select form-control",
                                  "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => (_ctx.state.newFormData.privacy = $event))
                                }, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.privacyList, (item, itemIndex) => {
                                    return (_openBlock(), _createBlock("option", {
                                      value: item,
                                      key: itemIndex
                                    }, _toDisplayString(item.name), 9, ["value"]))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.state.newFormData.privacy]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_979, [
                            _hoisted_980,
                            _createVNode("div", _hoisted_981, [
                              _createVNode("h5", null, _toDisplayString(_ctx.state.newFormData.privacy.value), 1),
                              _createVNode("p", _hoisted_982, _toDisplayString(_ctx.formPrivacyMessage), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_983, [
                        _createVNode("div", _hoisted_984, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn default-btn",
                            onClick: _cache[120] || (_cache[120] = 
//@ts-ignore
(...args) => (_ctx.showMentionUser && _ctx.showMentionUser(...args)))
                          }, " Send to User "),
                          _createVNode("button", {
                            type: "button",
                            class: "btn secondary-btn",
                            onClick: _cache[121] || (_cache[121] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
                          }, " Cancel ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_985, [
            _createVNode("div", _hoisted_986, [
              _createVNode("div", _hoisted_987, [
                _createVNode("div", _hoisted_988, [
                  _createVNode("div", _hoisted_989, [
                    _createVNode("h5", _hoisted_990, [
                      _createTextVNode(" Edit " + _toDisplayString(_ctx.state.formData.title) + "- ", 1),
                      _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "aria-label": "Close",
                      onClick: _cache[122] || (_cache[122] = 
//@ts-ignore
(...args) => (_ctx.hideEditTemplateModal && _ctx.hideEditTemplateModal(...args)))
                    }, [
                      _hoisted_991
                    ])
                  ]),
                  _createVNode("div", _hoisted_992, [
                    _createVNode("div", _hoisted_993, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.formData.elements, (element, elementIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "form-group",
                          key: elementIndex
                        }, [
                          (element.type === 'title')
                            ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                key: 0,
                                title: element.title,
                                description: element.description,
                                editStatus: true
                              }, null, 8, ["title", "description"]))
                            : _createCommentVNode("", true),
                          (element.type === 'textbox')
                            ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                key: 1,
                                data: element,
                                editStatus: true
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'radioButton')
                            ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                key: 2,
                                data: element,
                                editStatus: true
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'single_select')
                            ? (_openBlock(), _createBlock(_component_SelectOption, {
                                key: 3,
                                data: element
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'checkBox')
                            ? (_openBlock(), _createBlock(_component_CheckBox, {
                                key: 4,
                                data: element
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (element.type === 'textArea')
                            ? (_openBlock(), _createBlock(_component_TextArea, {
                                key: 5,
                                data: element,
                                editStatus: true
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("div", _hoisted_994, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[123] || (_cache[123] = 
//@ts-ignore
(...args) => (_ctx.hideEditTemplateModal && _ctx.hideEditTemplateModal(...args)))
                    }, " Cancel "),
                    _hoisted_995
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_996, [
            _createVNode("div", _hoisted_997, [
              _createVNode("div", _hoisted_998, [
                _createVNode("div", _hoisted_999, [
                  _hoisted_1000,
                  _createVNode("div", _hoisted_1001, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorListSendForm,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1002, [
                      _createVNode("div", _hoisted_1003, [
                        _hoisted_1004,
                        _withDirectives(_createVNode("select", {
                          class: "form-control mb-2",
                          id: "user.id",
                          "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => (_ctx.state.existingMember = $event)),
                          onChange: _cache[125] || (_cache[125] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInForm && _ctx.changeExistingMemberInForm(...args)))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              value: item,
                              key: itemIndex
                            }, _toDisplayString(item.full_name), 9, ["value"]))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.state.existingMember]
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_1005, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_1006
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_1007, [
                        _hoisted_1008,
                        _withDirectives(_createVNode("textarea", {
                          class: "form-control",
                          id: "w3review",
                          name: "w3review",
                          rows: "4",
                          cols: "50",
                          "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => (_ctx.state.ui.template.msg = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.ui.template.msg]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1009, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[127] || (_cache[127] = 
//@ts-ignore
(...args) => (_ctx.sendTemplateFile && _ctx.sendTemplateFile(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.createFormTemplate
                ? "sending..."
                : "send"), 1),
                    _hoisted_1010
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_1011,
          _createVNode("div", _hoisted_1012, [
            _createVNode("div", _hoisted_1013, [
              _createVNode("div", _hoisted_1014, [
                _createVNode("div", _hoisted_1015, [
                  _createVNode("div", _hoisted_1016, [
                    (_ctx.state.data.clientDocumentRetrieveWorkflowLink &&
                !_ctx.state.data.clientDocumentRetrieveWorkflowLink
                  .document_title &&
                !_ctx.state.data.clientDocumentRetrieveWorkflowLink.docId
              )
                      ? (_openBlock(), _createBlock("div", _hoisted_1017, [
                          (_ctx.state.formData.title)
                            ? (_openBlock(), _createBlock("h5", _hoisted_1018, [
                                _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                                _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_1019, [
                          (_ctx.state.data.selectedFormData.client_document_name &&
                  _ctx.state.data.selectedFormData.client_document_name
                )
                            ? (_openBlock(), _createBlock("h5", _hoisted_1020, _toDisplayString(_ctx.state.data.selectedFormData.client_document_name), 1))
                            : _createCommentVNode("", true)
                        ])),
                    _createVNode("div", null, [
                      (_ctx.state.ui.isPostLoading.getAccountFormRetrieveById ||
                  _ctx.state.ui.isLoading.accountFormResponseByEmailAndId ||
                  _ctx.state.ui.isLoading.clientDocumentRetrieveWorkflow
                )
                        ? (_openBlock(), _createBlock("p", _hoisted_1021, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                    : 'img/loading.gif'
                    ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[128] || (_cache[128] = 
//@ts-ignore
(...args) => (_ctx.hideFormView && _ctx.hideFormView(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1022
                    ])
                  ]),
                  (_ctx.state.data.clientDocumentRetrieveWorkflowLink &&
              !_ctx.state.data.clientDocumentRetrieveWorkflowLink.document_title &&
              !_ctx.state.data.clientDocumentRetrieveWorkflowLink.docId
            )
                    ? (_openBlock(), _createBlock("div", _hoisted_1023, [
                        _createVNode("div", _hoisted_1024, [
                          _createVNode("div", _hoisted_1025, [
                            _hoisted_1026,
                            _createVNode("div", _hoisted_1027, [
                              _createVNode("div", _hoisted_1028, [
                                (_ctx.state.item.selectedUserFormDetails.elements &&
                        _ctx.state.item.selectedUserFormDetails.elements.length
                      )
                                  ? (_openBlock(), _createBlock("div", _hoisted_1029, [
                                      _createVNode("form", null, [
                                        _createVNode("fieldset", _hoisted_1030, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.item
                              .selectedUserFormDetails.elements, (element, elementIndex) => {
                                            return (_openBlock(), _createBlock("div", {
                                              class: "form-group mb-0",
                                              key: elementIndex
                                            }, [
                                              (element.type === 'title')
                                                ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                                    key: 0,
                                                    title: element.title,
                                                    description: element.description,
                                                    editStatus: false
                                                  }, null, 8, ["title", "description"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'textbox')
                                                ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                                    key: 1,
                                                    data: element,
                                                    editStatus: false
                                                  }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'radioButton')
                                                ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                                    key: 2,
                                                    data: element,
                                                    index: elementIndex,
                                                    editStatus: false
                                                  }, null, 8, ["data", "index"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'single_select')
                                                ? (_openBlock(), _createBlock(_component_SelectOption, {
                                                    key: 3,
                                                    data: element,
                                                    editStatus: false
                                                  }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'checkBox')
                                                ? (_openBlock(), _createBlock(_component_CheckBox, {
                                                    key: 4,
                                                    data: element,
                                                    editStatus: false
                                                  }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'textArea')
                                                ? (_openBlock(), _createBlock(_component_TextArea, {
                                                    key: 5,
                                                    data: element,
                                                    editStatus: false
                                                  }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'digitalSignature')
                                                ? (_openBlock(), _createBlock(_component_DigitalSignature, {
                                                    key: 6,
                                                    data: element
                                                  }, null, 8, ["data"]))
                                                : _createCommentVNode("", true),
                                              (element.type === 'datePicker')
                                                ? (_openBlock(), _createBlock("div", _hoisted_1031, [
                                                    _createVNode("label", _hoisted_1032, _toDisplayString(element.title), 1),
                                                    _withDirectives(_createVNode("input", {
                                                      type: "text",
                                                      class: "form-control",
                                                      "onUpdate:modelValue": ($event: any) => (element.convertedDate = $event)
                                                    }, null, 8, ["onUpdate:modelValue"]), [
                                                      [_vModelText, element.convertedDate]
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      (_ctx.state.item.selectedUserFormDetails.edoc_pdf_path
                        )
                                        ? (_openBlock(), _createBlock("div", _hoisted_1033, [
                                            _hoisted_1034,
                                            _createVNode("button", {
                                              onClick: _cache[129] || (_cache[129] = 
//@ts-ignore
(...args) => (_ctx.downloadEdocPdf && _ctx.downloadEdocPdf(...args))),
                                              class: "btn default-btn outline"
                                            }, [
                                              _hoisted_1035,
                                              _hoisted_1036
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_1037, [
                                      _createVNode("div", _hoisted_1038, [
                                        _createVNode("div", _hoisted_1039, [
                                          _hoisted_1040,
                                          _createVNode("div", _hoisted_1041, [
                                            (_ctx.state.item.selectedUserFormDetails &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails.length &&
                                _ctx.state.formData.sentToUsers &&
                                !_ctx.state.formData.sentToUsers.length
                              )
                                              ? (_openBlock(), _createBlock("h5", _hoisted_1042, " Please choose the user from right to see the form filled up by the user "))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.selectedUser &&
                                _ctx.state.selectedUser.email != _ctx.state.email &&
                                _ctx.state.item.selectedUserFormDetails &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails.length &&
                                _ctx.state.formData.sentToUsers &&
                                _ctx.state.formData.sentToUsers.length
                              )
                                              ? (_openBlock(), _createBlock("h5", _hoisted_1043, " This user has not filled the form yet ! "))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.selectedUser &&
                                _ctx.state.selectedUser.email === _ctx.state.email &&
                                _ctx.state.item.selectedUserFormDetails &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails.length &&
                                !_ctx.state.item.selectedUserFormDetails
                                  .client_doc_pdf_path
                              )
                                              ? (_openBlock(), _createBlock("h5", _hoisted_1044, [
                                                  _hoisted_1045,
                                                  _createVNode("a", {
                                                    onClick: _cache[130] || (_cache[130] = 
//@ts-ignore
(...args) => (_ctx.userFormClick && _ctx.userFormClick(...args))),
                                                    class: "\n                                                btn btn-outline-primary btn-sm\n                                                mx-1\n                                                rounded-pill\n                                              "
                                                  }, "Click here"),
                                                  _hoisted_1046
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                              ]),
                              _createVNode("div", _hoisted_1047, [
                                _createVNode("form", null, [
                                  _createVNode("fieldset", _hoisted_1048, [
                                    _createVNode("div", _hoisted_1049, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.formData
                              .elements, (element, elementIndex) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "form-group",
                                          key: elementIndex
                                        }, [
                                          (element.type === 'title')
                                            ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                                key: 0,
                                                title: element.title,
                                                description: element.description,
                                                editStatus: false
                                              }, null, 8, ["title", "description"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'textbox')
                                            ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                                key: 1,
                                                data: element,
                                                editStatus: false
                                              }, null, 8, ["data"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'radioButton')
                                            ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                                key: 2,
                                                data: element,
                                                editStatus: false
                                              }, null, 8, ["data"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'single_select')
                                            ? (_openBlock(), _createBlock(_component_SelectOption, {
                                                key: 3,
                                                data: element,
                                                editStatus: false
                                              }, null, 8, ["data"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'checkBox')
                                            ? (_openBlock(), _createBlock(_component_CheckBox, {
                                                key: 4,
                                                data: element,
                                                editStatus: false
                                              }, null, 8, ["data"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'textArea')
                                            ? (_openBlock(), _createBlock(_component_TextArea, {
                                                key: 5,
                                                data: element,
                                                editStatus: false
                                              }, null, 8, ["data"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'digitalSignature')
                                            ? (_openBlock(), _createBlock(_component_DigitalSignature, {
                                                key: 6,
                                                data: element
                                              }, null, 8, ["data"]))
                                            : _createCommentVNode("", true),
                                          (element.type === 'datePicker')
                                            ? (_openBlock(), _createBlock("div", _hoisted_1050, [
                                                _createVNode("label", _hoisted_1051, _toDisplayString(element.title), 1),
                                                _withDirectives(_createVNode("input", {
                                                  type: "text",
                                                  class: "form-control",
                                                  "onUpdate:modelValue": ($event: any) => (element.convertedDate = $event)
                                                }, null, 8, ["onUpdate:modelValue"]), [
                                                  [_vModelText, element.convertedDate]
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_1052, [
                            _createVNode("div", _hoisted_1053, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, " Sent to users (" + _toDisplayString(_ctx.sentToUsers.length) + ")", 1)
                              ]),
                              _createVNode("div", _hoisted_1054, [
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Search User",
                                  "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => (_ctx.state.item.searchUser = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.item.searchUser]
                                ]),
                                _hoisted_1055
                              ])
                            ]),
                            (_ctx.sentToUsers && _ctx.sentToUsers.length)
                              ? (_openBlock(), _createBlock("div", _hoisted_1056, [
                                  _createVNode("ul", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sentToUsers, (user, userIndex) => {
                                      return (_openBlock(), _createBlock("li", {
                                        class: _ctx.state.activeUserIndex === userIndex ? 'active' : ''
                        ,
                                        key: userIndex,
                                        onClick: ($event: any) => (
                          _ctx.getAccountFormResponseByEmailAndId(user, userIndex)
                          )
                                      }, [
                                        _createVNode("div", _hoisted_1057, [
                                          _createVNode("div", null, [
                                            (user.image)
                                              ? (_openBlock(), _createBlock("img", {
                                                  key: 0,
                                                  src: user.image,
                                                  alt: "",
                                                  title: user.email
                                                }, null, 8, ["src", "title"]))
                                              : (_openBlock(), _createBlock("img", {
                                                  key: 1,
                                                  src: "https://dummyimage.com/35x35/c9c9c9/363636",
                                                  alt: "",
                                                  title: user.email
                                                }, null, 8, ["title"]))
                                          ]),
                                          (user.full_name)
                                            ? (_openBlock(), _createBlock("h5", {
                                                key: 0,
                                                title: user.email
                                              }, _toDisplayString(user.full_name), 9, ["title"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, ["onClick"]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_1058, [
                        _createVNode("div", _hoisted_1059, [
                          _createVNode("div", _hoisted_1060, [
                            _hoisted_1061,
                            _createVNode("div", _hoisted_1062, [
                              _createVNode("div", _hoisted_1063, [
                                (_ctx.state.item.selectedUserFormDetails &&
                        _ctx.state.item.selectedUserFormDetails.client_doc_pdf_path
                      )
                                  ? (_openBlock(), _createBlock("div", _hoisted_1064, [
                                      (_ctx.state.item.selectedUserFormDetails.filled_by
                          .email === _ctx.state.email ||
                          _ctx.state.data.msgByUser.email === _ctx.state.email
                        )
                                        ? (_openBlock(), _createBlock("div", _hoisted_1065, [
                                            _hoisted_1066,
                                            _createVNode("button", {
                                              onClick: _cache[132] || (_cache[132] = 
//@ts-ignore
(...args) => (_ctx.downloadEdocPdf && _ctx.downloadEdocPdf(...args))),
                                              class: "btn default-btn outline"
                                            }, [
                                              _hoisted_1067,
                                              _hoisted_1068
                                            ])
                                          ]))
                                        : (_openBlock(), _createBlock("h5", _hoisted_1069, " You are not Allowded to view or Download pdf.! "))
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_1070, [
                                      _createVNode("div", _hoisted_1071, [
                                        _createVNode("div", _hoisted_1072, [
                                          _hoisted_1073,
                                          (_ctx.state.item.selectedUserFormDetails &&
                              !_ctx.state.item.selectedUserFormDetails
                                .client_doc_pdf_path &&
                              _ctx.state.item.selectedUserFormDetails
                                .sentToUsers &&
                              !_ctx.state.item.selectedUserFormDetails.sentToUsers
                                .length
                            )
                                            ? (_openBlock(), _createBlock("h5", _hoisted_1074, " Please choose the user from right to see the form filled up by the user "))
                                            : _createCommentVNode("", true),
                                          (_ctx.state.selectedUser.email != _ctx.state.email &&
                              _ctx.state.item.selectedUserFormDetails &&
                              !_ctx.state.item.selectedUserFormDetails
                                .client_doc_pdf_path
                            )
                                            ? (_openBlock(), _createBlock("h5", _hoisted_1075, " This user has not filled the form yet ! "))
                                            : _createCommentVNode("", true),
                                          (_ctx.state.selectedUser.email === _ctx.state.email &&
                              _ctx.state.item.selectedUserFormDetails &&
                              !_ctx.state.item.selectedUserFormDetails
                                .client_doc_pdf_path
                            )
                                            ? (_openBlock(), _createBlock("h5", _hoisted_1076, [
                                                _hoisted_1077,
                                                _createVNode("a", {
                                                  onClick: _cache[133] || (_cache[133] = ($event: any) => (
                                _ctx.showWorkFlowLink(
                                  _ctx.state.data
                                    .clientDocumentRetrieveWorkflowLink
                                )
                                )),
                                                  class: "\n                                                btn btn-outline-primary btn-sm\n                                                mx-1\n                                                rounded-pill\n                                              "
                                                }, "Click here"),
                                                _hoisted_1078
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createVNode("div", null, [
                                            (_ctx.state.selectedUser.email === _ctx.state.email &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails
                                  .client_doc_pdf_path
                              )
                                              ? (_openBlock(), _createBlock("h5", _hoisted_1079, [
                                                  _hoisted_1080,
                                                  _createVNode("a", {
                                                    onClick: _cache[134] || (_cache[134] = ($event: any) => (
                                  _ctx.showPreviewLink(
                                    _ctx.state.data
                                      .clientDocumentRetrieveWorkflowLink
                                      .galleryThumbUrl
                                  )
                                  )),
                                                    class: "\n                                                  btn btn-outline-primary btn-sm\n                                                  mx-1\n                                                  rounded-pill\n                                                "
                                                  }, "Click here")
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                              ]),
                              _createVNode("div", _hoisted_1081, [
                                _hoisted_1082,
                                (_ctx.state.item.selectedUserFormDetails &&
                        _ctx.state.item.selectedUserFormDetails.client_doc_pdf_path
                      )
                                  ? (_openBlock(), _createBlock("div", _hoisted_1083, [
                                      (_ctx.state.item.selectedUserFormDetails.filled_by
                          .email === _ctx.state.email ||
                          _ctx.state.data.msgByUser.email === _ctx.state.email
                        )
                                        ? (_openBlock(), _createBlock("div", _hoisted_1084, [
                                            _hoisted_1085,
                                            _createVNode("button", {
                                              onClick: _cache[135] || (_cache[135] = 
//@ts-ignore
(...args) => (_ctx.downloadEdocPdf && _ctx.downloadEdocPdf(...args))),
                                              class: "btn default-btn outline"
                                            }, [
                                              _hoisted_1086,
                                              _hoisted_1087
                                            ])
                                          ]))
                                        : (_openBlock(), _createBlock("h5", _hoisted_1088, " You are not Allowded to view or Download pdf.! "))
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_1089, [
                                      _createVNode("div", _hoisted_1090, [
                                        _createVNode("div", _hoisted_1091, [
                                          _hoisted_1092,
                                          (_ctx.state.item.selectedUserFormDetails &&
                              !_ctx.state.item.selectedUserFormDetails
                                .client_doc_pdf_path &&
                              _ctx.state.item.selectedUserFormDetails
                                .sentToUsers &&
                              !_ctx.state.item.selectedUserFormDetails.sentToUsers
                                .length
                            )
                                            ? (_openBlock(), _createBlock("h5", _hoisted_1093, " Please choose the user from right to see the form filled up by the user "))
                                            : _createCommentVNode("", true),
                                          (_ctx.state.selectedUser.email != _ctx.state.email &&
                              _ctx.state.item.selectedUserFormDetails &&
                              !_ctx.state.item.selectedUserFormDetails
                                .client_doc_pdf_path
                            )
                                            ? (_openBlock(), _createBlock("h5", _hoisted_1094, " This user has not filled the form yet ! "))
                                            : _createCommentVNode("", true),
                                          (_ctx.state.selectedUser.email === _ctx.state.email &&
                              _ctx.state.item.selectedUserFormDetails &&
                              !_ctx.state.item.selectedUserFormDetails
                                .client_doc_pdf_path
                            )
                                            ? (_openBlock(), _createBlock("h5", _hoisted_1095, [
                                                _hoisted_1096,
                                                _createVNode("a", {
                                                  onClick: _cache[136] || (_cache[136] = ($event: any) => (
                                _ctx.showWorkFlowLink(
                                  _ctx.state.data
                                    .clientDocumentRetrieveWorkflowLink
                                )
                                )),
                                                  class: "\n                                                btn btn-outline-primary btn-sm\n                                                mx-1\n                                                rounded-pill\n                                              "
                                                }, "Click here"),
                                                _hoisted_1097
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createVNode("div", null, [
                                            (_ctx.state.selectedUser.email === _ctx.state.email &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails
                                  .client_doc_pdf_path
                              )
                                              ? (_openBlock(), _createBlock("h5", _hoisted_1098, [
                                                  _hoisted_1099,
                                                  _createVNode("a", {
                                                    onClick: _cache[137] || (_cache[137] = ($event: any) => (
                                  _ctx.showPreviewLink(
                                    _ctx.state.data
                                      .clientDocumentRetrieveWorkflowLink
                                      .galleryThumbUrl
                                  )
                                  )),
                                                    class: "\n                                                  btn btn-outline-primary btn-sm\n                                                  mx-1\n                                                  rounded-pill\n                                                "
                                                  }, "Click here")
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]))
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_1100, [
                            _createVNode("div", _hoisted_1101, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, " Sent to users (" + _toDisplayString(_ctx.sentToUsers.length) + ")", 1)
                              ]),
                              _createVNode("div", _hoisted_1102, [
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Search User",
                                  "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => (_ctx.state.item.searchUser = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.item.searchUser]
                                ]),
                                _hoisted_1103
                              ])
                            ]),
                            (_ctx.sentToUsers && _ctx.sentToUsers.length)
                              ? (_openBlock(), _createBlock("div", _hoisted_1104, [
                                  _createVNode("ul", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sentToUsers, (user, userIndex) => {
                                      return (_openBlock(), _createBlock("li", {
                                        class: _ctx.state.activeUserIndex === userIndex ? 'active' : ''
                        ,
                                        key: userIndex,
                                        onClick: ($event: any) => (
                          _ctx.getAccountFormResponseByEmailAndId(user, userIndex)
                          )
                                      }, [
                                        _createVNode("div", _hoisted_1105, [
                                          _createVNode("div", null, [
                                            (user.image)
                                              ? (_openBlock(), _createBlock("img", {
                                                  key: 0,
                                                  src: user.image,
                                                  alt: "",
                                                  title: user.email
                                                }, null, 8, ["src", "title"]))
                                              : (_openBlock(), _createBlock("img", {
                                                  key: 1,
                                                  src: "https://dummyimage.com/35x35/c9c9c9/363636",
                                                  alt: "",
                                                  title: user.email
                                                }, null, 8, ["title"]))
                                          ]),
                                          (user.full_name)
                                            ? (_openBlock(), _createBlock("h5", {
                                                key: 0,
                                                title: user.email
                                              }, _toDisplayString(user.full_name), 9, ["title"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, ["onClick"]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])),
                  _createVNode("div", _hoisted_1106, [
                    (_ctx.state.formData)
                      ? (_openBlock(), _createBlock("div", _hoisted_1107, [
                          _createVNode("p", _hoisted_1108, [
                            _hoisted_1109,
                            _hoisted_1110,
                            (_ctx.state.formData.owner && _ctx.state.formData.owner.created_by
                  )
                              ? (_openBlock(), _createBlock("span", _hoisted_1111, _toDisplayString(_ctx.state.formData.owner.created_by.email), 1))
                              : _createCommentVNode("", true),
                            _hoisted_1112,
                            _createVNode("span", null, _toDisplayString(_ctx.state.formData.created_date), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[139] || (_cache[139] = 
//@ts-ignore
(...args) => (_ctx.hideFormView && _ctx.hideFormView(...args)))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1113, [
            _createVNode("div", _hoisted_1114, [
              _createVNode("div", _hoisted_1115, [
                _createVNode("div", _hoisted_1116, [
                  _createVNode("div", _hoisted_1117, [
                    _hoisted_1118,
                    _createVNode("div", _hoisted_1119, [
                      _createVNode("h5", _hoisted_1120, _toDisplayString(_ctx.state.selectedFormForEdit.title), 1),
                      _hoisted_1121
                    ]),
                    _hoisted_1122
                  ]),
                  _createVNode("div", _hoisted_1123, [
                    _createVNode("div", _hoisted_1124, [
                      _createVNode("div", _hoisted_1125, [
                        _createVNode("div", _hoisted_1126, [
                          _createVNode("ul", null, [
                            _createVNode("li", {
                              onClick: _cache[140] || (_cache[140] = ($event: any) => (_ctx.showCustomEdit('section', 'Section')))
                            }, [
                              _hoisted_1127,
                              _hoisted_1128
                            ]),
                            _createVNode("li", {
                              onClick: _cache[141] || (_cache[141] = ($event: any) => (_ctx.showCustomEdit('textbox', 'Text Box')))
                            }, [
                              _hoisted_1129,
                              _hoisted_1130
                            ]),
                            _createVNode("li", {
                              onClick: _cache[142] || (_cache[142] = ($event: any) => (_ctx.showCustomEdit('textArea', 'TextArea')))
                            }, [
                              _hoisted_1131,
                              _hoisted_1132
                            ]),
                            _createVNode("li", {
                              onClick: _cache[143] || (_cache[143] = ($event: any) => (
                        _ctx.showCustomEdit('single_select', 'Select Option')
                        ))
                            }, [
                              _hoisted_1133,
                              _hoisted_1134
                            ]),
                            _createVNode("li", {
                              onClick: _cache[144] || (_cache[144] = ($event: any) => (_ctx.showCustomEdit('radioButton', 'Radio Button')))
                            }, [
                              _hoisted_1135,
                              _hoisted_1136
                            ]),
                            _createVNode("li", {
                              onClick: _cache[145] || (_cache[145] = ($event: any) => (_ctx.showCustomEdit('checkBox', 'Check Box')))
                            }, [
                              _hoisted_1137,
                              _hoisted_1138
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_1139, [
                        _createVNode("div", _hoisted_1140, [
                          _createVNode(_component_ErrorList, {
                            errors: _ctx.state.item.error.erorListSaveCustomSelectedForm,
                            hasError: _ctx.state.item.hasError
                          }, null, 8, ["errors", "hasError"]),
                          _createVNode("div", _hoisted_1141, [
                            _createVNode("div", _hoisted_1142, [
                              _createVNode("div", _hoisted_1143, [
                                _createVNode("div", _hoisted_1144, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    "data-toggle": "modal",
                                    onClick: _cache[146] || (_cache[146] = ($event: any) => (_ctx.showEditFormName('title')))
                                  }, [
                                    _hoisted_1145
                                  ])
                                ]),
                                _hoisted_1146,
                                _withDirectives(_createVNode("input", {
                                  disabled: "",
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Title Here",
                                  "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event: any) => (_ctx.state.selectedFormForEdit.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedFormForEdit.title]
                                ])
                              ]),
                              _createVNode("div", _hoisted_1147, [
                                _hoisted_1148,
                                _withDirectives(_createVNode("input", {
                                  disabled: "",
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Description here",
                                  "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event: any) => (_ctx.state.selectedFormForEdit.description = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedFormForEdit.description]
                                ])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedFormForEdit
                          .elements, (form, formIndex) => {
                                return (_openBlock(), _createBlock("div", { key: formIndex }, [
                                  _createVNode("div", _hoisted_1149, [
                                    (form.type === 'textbox')
                                      ? (_openBlock(), _createBlock("div", _hoisted_1150, [
                                          _createVNode("div", _hoisted_1151, [
                                            _createVNode("div", _hoisted_1152, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (_ctx.showEditElement(form, 'textbox'))
                                              }, [
                                                _hoisted_1153
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (_ctx.showDeleteElement(form, 'textbox'))
                                              }, [
                                                _hoisted_1154
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("label", _hoisted_1155, _toDisplayString(form.title), 1),
                                            _withDirectives(_createVNode("input", {
                                              readonly: "",
                                              "onUpdate:modelValue": ($event: any) => (form.answer = $event),
                                              type: "text",
                                              class: "form-control",
                                              id: "inputPassword"
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, form.answer]
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'section')
                                      ? (_openBlock(), _createBlock("div", _hoisted_1156, [
                                          _createVNode("div", _hoisted_1157, [
                                            _createVNode("div", _hoisted_1158, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (_ctx.showEditElement(form, 'section'))
                                              }, [
                                                _hoisted_1159
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (_ctx.showDeleteElement(form, 'section'))
                                              }, [
                                                _hoisted_1160
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("h3", _hoisted_1161, _toDisplayString(form.title), 1),
                                            _createVNode("h5", null, _toDisplayString(form.description), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'radioButton')
                                      ? (_openBlock(), _createBlock("div", _hoisted_1162, [
                                          _createVNode("div", _hoisted_1163, [
                                            _createVNode("div", _hoisted_1164, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (
                                    _ctx.showEditElement(form, 'radioButton')
                                    )
                                              }, [
                                                _hoisted_1165
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (
                                    _ctx.showDeleteElement(form, 'radioButton')
                                    )
                                              }, [
                                                _hoisted_1166
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("label", _hoisted_1167, _toDisplayString(form.title), 1),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                              return (_openBlock(), _createBlock("div", {
                                                class: "d-inline-block mr-3",
                                                key: optionIndex
                                              }, [
                                                _withDirectives(_createVNode("input", {
                                                  disabled: "",
                                                  type: "radio",
                                                  name: "customRadioInline1",
                                                  value: option.value,
                                                  "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                                }, null, 8, ["value", "onUpdate:modelValue"]), [
                                                  [_vModelRadio, option.selected]
                                                ]),
                                                _createVNode("label", _hoisted_1168, _toDisplayString(option.text), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'single_select')
                                      ? (_openBlock(), _createBlock("div", _hoisted_1169, [
                                          _createVNode("div", _hoisted_1170, [
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              "data-toggle": "modal",
                                              onClick: ($event: any) => (
                                  _ctx.showEditElement(form, 'single_select')
                                  )
                                            }, [
                                              _hoisted_1171
                                            ], 8, ["onClick"]),
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              class: "trash",
                                              onClick: ($event: any) => (
                                  _ctx.showDeleteElement(form, 'single_select')
                                  )
                                            }, [
                                              _hoisted_1172
                                            ], 8, ["onClick"])
                                          ]),
                                          _createVNode("label", _hoisted_1173, _toDisplayString(form.title), 1),
                                          _createVNode("select", _hoisted_1174, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                              return (_openBlock(), _createBlock("option", {
                                                selected: option.text === option.selected,
                                                value: option.value,
                                                key: optionIndex
                                              }, _toDisplayString(option.text), 9, ["selected", "value"]))
                                            }), 128))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'checkBox')
                                      ? (_openBlock(), _createBlock("div", _hoisted_1175, [
                                          _createVNode("div", _hoisted_1176, [
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              "data-toggle": "modal",
                                              onClick: ($event: any) => (_ctx.showEditElement(form, 'checkBox'))
                                            }, [
                                              _hoisted_1177
                                            ], 8, ["onClick"]),
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              class: "trash",
                                              onClick: ($event: any) => (_ctx.showDeleteElement(form, 'checkBox'))
                                            }, [
                                              _hoisted_1178
                                            ], 8, ["onClick"])
                                          ]),
                                          _createVNode("label", null, _toDisplayString(form.title), 1),
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                            return (_openBlock(), _createBlock("div", {
                                              class: "d-inline-block mr-3",
                                              key: optionIndex
                                            }, [
                                              _withDirectives(_createVNode("input", {
                                                disabled: "",
                                                type: "checkbox",
                                                id: "vehicle1",
                                                name: "vehicle1",
                                                value: option.text,
                                                "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                              }, null, 8, ["value", "onUpdate:modelValue"]), [
                                                [_vModelCheckbox, option.selected]
                                              ]),
                                              _createVNode("label", _hoisted_1179, _toDisplayString(option.text), 1)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (form.type === 'textArea')
                                      ? (_openBlock(), _createBlock("div", _hoisted_1180, [
                                          _createVNode("div", _hoisted_1181, [
                                            _createVNode("div", _hoisted_1182, [
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                "data-toggle": "modal",
                                                onClick: ($event: any) => (_ctx.showEditElement(form, 'textArea'))
                                              }, [
                                                _hoisted_1183
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "trash",
                                                onClick: ($event: any) => (_ctx.showDeleteElement(form, 'textArea'))
                                              }, [
                                                _hoisted_1184
                                              ], 8, ["onClick"])
                                            ]),
                                            _createVNode("label", _hoisted_1185, _toDisplayString(form.title), 1),
                                            _withDirectives(_createVNode("input", {
                                              readonly: "",
                                              "onUpdate:modelValue": ($event: any) => (form.answer = $event),
                                              type: "text",
                                              class: "form-control",
                                              id: "inputPassword"
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, form.answer]
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1186, [
                    _createVNode("div", _hoisted_1187, [
                      _createVNode("div", _hoisted_1188, [
                        _createVNode("div", _hoisted_1189, [
                          _hoisted_1190,
                          (_ctx.state.privacyList && _ctx.state.privacyList.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_1191, [
                                _withDirectives(_createVNode("select", {
                                  class: "custom-select form-control",
                                  "onUpdate:modelValue": _cache[149] || (_cache[149] = ($event: any) => (_ctx.state.newFormData.privacy = $event))
                                }, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.privacyList, (item, itemIndex) => {
                                    return (_openBlock(), _createBlock("option", {
                                      value: item,
                                      key: itemIndex
                                    }, _toDisplayString(item.name), 9, ["value"]))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.state.newFormData.privacy]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_1192, [
                            _hoisted_1193,
                            _createVNode("div", _hoisted_1194, [
                              _createVNode("h5", null, _toDisplayString(_ctx.state.newFormData.privacy.value), 1),
                              _createVNode("p", _hoisted_1195, _toDisplayString(_ctx.formPrivacyMessage), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_1196, [
                        _createVNode("div", _hoisted_1197, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn default-btn primary-btn",
                            onClick: _cache[150] || (_cache[150] = 
//@ts-ignore
(...args) => (_ctx.showSendFormModal && _ctx.showSendFormModal(...args)))
                          }, " Send This Form "),
                          _createVNode("button", {
                            type: "button",
                            class: "btn default-btn",
                            onClick: _cache[151] || (_cache[151] = 
//@ts-ignore
(...args) => (_ctx.showCustomFormConformation && _ctx.showCustomFormConformation(...args)))
                          }, " Save changes "),
                          _hoisted_1198
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1199, [
            _createVNode("div", _hoisted_1200, [
              _createVNode("div", _hoisted_1201, [
                _createVNode("div", _hoisted_1202, [
                  _createVNode("div", _hoisted_1203, [
                    (_ctx.state.selectedElement.type === 'title' ||
                _ctx.state.selectedElement.type === 'textbox' ||
                _ctx.state.selectedElement.type === 'textArea'
              )
                      ? (_openBlock(), _createBlock("h5", _hoisted_1204, " Edit " + _toDisplayString(_ctx.state.selectedElement.title), 1))
                      : (_openBlock(), _createBlock("h5", _hoisted_1205, " Edit " + _toDisplayString(_ctx.state.selectedElement.element.title), 1)),
                    _hoisted_1206
                  ]),
                  _createVNode("div", _hoisted_1207, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorList,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1208, [
                      (_ctx.state.selectedElement.type === 'title')
                        ? (_openBlock(), _createBlock("div", _hoisted_1209, [
                            _createVNode("div", _hoisted_1210, [
                              _hoisted_1211,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Title Here",
                                "onUpdate:modelValue": _cache[152] || (_cache[152] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ]),
                            _createVNode("div", _hoisted_1212, [
                              _hoisted_1213,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Description here",
                                "onUpdate:modelValue": _cache[153] || (_cache[153] = ($event: any) => (_ctx.state.selectedElement.description = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.description]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'section')
                        ? (_openBlock(), _createBlock("div", _hoisted_1214, [
                            _createVNode("div", _hoisted_1215, [
                              _hoisted_1216,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                "onUpdate:modelValue": _cache[154] || (_cache[154] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ]),
                            _createVNode("div", _hoisted_1217, [
                              _hoisted_1218,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                "onUpdate:modelValue": _cache[155] || (_cache[155] = ($event: any) => (_ctx.state.selectedElement.description = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.description]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'textbox')
                        ? (_openBlock(), _createBlock("div", _hoisted_1219, [
                            _createVNode("div", _hoisted_1220, [
                              _hoisted_1221,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                "onUpdate:modelValue": _cache[156] || (_cache[156] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'textArea')
                        ? (_openBlock(), _createBlock("div", _hoisted_1222, [
                            _createVNode("div", _hoisted_1223, [
                              _hoisted_1224,
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[157] || (_cache[157] = ($event: any) => (_ctx.state.selectedElement.title = $event)),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword"
                              }, null, 512), [
                                [_vModelText, _ctx.state.selectedElement.title]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'checkBox')
                        ? (_openBlock(), _createBlock("div", _hoisted_1225, [
                            _createVNode("div", _hoisted_1226, [
                              _createVNode("div", _hoisted_1227, [
                                _hoisted_1228,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[158] || (_cache[158] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedElement.element.title]
                                ])
                              ]),
                              (_ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_1229, [
                                    _hoisted_1230,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_1231, [
                                          _createVNode("div", _hoisted_1232, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              name: "exampleRadios",
                                              id: "exampleRadios1",
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_1233, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        (rowIndex != 0)
                                          ? (_openBlock(), _createBlock("div", _hoisted_1234, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "option-btn",
                                                disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                                onClick: ($event: any) => (_ctx.removeCheckBoxinCustomEdit(row.text))
                                              }, [
                                                _hoisted_1235
                                              ], 8, ["disabled", "onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_1236, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[159] || (_cache[159] = 
//@ts-ignore
(...args) => (_ctx.addCheckBoxinCustomEdit && _ctx.addCheckBoxinCustomEdit(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_1237,
                                        _hoisted_1238
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'single_select')
                        ? (_openBlock(), _createBlock("div", _hoisted_1239, [
                            _createVNode("div", _hoisted_1240, [
                              _createVNode("div", _hoisted_1241, [
                                _hoisted_1242,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[160] || (_cache[160] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedElement.element.title]
                                ])
                              ]),
                              (_ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_1243, [
                                    _hoisted_1244,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_1245, [
                                          _createVNode("div", null, [
                                            _withDirectives(_createVNode("input", {
                                              type: "radio",
                                              name: "exampleRadios",
                                              id: "exampleRadios1",
                                              value: row.text,
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["value", "onUpdate:modelValue"]), [
                                              [_vModelRadio, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_1246, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        (rowIndex != 0)
                                          ? (_openBlock(), _createBlock("div", _hoisted_1247, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "option-btn",
                                                disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                                onClick: ($event: any) => (_ctx.removeSelectOptioninCustomEdit(row.text))
                                              }, [
                                                _hoisted_1248
                                              ], 8, ["disabled", "onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_1249, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[161] || (_cache[161] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptionsinCustomEdit && _ctx.addSelectOptionsinCustomEdit(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_1250,
                                        _hoisted_1251
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.selectedElement.type === 'radioButton')
                        ? (_openBlock(), _createBlock("div", _hoisted_1252, [
                            _createVNode("div", _hoisted_1253, [
                              _createVNode("div", _hoisted_1254, [
                                _hoisted_1255,
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Text field label",
                                  "onUpdate:modelValue": _cache[162] || (_cache[162] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.selectedElement.element.title]
                                ])
                              ]),
                              (_ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                                ? (_openBlock(), _createBlock("div", _hoisted_1256, [
                                    _hoisted_1257,
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row py-2",
                                        key: rowIndex
                                      }, [
                                        _createVNode("div", _hoisted_1258, [
                                          _createVNode("div", null, [
                                            _withDirectives(_createVNode("input", {
                                              type: "radio",
                                              name: "exampleRadios",
                                              id: "exampleRadios1",
                                              value: row.value,
                                              "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                            }, null, 8, ["value", "onUpdate:modelValue"]), [
                                              [_vModelRadio, row.selected]
                                            ])
                                          ])
                                        ]),
                                        _createVNode("div", _hoisted_1259, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "Option label",
                                            "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                          }, null, 8, ["onUpdate:modelValue"]), [
                                            [_vModelText, row.text]
                                          ])
                                        ]),
                                        (rowIndex != 0)
                                          ? (_openBlock(), _createBlock("div", _hoisted_1260, [
                                              _createVNode("button", {
                                                type: "button",
                                                class: "option-btn",
                                                disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                                onClick: ($event: any) => (_ctx.removeOptionsinCustomEdit(row.text))
                                              }, [
                                                _hoisted_1261
                                              ], 8, ["disabled", "onClick"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createVNode("div", _hoisted_1262, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: _cache[163] || (_cache[163] = 
//@ts-ignore
(...args) => (_ctx.addOptionsinCustomEdit && _ctx.addOptionsinCustomEdit(...args))),
                                        class: "btn default-btn outline secondary mt-3"
                                      }, [
                                        _hoisted_1263,
                                        _hoisted_1264
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_1265, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[164] || (_cache[164] = 
//@ts-ignore
(...args) => (_ctx.editSelectedForm && _ctx.editSelectedForm(...args)))
                    }, " Update "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[165] || (_cache[165] = 
//@ts-ignore
(...args) => (_ctx.cancelEditSelectedForm && _ctx.cancelEditSelectedForm(...args)))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1266, [
            _createVNode("div", _hoisted_1267, [
              _createVNode("div", _hoisted_1268, [
                _createVNode("div", _hoisted_1269, [
                  _hoisted_1270,
                  _createVNode("div", _hoisted_1272, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[166] || (_cache[166] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteElement && _ctx.confirmDeleteElement(...args)))
                    }, " Yes "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[167] || (_cache[167] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteSelectedForm && _ctx.cancelDeleteSelectedForm(...args)))
                    }, " No ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1273, [
            _createVNode("div", _hoisted_1274, [
              _createVNode("div", _hoisted_1275, [
                _createVNode("div", _hoisted_1276, [
                  _hoisted_1277,
                  _createVNode("div", _hoisted_1279, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[168] || (_cache[168] = 
//@ts-ignore
(...args) => (_ctx.hideNewFormConformation && _ctx.hideNewFormConformation(...args)))
                    }, " No "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[169] || (_cache[169] = 
//@ts-ignore
(...args) => (_ctx.createNewForm && _ctx.createNewForm(...args)))
                    }, " Yes ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1280, [
            _createVNode("div", _hoisted_1281, [
              _createVNode("div", _hoisted_1282, [
                _createVNode("div", _hoisted_1283, [
                  _hoisted_1284,
                  _createVNode("div", _hoisted_1286, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[170] || (_cache[170] = 
//@ts-ignore
(...args) => (_ctx.saveCustomSelectedForm && _ctx.saveCustomSelectedForm(...args)))
                    }, " Yes "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[171] || (_cache[171] = 
//@ts-ignore
(...args) => (_ctx.hideConfirmEditForm && _ctx.hideConfirmEditForm(...args)))
                    }, " No ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1287, [
            _createVNode("div", _hoisted_1288, [
              _createVNode("div", _hoisted_1289, [
                _createVNode("div", _hoisted_1290, [
                  _createVNode("div", _hoisted_1291, [
                    _createVNode("h5", _hoisted_1292, " Add " + _toDisplayString(_ctx.state.selected), 1),
                    _hoisted_1293
                  ]),
                  _createVNode("div", _hoisted_1294, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorList,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1295, [
                      _createVNode("div", _hoisted_1296, [
                        (_ctx.state.type === 'title')
                          ? (_openBlock(), _createBlock("div", _hoisted_1297, [
                              _createVNode("div", _hoisted_1298, [
                                _hoisted_1299,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[172] || (_cache[172] = ($event: any) => (_ctx.state.form.textField.title = $event)),
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Title Here"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.textField.title]
                                ])
                              ]),
                              _createVNode("div", _hoisted_1300, [
                                _hoisted_1301,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[173] || (_cache[173] = ($event: any) => (_ctx.state.form.textField.description = $event)),
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword",
                                  placeholder: "Description here"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.textField.description]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.type === 'section')
                          ? (_openBlock(), _createBlock("div", _hoisted_1302, [
                              _createVNode("div", _hoisted_1303, [
                                _hoisted_1304,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[174] || (_cache[174] = ($event: any) => (_ctx.state.form.textField.title = $event)),
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.textField.title]
                                ])
                              ]),
                              _createVNode("div", _hoisted_1305, [
                                _hoisted_1306,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[175] || (_cache[175] = ($event: any) => (_ctx.state.form.textField.description = $event)),
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.textField.description]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.type === 'textbox')
                          ? (_openBlock(), _createBlock("div", _hoisted_1307, [
                              _createVNode("div", _hoisted_1308, [
                                _hoisted_1309,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[176] || (_cache[176] = ($event: any) => (_ctx.state.form.textbox.title = $event)),
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.textbox.title]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.type === 'textArea')
                          ? (_openBlock(), _createBlock("div", _hoisted_1310, [
                              _createVNode("div", _hoisted_1311, [
                                _hoisted_1312,
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[177] || (_cache[177] = ($event: any) => (_ctx.state.form.textArea.title = $event)),
                                  type: "text",
                                  class: "form-control",
                                  id: "inputPassword"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.form.textArea.title]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.type === 'radioButton')
                          ? (_openBlock(), _createBlock("div", _hoisted_1313, [
                              _createVNode("div", _hoisted_1314, [
                                _createVNode("div", _hoisted_1315, [
                                  _hoisted_1316,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "inputPassword",
                                    placeholder: "Text field label",
                                    "onUpdate:modelValue": _cache[178] || (_cache[178] = ($event: any) => (_ctx.state.form.radioButton.title = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.form.radioButton.title]
                                  ])
                                ]),
                                (_ctx.state.form.radioButton.select_values &&
                        _ctx.state.form.radioButton.select_values.length
                      )
                                  ? (_openBlock(), _createBlock("div", _hoisted_1317, [
                                      _hoisted_1318,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.radioButton
                          .select_values, (row, rowIndex) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "row py-2",
                                          key: rowIndex
                                        }, [
                                          _createVNode("div", _hoisted_1319, [
                                            _createVNode("div", null, [
                                              _withDirectives(_createVNode("input", {
                                                type: "radio",
                                                name: "exampleRadios",
                                                value: row.text,
                                                "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                              }, null, 8, ["value", "onUpdate:modelValue"]), [
                                                [_vModelRadio, row.selected]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_1320, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: "form-control",
                                              placeholder: "Option label",
                                              "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, row.text]
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_1321, [
                                            _createVNode("button", {
                                              type: "button",
                                              class: "option-btn",
                                              disabled: _ctx.state.form.radioButton.select_values.length ===
                              1
                              ,
                                              onClick: ($event: any) => (_ctx.removeOptions(row.text))
                                            }, [
                                              _hoisted_1322
                                            ], 8, ["disabled", "onClick"])
                                          ])
                                        ]))
                                      }), 128)),
                                      _createVNode("div", _hoisted_1323, [
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: _cache[179] || (_cache[179] = 
//@ts-ignore
(...args) => (_ctx.addOptions && _ctx.addOptions(...args))),
                                          class: "btn default-btn outline secondary mt-3"
                                        }, [
                                          _hoisted_1324,
                                          _hoisted_1325
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.type === 'single_select')
                          ? (_openBlock(), _createBlock("div", _hoisted_1326, [
                              _createVNode("div", _hoisted_1327, [
                                _createVNode("div", _hoisted_1328, [
                                  _hoisted_1329,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "inputPassword",
                                    placeholder: "Text field label",
                                    "onUpdate:modelValue": _cache[180] || (_cache[180] = ($event: any) => (_ctx.state.form.selectOption.title = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.form.selectOption.title]
                                  ])
                                ]),
                                (_ctx.state.form.selectOption.select_values &&
                        _ctx.state.form.selectOption.select_values.length
                      )
                                  ? (_openBlock(), _createBlock("div", _hoisted_1330, [
                                      _hoisted_1331,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.selectOption
                          .select_values, (row, rowIndex) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "row py-2",
                                          key: rowIndex
                                        }, [
                                          _createVNode("div", _hoisted_1332, [
                                            _createVNode("div", null, [
                                              _withDirectives(_createVNode("input", {
                                                type: "radio",
                                                name: "exampleRadios",
                                                id: "exampleRadios1",
                                                value: row.text,
                                                "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                              }, null, 8, ["value", "onUpdate:modelValue"]), [
                                                [_vModelRadio, row.selected]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_1333, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: "form-control",
                                              placeholder: "Option label",
                                              "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, row.text]
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_1334, [
                                            _createVNode("button", {
                                              type: "button",
                                              class: "option-btn",
                                              disabled: _ctx.state.form.selectOption.select_values.length ===
                              1
                              ,
                                              onClick: ($event: any) => (_ctx.removeSelectOption(row.text))
                                            }, [
                                              _hoisted_1335
                                            ], 8, ["disabled", "onClick"])
                                          ])
                                        ]))
                                      }), 128)),
                                      _createVNode("div", _hoisted_1336, [
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: _cache[181] || (_cache[181] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptions && _ctx.addSelectOptions(...args))),
                                          class: "btn default-btn outline secondary mt-3"
                                        }, [
                                          _hoisted_1337,
                                          _hoisted_1338
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.type === 'checkBox')
                          ? (_openBlock(), _createBlock("div", _hoisted_1339, [
                              _createVNode("div", _hoisted_1340, [
                                _createVNode("div", _hoisted_1341, [
                                  _hoisted_1342,
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "inputPassword",
                                    placeholder: "Text field label",
                                    "onUpdate:modelValue": _cache[182] || (_cache[182] = ($event: any) => (_ctx.state.form.checkBox.title = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.state.form.checkBox.title]
                                  ])
                                ]),
                                (_ctx.state.form.checkBox.select_values &&
                        _ctx.state.form.checkBox.select_values.length
                      )
                                  ? (_openBlock(), _createBlock("div", _hoisted_1343, [
                                      _hoisted_1344,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.checkBox
                          .select_values, (row, rowIndex) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "row py-2",
                                          key: rowIndex
                                        }, [
                                          _createVNode("div", _hoisted_1345, [
                                            _createVNode("div", _hoisted_1346, [
                                              _withDirectives(_createVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                name: "exampleRadios",
                                                id: "exampleRadios1",
                                                "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                              }, null, 8, ["onUpdate:modelValue"]), [
                                                [_vModelCheckbox, row.selected]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_1347, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: "form-control",
                                              placeholder: "Option label",
                                              "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelText, row.text]
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_1348, [
                                            _createVNode("button", {
                                              type: "button",
                                              class: "option-btn",
                                              disabled: _ctx.state.form.checkBox.select_values.length === 1
                              ,
                                              onClick: ($event: any) => (_ctx.removeCheckBox(row.text))
                                            }, [
                                              _hoisted_1349
                                            ], 8, ["disabled", "onClick"])
                                          ])
                                        ]))
                                      }), 128)),
                                      _createVNode("div", _hoisted_1350, [
                                        _createVNode("a", {
                                          href: "javascript:void(0)",
                                          onClick: _cache[183] || (_cache[183] = 
//@ts-ignore
(...args) => (_ctx.addCheckBox && _ctx.addCheckBox(...args))),
                                          class: "btn default-btn outline secondary mt-3"
                                        }, [
                                          _hoisted_1351,
                                          _hoisted_1352
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_1353, [
                          _hoisted_1354,
                          _withDirectives(_createVNode("select", {
                            class: "form-control custom-select",
                            "onUpdate:modelValue": _cache[184] || (_cache[184] = ($event: any) => (_ctx.state.typePosition = $event))
                          }, [
                            _hoisted_1355,
                            _hoisted_1356
                          ], 512), [
                            [_vModelSelect, _ctx.state.typePosition]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1357, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[185] || (_cache[185] = 
//@ts-ignore
(...args) => (_ctx.addTextFieldInCustomEdit && _ctx.addTextFieldInCustomEdit(...args)))
                    }, " Add "),
                    _hoisted_1358
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1359, [
            _createVNode("div", _hoisted_1360, [
              _createVNode("div", _hoisted_1361, [
                _createVNode("div", _hoisted_1362, [
                  _hoisted_1363,
                  _createVNode("div", _hoisted_1364, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorListSendForm,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorListNewForm,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1365, [
                      _createVNode("div", _hoisted_1366, [
                        _hoisted_1367,
                        _withDirectives(_createVNode("select", {
                          class: "form-control mb-2",
                          id: "user.id",
                          "onUpdate:modelValue": _cache[186] || (_cache[186] = ($event: any) => (_ctx.state.existingMember = $event)),
                          onChange: _cache[187] || (_cache[187] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInForm && _ctx.changeExistingMemberInForm(...args)))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              value: item,
                              key: itemIndex
                            }, _toDisplayString(item.full_name), 9, ["value"]))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.state.existingMember]
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_1368, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_1369
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_1370, [
                        _hoisted_1371,
                        _withDirectives(_createVNode("textarea", {
                          class: "form-control",
                          id: "w3review",
                          name: "w3review",
                          rows: "4",
                          cols: "50",
                          "onUpdate:modelValue": _cache[188] || (_cache[188] = ($event: any) => (_ctx.state.ui.template.msg = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.ui.template.msg]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1372, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[189] || (_cache[189] = 
//@ts-ignore
(...args) => (_ctx.sendCreateNewForm && _ctx.sendCreateNewForm(...args)))
                    }, " Send "),
                    _hoisted_1373
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1374, [
            _createVNode("div", _hoisted_1375, [
              _createVNode("div", _hoisted_1376, [
                _createVNode("div", _hoisted_1377, [
                  _hoisted_1378,
                  _createVNode("div", _hoisted_1379, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorListSendForm,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorListSaveCustomSelectedForm,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1380, [
                      _createVNode("div", _hoisted_1381, [
                        _hoisted_1382,
                        _withDirectives(_createVNode("select", {
                          class: "form-control mb-2",
                          id: "user.id",
                          "onUpdate:modelValue": _cache[190] || (_cache[190] = ($event: any) => (_ctx.state.existingMember = $event)),
                          onChange: _cache[191] || (_cache[191] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInForm && _ctx.changeExistingMemberInForm(...args)))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              value: item,
                              key: itemIndex
                            }, _toDisplayString(item.full_name), 9, ["value"]))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.state.existingMember]
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_1383, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_1384
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_1385, [
                        _hoisted_1386,
                        _withDirectives(_createVNode("textarea", {
                          class: "form-control",
                          id: "w3review",
                          name: "w3review",
                          rows: "4",
                          cols: "50",
                          "onUpdate:modelValue": _cache[192] || (_cache[192] = ($event: any) => (_ctx.state.ui.template.msg = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.ui.template.msg]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1387, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[193] || (_cache[193] = 
//@ts-ignore
(...args) => (_ctx.emailValidationCustomEdit && _ctx.emailValidationCustomEdit(...args)))
                    }, " Send "),
                    _hoisted_1388
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1389, [
            _createVNode("div", _hoisted_1390, [
              _createVNode("div", _hoisted_1391, [
                _createVNode("div", _hoisted_1392, [
                  _createVNode("div", _hoisted_1393, [
                    _hoisted_1394,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[194] || (_cache[194] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteSelectedImage && _ctx.hideDeleteSelectedImage(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1395
                    ])
                  ]),
                  _createVNode("div", _hoisted_1396, [
                    _createVNode("div", _hoisted_1397, [
                      (_ctx.state.selectedAttachment.file_name)
                        ? (_openBlock(), _createBlock("p", _hoisted_1398, " Are you sure you want to delete " + _toDisplayString(_ctx.state.selectedAttachment.file_name) + " ? ", 1))
                        : (_openBlock(), _createBlock("p", _hoisted_1399, " Are you sure you want to delete " + _toDisplayString(_ctx.state.selectedAttachment.filename) + " ? ", 1))
                    ])
                  ]),
                  _createVNode("div", _hoisted_1400, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[195] || (_cache[195] = 
//@ts-ignore
(...args) => (_ctx.removeSelectedCommunicationImage && _ctx.removeSelectedCommunicationImage(...args)))
                    }, " Delete "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[196] || (_cache[196] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteSelectedImage && _ctx.hideDeleteSelectedImage(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1401, [
            _createVNode("div", _hoisted_1402, [
              _createVNode("div", _hoisted_1403, [
                _createVNode("div", _hoisted_1404, [
                  _createVNode("div", _hoisted_1405, [
                    _hoisted_1406,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[197] || (_cache[197] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteReplySelectedImage && _ctx.hideDeleteReplySelectedImage(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1407
                    ])
                  ]),
                  _createVNode("div", _hoisted_1408, [
                    _createVNode("div", _hoisted_1409, [
                      (_ctx.state.selectedResponseDelete.file_name)
                        ? (_openBlock(), _createBlock("p", _hoisted_1410, " Are you sure you want to delete " + _toDisplayString(_ctx.state.selectedResponseDelete.file_name) + " ? ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_1411, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[198] || (_cache[198] = 
//@ts-ignore
(...args) => (_ctx.removeSelectedReplyCommunicationImageAttached && _ctx.removeSelectedReplyCommunicationImageAttached(...args)))
                    }, " Delete "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[199] || (_cache[199] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteReplySelectedImage && _ctx.hideDeleteReplySelectedImage(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1412, [
            _createVNode("div", _hoisted_1413, [
              _createVNode("div", _hoisted_1414, [
                _createVNode("div", _hoisted_1415, [
                  _createVNode("div", _hoisted_1416, [
                    _createVNode("div", _hoisted_1417, [
                      _createVNode("h5", _hoisted_1418, _toDisplayString(_ctx.state.data.formData.title), 1),
                      _createVNode("p", _hoisted_1419, _toDisplayString(_ctx.state.data.formData.description), 1)
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "aria-label": "Close",
                      onClick: _cache[200] || (_cache[200] = 
//@ts-ignore
(...args) => (_ctx.hideViewTemplateModal && _ctx.hideViewTemplateModal(...args)))
                    }, [
                      _hoisted_1420
                    ])
                  ]),
                  _createVNode("div", _hoisted_1421, [
                    _createVNode("div", _hoisted_1422, [
                      _createVNode("form", null, [
                        _createVNode("fieldset", _hoisted_1423, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.formData
                      .elements, (element, elementIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "form-group",
                              key: elementIndex
                            }, [
                              (element.type === 'title')
                                ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                    key: 0,
                                    title: element.title,
                                    description: element.description,
                                    editStatus: false
                                  }, null, 8, ["title", "description"]))
                                : _createCommentVNode("", true),
                              (element.type === 'textbox')
                                ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                    key: 1,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'radioButton')
                                ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                    key: 2,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'single_select')
                                ? (_openBlock(), _createBlock(_component_SelectOption, {
                                    key: 3,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'checkBox')
                                ? (_openBlock(), _createBlock(_component_CheckBox, {
                                    key: 4,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'textArea')
                                ? (_openBlock(), _createBlock(_component_TextArea, {
                                    key: 5,
                                    data: element,
                                    editStatus: false
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'digitalSignature')
                                ? (_openBlock(), _createBlock(_component_DigitalSignature, {
                                    key: 6,
                                    data: element
                                  }, null, 8, ["data"]))
                                : _createCommentVNode("", true),
                              (element.type === 'datePicker')
                                ? (_openBlock(), _createBlock("div", _hoisted_1424, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      "onUpdate:modelValue": ($event: any) => (element.convertedDate = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, element.convertedDate]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1425, [
                    (_ctx.state.data.formData)
                      ? (_openBlock(), _createBlock("div", _hoisted_1426, [
                          _createVNode("p", _hoisted_1427, [
                            _hoisted_1428,
                            _hoisted_1429,
                            (_ctx.state.data.formData.owner &&
                    _ctx.state.data.formData.owner.created_by
                  )
                              ? (_openBlock(), _createBlock("span", _hoisted_1430, _toDisplayString(_ctx.state.data.formData.owner.created_by.email), 1))
                              : _createCommentVNode("", true),
                            _hoisted_1431,
                            _createVNode("span", null, _toDisplayString(_ctx.state.data.formData.created_date), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[201] || (_cache[201] = 
//@ts-ignore
(...args) => (_ctx.hideViewTemplateModal && _ctx.hideViewTemplateModal(...args)))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1432, [
            _createVNode("div", _hoisted_1433, [
              _createVNode("div", _hoisted_1434, [
                _createVNode("div", _hoisted_1435, [
                  _createVNode("div", _hoisted_1436, [
                    _createVNode("h5", _hoisted_1437, [
                      _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                      _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                    ]),
                    _hoisted_1438
                  ]),
                  _createVNode("div", _hoisted_1439, [
                    _hoisted_1440,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userFormData, (element, elementIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-wrap pt-0",
                        key: elementIndex
                      }, [
                        _createVNode("div", _hoisted_1441, [
                          (element.type === 'title')
                            ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                key: 0,
                                title: element.title,
                                description: element.description,
                                editStatus: false
                              }, null, 8, ["title", "description"]))
                            : _createCommentVNode("", true)
                        ]),
                        (element.type === 'textbox')
                          ? (_openBlock(), _createBlock("div", _hoisted_1442, [
                              _createVNode("label", _hoisted_1443, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1444, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: element.title === element.hasError
                    ? 'form-control error-field'
                    : 'form-control'
                    ,
                                placeholder: element.placeholder,
                                "onUpdate:modelValue": ($event: any) => (element.answer = $event)
                              }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                [_vModelText, element.answer]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'digitalSignature')
                          ? (_openBlock(), _createBlock("div", _hoisted_1445, [
                              _createVNode("label", _hoisted_1446, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1447, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode("div", null, [
                                _createVNode("div", _hoisted_1448, [
                                  _createVNode("canvas", {
                                    id: element.canvasName,
                                    class: element.title === element.hasError
                        ? 'error-field'
                        : ''
                        
                                  }, null, 10, ["id"])
                                ]),
                                _createVNode("button", {
                                  onClick: ($event: any) => (_ctx.clearSelectedSignature(element)),
                                  class: "btn default-btn mt-3"
                                }, " clear ", 8, ["onClick"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'datePicker')
                          ? (_openBlock(), _createBlock("div", _hoisted_1449, [
                              _createVNode("label", _hoisted_1450, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1451, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: element.title === element.hasError
                    ? 'form-control error-field'
                    : 'form-control'
                    ,
                                placeholder: "Untitled form",
                                "onUpdate:modelValue": ($event: any) => (element.convertedDate = $event),
                                onClick: ($event: any) => (_ctx.showHideCalender(element)),
                                onkeydown: "return false;"
                              }, null, 10, ["onUpdate:modelValue", "onClick"]), [
                                [_vModelText, element.convertedDate]
                              ]),
                              (element.show)
                                ? (_openBlock(), _createBlock(_component_v_date_picker, {
                                    key: 0,
                                    modelValue: element.date,
                                    "onUpdate:modelValue": ($event: any) => (element.date = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'radioButton')
                          ? (_openBlock(), _createBlock("div", _hoisted_1452, [
                              _createVNode("label", _hoisted_1453, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1454, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              (element.select_values && element.select_values.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_1455, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                                      return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                                        _withDirectives(_createVNode("input", {
                                          type: "radio",
                                          id: `radioButton${elementIndex}`,
                                          name: `radioButton${elementIndex}`,
                                          value: option.text,
                                          "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                        }, null, 8, ["id", "name", "value", "onUpdate:modelValue"]), [
                                          [_vModelRadio, option.selected]
                                        ]),
                                        _createVNode("label", {
                                          class: element.title === element.hasError
                        ? 'd-inline-block ml-2 error-field-text'
                        : ''
                        
                                        }, _toDisplayString(option.text), 3)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_1456, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.options, (eleoption, optionIndex) => {
                                      return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                                        _withDirectives(_createVNode("input", {
                                          type: "radio",
                                          id: `radioButton${elementIndex}`,
                                          name: `radioButton${elementIndex}`,
                                          value: eleoption.option,
                                          "onUpdate:modelValue": ($event: any) => (eleoption.selected = $event)
                                        }, null, 8, ["id", "name", "value", "onUpdate:modelValue"]), [
                                          [_vModelRadio, eleoption.selected]
                                        ]),
                                        _createVNode("label", {
                                          class: element.title === element.hasError
                        ? 'd-inline-block ml-2 error-field-text'
                        : ''
                        
                                        }, _toDisplayString(eleoption.option), 3)
                                      ]))
                                    }), 128))
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'single_select')
                          ? (_openBlock(), _createBlock("div", _hoisted_1457, [
                              _createVNode("label", _hoisted_1458, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1459, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              (element.select_values && element.select_values.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_1460, [
                                    _withDirectives(_createVNode("select", {
                                      id: `cars${elementIndex}`,
                                      class: element.title === element.hasError
                      ? 'form-control error-field'
                      : 'form-control'
                      ,
                                      "onUpdate:modelValue": ($event: any) => (element.selectedOption = $event)
                                    }, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                                        return (_openBlock(), _createBlock("option", {
                                          value: option,
                                          key: optionIndex
                                        }, _toDisplayString(option.text), 9, ["value"]))
                                      }), 128))
                                    ], 10, ["id", "onUpdate:modelValue"]), [
                                      [_vModelSelect, element.selectedOption]
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_1461, [
                                    _withDirectives(_createVNode("select", {
                                      id: `cars${elementIndex}`,
                                      class: element.title === element.hasError
                      ? 'form-control error-field'
                      : 'form-control'
                      ,
                                      "onUpdate:modelValue": ($event: any) => (element.selected = $event)
                                    }, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.options, (item, optionIndex) => {
                                        return (_openBlock(), _createBlock("option", {
                                          value: item.option,
                                          key: optionIndex
                                        }, _toDisplayString(item.option), 9, ["value"]))
                                      }), 128))
                                    ], 10, ["id", "onUpdate:modelValue"]), [
                                      [_vModelSelect, element.selected]
                                    ])
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'checkBox')
                          ? (_openBlock(), _createBlock("div", _hoisted_1462, [
                              _createVNode("label", null, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1463, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              (element.select_values && element.select_values.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_1464, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                                      return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                                        _withDirectives(_createVNode("input", {
                                          type: "checkbox",
                                          id: "checkbox1e",
                                          name: "checkbox1e",
                                          value: option.text,
                                          "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                        }, null, 8, ["value", "onUpdate:modelValue"]), [
                                          [_vModelCheckbox, option.selected]
                                        ]),
                                        _createVNode("label", {
                                          class: element.title === element.hasError
                        ? 'd-inline-block ml-2 error-field-text'
                        : ''
                        
                                        }, _toDisplayString(option.text), 3)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_1465, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.options, (option, optionIndex) => {
                                      return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                                        _withDirectives(_createVNode("input", {
                                          type: "checkbox",
                                          id: "checkbox1e",
                                          name: "checkbox1e",
                                          value: option.option,
                                          "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                        }, null, 8, ["value", "onUpdate:modelValue"]), [
                                          [_vModelCheckbox, option.selected]
                                        ]),
                                        _createVNode("label", {
                                          class: element.title === element.hasError
                        ? 'd-inline-block ml-2 error-field-text'
                        : ''
                        
                                        }, _toDisplayString(option.option), 3)
                                      ]))
                                    }), 128))
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (element.type === 'textArea')
                          ? (_openBlock(), _createBlock("div", _hoisted_1466, [
                              _createVNode("label", null, [
                                _createTextVNode(_toDisplayString(element.title) + " ", 1),
                                (element.required)
                                  ? (_openBlock(), _createBlock("span", _hoisted_1467, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _withDirectives(_createVNode("textarea", {
                                class: "textarea",
                                id: "w3review",
                                name: "w3review",
                                rows: "4",
                                cols: "50",
                                "onUpdate:modelValue": ($event: any) => (element.answer = $event),
                                onInput: _cache[202] || (_cache[202] = ($event: any) => (_ctx.resizeFormTextArea($event)))
                              }, null, 40, ["onUpdate:modelValue"]), [
                                [_vModelText, element.answer]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_1468, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[203] || (_cache[203] = 
//@ts-ignore
(...args) => (_ctx.submitUserInputForm && _ctx.submitUserInputForm(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.selectedUserAccountFormResponse
                ? "Submitting..."
                : "Submit Form"), 1),
                    _hoisted_1469
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1470, [
            _createVNode("div", _hoisted_1471, [
              _createVNode("div", _hoisted_1472, [
                _createVNode("div", _hoisted_1473, [
                  _createVNode("div", _hoisted_1474, [
                    _createVNode("div", {
                      class: "modal-back-btn",
                      onClick: _cache[204] || (_cache[204] = 
//@ts-ignore
(...args) => (_ctx.sendOptionBack && _ctx.sendOptionBack(...args)))
                    }, [
                      _hoisted_1475
                    ]),
                    _hoisted_1476,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      onClick: _cache[205] || (_cache[205] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1477
                    ])
                  ]),
                  _createVNode("div", _hoisted_1478, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.erorListSendForm,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1479, [
                      _createVNode("div", _hoisted_1480, [
                        (_ctx.state.channel.project && _ctx.state.channel.project.name)
                          ? (_openBlock(), _createBlock("h6", _hoisted_1481, " Project : " + _toDisplayString(_ctx.state.channel.project.name), 1))
                          : _createCommentVNode("", true),
                        _createVNode("h6", _hoisted_1482, " Channel : " + _toDisplayString(_ctx.state.channel.name), 1)
                      ]),
                      _createVNode("div", _hoisted_1483, [
                        _hoisted_1484,
                        _withDirectives(_createVNode("select", {
                          class: "form-control mb-2",
                          id: "",
                          "onUpdate:modelValue": _cache[206] || (_cache[206] = ($event: any) => (_ctx.state.existingMember = $event)),
                          onChange: _cache[207] || (_cache[207] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInSendOption && _ctx.changeExistingMemberInSendOption(...args)))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (item, itemIndex) => {
                            return (_openBlock(), _createBlock("option", {
                              disabled: !_ctx.state.userList && !_ctx.state.userList.length,
                              value: item,
                              key: itemIndex
                            }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["disabled", "value"]))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.state.existingMember]
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_1485, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_1486
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_1487, [
                        _hoisted_1488,
                        _withDirectives(_createVNode("textarea", {
                          class: "form-control",
                          id: "w3review",
                          name: "w3review",
                          rows: "4",
                          cols: "50",
                          "onUpdate:modelValue": _cache[208] || (_cache[208] = ($event: any) => (_ctx.state.data.additionalMessage = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.additionalMessage]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_1489, [
                    _createVNode("div", _hoisted_1490, [
                      _hoisted_1491,
                      _createVNode("div", _hoisted_1492, [
                        _createVNode("div", _hoisted_1493, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn default-btn",
                            onClick: _cache[209] || (_cache[209] = 
//@ts-ignore
(...args) => (_ctx.sendDigitizedForm && _ctx.sendDigitizedForm(...args)))
                          }, " Send "),
                          _createVNode("button", {
                            type: "button",
                            class: "btn secondary-btn",
                            "data-dismiss": "modal",
                            onClick: _cache[210] || (_cache[210] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args)))
                          }, " Cancel ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1494, [
            _createVNode("div", _hoisted_1495, [
              _createVNode("div", _hoisted_1496, [
                _createVNode("div", _hoisted_1497, [
                  _createVNode("div", _hoisted_1498, [
                    _hoisted_1499,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[211] || (_cache[211] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteCommunicationModal && _ctx.hideDeleteCommunicationModal(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1500
                    ])
                  ]),
                  _createVNode("div", _hoisted_1501, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.deleteCommunication,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _hoisted_1502,
                    _createVNode("p", null, [
                      _createVNode("strong", {
                        innerHTML: _ctx.state.selectedForEdit.message
                      }, null, 8, ["innerHTML"]),
                      _createVNode("small", _hoisted_1503, " (sent @ " + _toDisplayString(_ctx.state.selectedForEdit.currentTime) + ")", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_1504, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[212] || (_cache[212] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteCommunicationModal && _ctx.hideDeleteCommunicationModal(...args)))
                    }, " Cancel "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[213] || (_cache[213] = 
//@ts-ignore
(...args) => (_ctx.deleteCommunication && _ctx.deleteCommunication(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.deleteCommunication
                ? "Deleting..."
                : "Yes"), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1505, [
            _createVNode("div", _hoisted_1506, [
              _createVNode("div", _hoisted_1507, [
                _createVNode("div", _hoisted_1508, [
                  _createVNode("div", _hoisted_1509, [
                    _hoisted_1510,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[214] || (_cache[214] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteReplyMessage && _ctx.hideDeleteReplyMessage(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1511
                    ])
                  ]),
                  _createVNode("div", _hoisted_1512, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.deleteCommunication,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _hoisted_1513,
                    _createVNode("p", null, [
                      _createVNode("strong", {
                        innerHTML: _ctx.state.selectedForEdit.message
                      }, null, 8, ["innerHTML"]),
                      _createVNode("small", _hoisted_1514, " (sent @ " + _toDisplayString(_ctx.state.selectedForEdit.sentDate) + ")", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_1515, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[215] || (_cache[215] = 
//@ts-ignore
(...args) => (_ctx.deleteReplyCommunication && _ctx.deleteReplyCommunication(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.deleteCommunication
                ? "Deleting..."
                : "Yes"), 1),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[216] || (_cache[216] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteReplyMessage && _ctx.hideDeleteReplyMessage(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1516, [
            _createVNode("div", _hoisted_1517, [
              _createVNode("div", _hoisted_1518, [
                _createVNode("div", _hoisted_1519, [
                  _createVNode("div", _hoisted_1520, [
                    _hoisted_1521,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[217] || (_cache[217] = 
//@ts-ignore
(...args) => (_ctx.hideForwardMessage && _ctx.hideForwardMessage(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1522
                    ])
                  ]),
                  _createVNode("div", _hoisted_1523, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.forwardCommunication,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    _createVNode("div", _hoisted_1524, [
                      (_ctx.showEditor)
                        ? (_openBlock(), _createBlock(_component_Editor, {
                            key: 0,
                            showEnterSetting: false,
                            onEnterSetting: _ctx.enterSetting,
                            modelValue: _ctx.state.data.forwardWriteMessage,
                            "onUpdate:modelValue": _cache[218] || (_cache[218] = ($event: any) => (_ctx.state.data.forwardWriteMessage = $event))
                          }, null, 8, ["onEnterSetting", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_1525, [
                      _createVNode("div", _hoisted_1526, [
                        (_ctx.state.data.forwardMessage.user)
                          ? (_openBlock(), _createBlock("div", _hoisted_1527, [
                              _createVNode("img", {
                                src: _ctx.state.data.forwardMessage.user.image,
                                title: _ctx.state.data.forwardMessage.user.full_name,
                                alt: ""
                              }, null, 8, ["src", "title"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.forwardMessage.user)
                          ? (_openBlock(), _createBlock("div", _hoisted_1528, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.state.data.forwardMessage.user.full_name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("p", null, [
                        (_ctx.state.data.forwardMessage.message)
                          ? (_openBlock(), _createBlock("small", {
                              key: 0,
                              innerHTML: _ctx.state.data.forwardMessage.message
                            }, null, 8, ["innerHTML"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.state.data.forwardMessage.attachments &&
                _ctx.state.data.forwardMessage.attachments.length
              )
                      ? (_openBlock(), _createBlock("div", _hoisted_1529, [
                          _createVNode("ul", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.forwardMessage.attachments, (image, imageIndex) => {
                              return (_openBlock(), _createBlock("li", { key: imageIndex }, [
                                _createVNode("div", _hoisted_1530, [
                                  (image.file_type === 'mp4' ||
                        image.file_type === 'mov' ||
                        image.file_type === 'wmv' ||
                        image.file_type === 'webm' ||
                        image.file_type === 'ogg' ||
                        image.file_type === 'avi' ||
                        image.file_type === 'x-ms-wmv'
                      )
                                    ? (_openBlock(), _createBlock("div", _hoisted_1531, [
                                        _createVNode("div", _hoisted_1532, [
                                          _createVNode("video", {
                                            id: `my-player${imageIndex}`,
                                            class: "video-js",
                                            controls: "",
                                            preload: "auto",
                                            poster: "img/convorally-logo.png",
                                            "data-setup": "{}"
                                          }, [
                                            _createVNode("source", {
                                              src: image.file_link,
                                              type: `video/${image.file_type}`
                                            }, null, 8, ["src", "type"]),
                                            _hoisted_1533
                                          ], 8, ["id"])
                                        ]),
                                        _createVNode("div", _hoisted_1534, [
                                          _createVNode("p", {
                                            class: "font-weight-bold",
                                            innerHTML: `${image.file_name}`
                                          }, null, 8, ["innerHTML"])
                                        ])
                                      ]))
                                    : (image.file_type === 'doc' ||
                        image.file_type === 'docx'
                      )
                                      ? (_openBlock(), _createBlock("div", _hoisted_1535, [
                                          _hoisted_1536,
                                          _createVNode("div", _hoisted_1537, [
                                            _createVNode("p", {
                                              class: "font-weight-bold",
                                              onClick: _withModifiers(($event: any) => (
                            _ctx.downloadFile(image.file_link)
                            ), ["prevent"]),
                                              innerHTML: `${image.file_name}`
                                            }, null, 8, ["onClick", "innerHTML"])
                                          ]),
                                          _createVNode("a", {
                                            href: "javascript:void(0)",
                                            class: "remove-image",
                                            onClick: _withModifiers(($event: any) => (_ctx.removeForwardFile(image)), ["prevent"])
                                          }, [
                                            _hoisted_1538
                                          ], 8, ["onClick"])
                                        ]))
                                      : (image.file_type === 'xls' ||
                        image.file_type === 'xlsx' ||
                        image.file_type === 'xlsm' ||
                        image.file_type === 'xlsb' ||
                        image.file_type === 'xltx')
                                        ? (_openBlock(), _createBlock("div", _hoisted_1539, [
                                            _createVNode("div", {
                                              class: "image-wrapp",
                                              onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                            }, [
                                              _createVNode("div", _hoisted_1540, [
                                                _createVNode("img", {
                                                  src: `${_ctx.state.data.imageBaseUrl}img/excel.png`,
                                                  alt: "",
                                                  height: "150",
                                                  width: "180"
                                                }, null, 8, ["src"])
                                              ]),
                                              _createVNode("div", _hoisted_1541, [
                                                _createVNode("p", {
                                                  class: "font-weight-bold",
                                                  innerHTML: `${image.file_name}`
                                                }, null, 8, ["innerHTML"])
                                              ])
                                            ], 8, ["onClick"]),
                                            _createVNode("a", {
                                              href: "javascript:void(0)",
                                              class: "remove-image",
                                              onClick: _withModifiers(($event: any) => (_ctx.removeForwardFile(image)), ["prevent"])
                                            }, [
                                              _hoisted_1542
                                            ], 8, ["onClick"])
                                          ]))
                                        : (image.file_type === 'ppt' ||
                        image.file_type === 'pptm' ||
                        image.file_type === 'pptx'
                      )
                                          ? (_openBlock(), _createBlock("div", _hoisted_1543, [
                                              _createVNode("div", {
                                                class: "image-wrapp",
                                                onClick: _withModifiers(($event: any) => (_ctx.downloadFile(image.file_link)), ["prevent"])
                                              }, [
                                                _createVNode("div", _hoisted_1544, [
                                                  _createVNode("img", {
                                                    src: `${_ctx.state.data.imageBaseUrl}img/ppt.png`,
                                                    alt: "",
                                                    height: "150",
                                                    width: "180"
                                                  }, null, 8, ["src"])
                                                ]),
                                                _createVNode("div", _hoisted_1545, [
                                                  _createVNode("p", {
                                                    class: "font-weight-bold",
                                                    innerHTML: `${image.file_name}`
                                                  }, null, 8, ["innerHTML"])
                                                ])
                                              ], 8, ["onClick"]),
                                              _createVNode("a", {
                                                href: "javascript:void(0)",
                                                class: "remove-image",
                                                onClick: _withModifiers(($event: any) => (_ctx.removeForwardFile(image)), ["prevent"])
                                              }, [
                                                _hoisted_1546
                                              ], 8, ["onClick"])
                                            ]))
                                          : (image.file_type === 'zip' || image.file_type === 'rar' || image.file_type === 'tar')
                                            ? (_openBlock(), _createBlock("div", _hoisted_1547, [
                                                _createVNode("div", _hoisted_1548, [
                                                  _createVNode("div", {
                                                    class: "same-ht-img",
                                                    onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                  }, [
                                                    _createVNode("img", {
                                                      src: _ctx.state.data.imageBaseUrl ? `${_ctx.state.data.imageBaseUrl}img/file.jpg` : 'img/file.jpg',
                                                      alt: ""
                                                    }, null, 8, ["src"])
                                                  ], 8, ["onClick"]),
                                                  _createVNode("div", _hoisted_1549, [
                                                    _createVNode("p", {
                                                      class: "font-weight-bold",
                                                      innerHTML: `${image.file_name}`
                                                    }, null, 8, ["innerHTML"]),
                                                    _createVNode("p", null, "(" + _toDisplayString(image.convertedFileSize) + ")", 1),
                                                    _createVNode("a", {
                                                      href: "javascript:void(0)",
                                                      class: "btn default-btn d-block mt-1 btn-sm",
                                                      onClick: ($event: any) => (_ctx.downloadFile(image.file_link))
                                                    }, [
                                                      _hoisted_1550,
                                                      _hoisted_1551
                                                    ], 8, ["onClick"])
                                                  ])
                                                ]),
                                                (_ctx.channelStatus)
                                                  ? (_openBlock(), _createBlock("a", {
                                                      key: 0,
                                                      title: "Forward",
                                                      onClick: ($event: any) => (_ctx.forwardMessage(_ctx.communication, image)),
                                                      class: "remove-image share-icon"
                                                    }, [
                                                      _hoisted_1552
                                                    ], 8, ["onClick"]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.communication.editStatus && _ctx.channelStatus)
                                                  ? (_openBlock(), _createBlock("a", {
                                                      key: 1,
                                                      title: "Rename",
                                                      onClick: ($event: any) => (_ctx.renameDoc(_ctx.communication, image)),
                                                      class: "remove-image edit-icon"
                                                    }, [
                                                      _hoisted_1553
                                                    ], 8, ["onClick"]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.communication.editStatus && _ctx.channelStatus)
                                                  ? (_openBlock(), _createBlock("a", {
                                                      key: 2,
                                                      href: "javascript:void(0)",
                                                      class: "remove-image",
                                                      onClick: _withModifiers(($event: any) => (
                            _ctx.selectedCommunicationImageToDelete(
                              _ctx.communication,
                              image
                            )
                            ), ["prevent"])
                                                    }, [
                                                      _hoisted_1554
                                                    ], 8, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (image.file_type != 'pdf')
                                              ? (_openBlock(), _createBlock("div", _hoisted_1555, [
                                                  _createVNode("div", _hoisted_1556, [
                                                    _createVNode("div", _hoisted_1557, [
                                                      _createVNode("img", {
                                                        src: image.file_link,
                                                        alt: "",
                                                        height: "150",
                                                        width: "180"
                                                      }, null, 8, ["src"])
                                                    ]),
                                                    _createVNode("div", _hoisted_1558, [
                                                      _createVNode("p", {
                                                        class: "font-weight-bold",
                                                        innerHTML: `${image.file_name}`
                                                      }, null, 8, ["innerHTML"])
                                                    ])
                                                  ]),
                                                  _createVNode("a", {
                                                    href: "javascript:void(0)",
                                                    class: "remove-image",
                                                    onClick: _withModifiers(($event: any) => (_ctx.removeForwardFile(image)), ["prevent"])
                                                  }, [
                                                    _hoisted_1559
                                                  ], 8, ["onClick"])
                                                ]))
                                              : (_openBlock(), _createBlock("div", _hoisted_1560, [
                                                  _createVNode("div", {
                                                    onClick: ($event: any) => (_ctx.viewPdf(image.file_link))
                                                  }, [
                                                    _createVNode("div", _hoisted_1561, [
                                                      _createVNode("embed", {
                                                        src: image.file_link,
                                                        frameBorder: "0",
                                                        scrolling: "auto",
                                                        height: "100%",
                                                        width: "100%"
                                                      }, null, 8, ["src"])
                                                    ]),
                                                    _createVNode("div", _hoisted_1562, [
                                                      _createVNode("p", {
                                                        class: "font-weight-bold",
                                                        innerHTML: `${image.file_name}`
                                                      }, null, 8, ["innerHTML"])
                                                    ])
                                                  ], 8, ["onClick"]),
                                                  _createVNode("a", {
                                                    href: "javascript:void(0)",
                                                    class: "remove-image",
                                                    onClick: _withModifiers(($event: any) => (_ctx.removeForwardFile(image)), ["prevent"])
                                                  }, [
                                                    _hoisted_1563
                                                  ], 8, ["onClick"])
                                                ]))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_1564, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[219] || (_cache[219] = 
//@ts-ignore
(...args) => (_ctx.hideForwardMessage && _ctx.hideForwardMessage(...args)))
                    }, " Cancel "),
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[220] || (_cache[220] = 
//@ts-ignore
(...args) => (_ctx.forWardCommunication && _ctx.forWardCommunication(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.forwardCommunication
                ? "Forwarding..."
                : "Yes"), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1565, [
            _createVNode("div", _hoisted_1566, [
              _createVNode("div", _hoisted_1567, [
                (_ctx.state.data.selectedPendingMember)
                  ? (_openBlock(), _createBlock("div", _hoisted_1568, [
                      _createVNode("div", _hoisted_1569, [
                        _createVNode("button", {
                          type: "button",
                          class: "close",
                          "aria-label": "Close",
                          onClick: _cache[221] || (_cache[221] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberRemove && _ctx.hidePendingMemberRemove(...args)))
                        }, [
                          _hoisted_1570
                        ])
                      ]),
                      (_ctx.state.data.selectedPendingMember.email)
                        ? (_openBlock(), _createBlock("div", _hoisted_1571, [
                            _createVNode(_component_ErrorList, {
                              errors: _ctx.state.ui.errors.errorList.resendInvitation,
                              hasError: _ctx.state.ui.errors.hasError
                            }, null, 8, ["errors", "hasError"]),
                            _createVNode("div", _hoisted_1572, [
                              (_ctx.state.data.selectedPendingMember)
                                ? (_openBlock(), _createBlock("p", _hoisted_1573, [
                                    _hoisted_1574,
                                    _createVNode("strong", null, _toDisplayString(_ctx.state.data.selectedPendingMember.email), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_1575, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn secondary-btn",
                          onClick: _cache[222] || (_cache[222] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberRemove && _ctx.hidePendingMemberRemove(...args)))
                        }, " Cancel "),
                        _createVNode("button", {
                          type: "button",
                          class: "btn default-btn",
                          onClick: _cache[223] || (_cache[223] = 
//@ts-ignore
(...args) => (_ctx.deletePendingInvitation && _ctx.deletePendingInvitation(...args)))
                        }, _toDisplayString(_ctx.state.ui.isPostLoading.deletePendingInvitation
                ? "Removing..."
                : "Yes,remove user."), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1576, [
            _createVNode("div", _hoisted_1577, [
              _createVNode("div", _hoisted_1578, [
                (_ctx.state.data.selectedPendingMember)
                  ? (_openBlock(), _createBlock("div", _hoisted_1579, [
                      _createVNode("div", _hoisted_1580, [
                        (_ctx.state.data.selectedPendingMember)
                          ? (_openBlock(), _createBlock("h5", _hoisted_1581, " reinvite " + _toDisplayString(_ctx.state.data.selectedPendingMember.email) + "? ", 1))
                          : _createCommentVNode("", true),
                        _createVNode("button", {
                          type: "button",
                          class: "close",
                          "aria-label": "Close",
                          onClick: _cache[224] || (_cache[224] = 
//@ts-ignore
(...args) => (_ctx.hideResendInvitationConfirmation && _ctx.hideResendInvitationConfirmation(...args)))
                        }, [
                          _hoisted_1582
                        ])
                      ]),
                      (_ctx.state.data.selectedPendingMember.email)
                        ? (_openBlock(), _createBlock("div", _hoisted_1583, [
                            _createVNode(_component_ErrorList, {
                              errors: _ctx.state.ui.errors.errorList.resendInvitation,
                              hasError: _ctx.state.ui.errors.hasError
                            }, null, 8, ["errors", "hasError"]),
                            _hoisted_1584,
                            _createVNode("div", _hoisted_1585, [
                              _createVNode("ul", null, [
                                _createVNode("li", null, _toDisplayString(_ctx.state.data.selectedPendingMember.email) + " will be invited again. ", 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_1586, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn secondary-btn",
                          onClick: _cache[225] || (_cache[225] = 
//@ts-ignore
(...args) => (_ctx.hideResendInvitationConfirmation && _ctx.hideResendInvitationConfirmation(...args)))
                        }, " Cancel "),
                        _createVNode("button", {
                          type: "button",
                          class: "btn default-btn",
                          onClick: _cache[226] || (_cache[226] = 
//@ts-ignore
(...args) => (_ctx.resendInvitation && _ctx.resendInvitation(...args)))
                        }, _toDisplayString(_ctx.state.ui.isPostLoading.resendInvitation
                ? "Reinviting..."
                : "Yes,invite user."), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1587, [
            _createVNode("div", _hoisted_1588, [
              _createVNode("div", _hoisted_1589, [
                _createVNode("div", _hoisted_1590, [
                  _createVNode("div", _hoisted_1591, [
                    _hoisted_1592,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                      onClick: _cache[227] || (_cache[227] = 
//@ts-ignore
(...args) => (_ctx.hideRenameAttachmentModal && _ctx.hideRenameAttachmentModal(...args)))
                    }, [
                      _hoisted_1593
                    ])
                  ]),
                  _createVNode("div", _hoisted_1594, [
                    _createVNode(_component_ErrorList, {
                      errors: _ctx.state.item.error.renameSelectedAttachment,
                      hasError: _ctx.state.item.hasError
                    }, null, 8, ["errors", "hasError"]),
                    (_ctx.state.data.selectedForRename)
                      ? (_openBlock(), _createBlock("div", _hoisted_1595, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            placeholder: "File Name",
                            "onUpdate:modelValue": _cache[228] || (_cache[228] = ($event: any) => (_ctx.state.data.selectedForRename.newName = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.selectedForRename.newName]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_1596, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[229] || (_cache[229] = 
//@ts-ignore
(...args) => (_ctx.renameSelectedAttachment && _ctx.renameSelectedAttachment(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.renameSelectedAttachment
                ? "Saving..."
                : "Save changes"), 1),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[230] || (_cache[230] = 
//@ts-ignore
(...args) => (_ctx.hideRenameAttachmentModal && _ctx.hideRenameAttachmentModal(...args)))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_1597, [
            _createVNode("div", _hoisted_1598, [
              _createVNode("div", _hoisted_1599, [
                _createVNode("div", _hoisted_1600, [
                  _createVNode("div", _hoisted_1601, [
                    _hoisted_1602,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[231] || (_cache[231] = 
//@ts-ignore
(...args) => (_ctx.showImageModelHide && _ctx.showImageModelHide(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1603
                    ])
                  ]),
                  _createVNode("div", _hoisted_1604, [
                    (_ctx.state.slides.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_1605, [
                          (_ctx.state.isPreV)
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                onClick: _cache[232] || (_cache[232] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args))),
                                class: "previous-btn nav-arrows",
                                onKeydown: _cache[233] || (_cache[233] = _withKeys(
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)), ["left"]))
                              }, [
                                _hoisted_1606
                              ], 32))
                            : _createCommentVNode("", true),
                          (_ctx.state.isNext)
                            ? (_openBlock(), _createBlock("button", {
                                key: 1,
                                onClick: _cache[234] || (_cache[234] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
                                class: "next-btn nav-arrows",
                                onKeydown: _cache[235] || (_cache[235] = _withKeys(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["right"]))
                              }, [
                                _hoisted_1607
                              ], 32))
                            : _createCommentVNode("", true),
                          _createVNode(_TransitionGroup, {
                            name: "slide",
                            tag: "div"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.slides, (item, index) => {
                                return _withDirectives((_openBlock(), _createBlock("div", {
                                  class: "gallery-image",
                                  key: index
                                }, [
                                  _createVNode("img", {
                                    src: item.file_link
                                  }, null, 8, ["src"])
                                ], 512)), [
                                  [_vShow, index === _ctx.state.currentIndex]
                                ])
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.state.ui.isActive.upgradeSubscription)
            ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
                key: 2,
                onCloseModal: _ctx.hideUpdateSubscriptionModal
              }, null, 8, ["onCloseModal"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_1608, [
            _createVNode("div", _hoisted_1609, [
              _createVNode("div", _hoisted_1610, [
                _createVNode("div", _hoisted_1611, [
                  _createVNode("div", _hoisted_1612, [
                    _hoisted_1613,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: _cache[236] || (_cache[236] = 
//@ts-ignore
(...args) => (_ctx.showReplyImageModelHide && _ctx.showReplyImageModelHide(...args))),
                      "aria-label": "Close"
                    }, [
                      _hoisted_1614
                    ])
                  ]),
                  _createVNode("div", _hoisted_1615, [
                    _createVNode("div", _hoisted_1616, [
                      _createVNode("div", _hoisted_1617, [
                        _createVNode("img", {
                          src: _ctx.state.replyImage.file_link
                        }, null, 8, ["src"])
                      ]),
                      _hoisted_1618
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_vue_easy_lightbox, {
              visible: _ctx.visibleRef,
              imgs: _ctx.imgsRef,
              index: _ctx.indexRef,
              onOnPrev: _ctx.handlePrev,
              onOnNext: _ctx.handleNext,
              onHide: _ctx.handleHide
            }, null, 8, ["visible", "imgs", "index", "onOnPrev", "onOnNext", "onHide"])
          ]),
          _createVNode("div", _hoisted_1619, [
            _createVNode("div", _hoisted_1620, [
              _createVNode("div", _hoisted_1621, [
                _createVNode("div", _hoisted_1622, [
                  _hoisted_1623,
                  _createVNode("div", _hoisted_1624, [
                    (_ctx.imgsRef.length && _ctx.imgsRef[0])
                      ? (_openBlock(), _createBlock("iframe", {
                          key: 0,
                          height: "600",
                          src: _ctx.imgsRef[0],
                          class: "pdf-iframe",
                          frameborder: "0"
                        }, "\n              ", 8, ["src"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_component_DocusignDocumentListModel, {
            showModal: _ctx.state.data.showDocusignDocumentListModel,
            channelMemberList: _ctx.state.memberList,
            channelId: _ctx.state.data.channelUuid,
            onClose: _ctx.closeDocusignListModel
          }, null, 8, ["showModal", "channelMemberList", "channelId", "onClose"]),
          _createVNode(_component_showShareDocusignDocumentModel, {
            showModal: _ctx.state.data.showShareDocusignDocumentModel,
            docDetails: _ctx.state.data.docusignShareDocumentDetail,
            docData: _ctx.state.data.docusignShareDocumentData,
            onClose: _ctx.closeDocusignShareDocumentModel
          }, null, 8, ["showModal", "docDetails", "docData", "onClose"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_1625, [
          (!_ctx.state.data.docuSignSignOpenUrl && !_ctx.state.data.docuSignSignUrl)
            ? (_openBlock(), _createBlock("div", _hoisted_1626, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl
        ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
        : 'img/loading.gif'
        ,
                  alt: ""
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("iframe", {
            id: "myIframe",
            src: _ctx.state.data.docuSignSignOpenUrl ? _ctx.state.data.docuSignSignOpenUrl : _ctx.state.data.docuSignSignUrl,
            name: "myFrame",
            frameborder: "0",
            scrolling: "no",
            style: {"position":"relative","height":"100%","width":"100%"}
          }, null, 8, ["src"])
        ])),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 3,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1627, [
      _createVNode("div", _hoisted_1628, [
        _createVNode("div", _hoisted_1629, [
          _createVNode("div", _hoisted_1630, [
            _hoisted_1631,
            _createVNode("div", _hoisted_1632, [
              _createVNode("div", _hoisted_1633, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[237] || (_cache[237] = ($event: any) => (_ctx.state.data.selectedFileName = $event)),
                  onKeyup: _cache[238] || (_cache[238] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveFileName && _ctx.saveFileName(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.data.selectedFileName]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_1634, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[239] || (_cache[239] = 
//@ts-ignore
(...args) => (_ctx.saveFileName && _ctx.saveFileName(...args)))
              }, "Save changes")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_1635, [
      _createVNode("div", _hoisted_1636, [
        (_ctx.state.isLoading.inviteAllUsers)
          ? (_openBlock(), _createBlock("div", _hoisted_1637, [
              _hoisted_1638
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_1639, [
          _createVNode("div", _hoisted_1640, [
            _createVNode("div", _hoisted_1641, [
              _hoisted_1642,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[240] || (_cache[240] = 
//@ts-ignore
(...args) => (_ctx.hidePrivateChannel && _ctx.hidePrivateChannel(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_1643
              ])
            ]),
            _createVNode("div", _hoisted_1644, [
              _createVNode("div", _hoisted_1645, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.errorList,
                  hasError: _ctx.state.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                (!_ctx.state.data.invitationVerify.showStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_1646, [
                      _createVNode("div", _hoisted_1647, [
                        _hoisted_1648,
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.selectedUsers,
                          "onUpdate:modelValue": _cache[241] || (_cache[241] = ($event: any) => (_ctx.selectedUsers = $event)),
                          options: _ctx.allUsers,
                          "close-on-select": "true",
                          "custom-label": _ctx.nameWithEmail,
                          "clear-on-select": true,
                          placeholder: "Search and select",
                          label: "email",
                          "track-by": "email",
                          onSelect: _cache[242] || (_cache[242] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                        }, null, 8, ["modelValue", "options", "custom-label"]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_1649, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_1650
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_1651, [
                        _hoisted_1652,
                        _createVNode("div", _hoisted_1653, [
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[243] || (_cache[243] = ($event: any) => (_ctx.state.inviteMember = $event)),
                            type: "email",
                            class: "form-control",
                            id: "exampleInputEmail1",
                            "aria-describedby": "emailHelp",
                            placeholder: "Type email and press enter or click add button",
                            onKeyup: _cache[244] || (_cache[244] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                          }, null, 544), [
                            [_vModelText, _ctx.state.inviteMember]
                          ]),
                          _createVNode("button", {
                            onClick: _cache[245] || (_cache[245] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                          }, [
                            _hoisted_1654
                          ])
                        ])
                      ]),
                      (_ctx.state.inputError)
                        ? (_openBlock(), _createBlock("p", _hoisted_1655, "Please fill below field"))
                        : _createCommentVNode("", true),
                      (_ctx.state.duplicate)
                        ? (_openBlock(), _createBlock("p", _hoisted_1656, "This email is already used below"))
                        : _createCommentVNode("", true),
                      (_ctx.state.invite.invites && _ctx.state.invite.invites.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_1657, [
                            _createVNode("table", _hoisted_1658, [
                              _hoisted_1659,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                                return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                  _createVNode("tr", null, [
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_1660, [
                                        _withDirectives(_createVNode("input", {
                                          type: "email",
                                          class: "form-control",
                                          readonly: "",
                                          "onUpdate:modelValue": ($event: any) => (invite.email = $event)
                                        }, null, 8, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.email]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_1661, [
                                        _createVNode("div", _hoisted_1662, [
                                          _hoisted_1663,
                                          _withDirectives(_createVNode("input", {
                                            type: "number",
                                            class: invite.phoneError ? 'form-control error-field' : 'form-control',
                                            placeholder: "mobile number only",
                                            "onUpdate:modelValue": ($event: any) => (invite.phone = $event)
                                          }, null, 10, ["onUpdate:modelValue"]), [
                                            [_vModelText, invite.phone]
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_1664, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                          "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.first_name]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_1665, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                          "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.last_name]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("a", {
                                        class: "btn btn-sm red-btn mt-1",
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                      }, [
                                        _hoisted_1666
                                      ], 8, ["onClick"])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_1667, [
              _createVNode("div", null, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn secondary-btn mr-2",
                  onClick: _cache[246] || (_cache[246] = 
//@ts-ignore
(...args) => (_ctx.hidePrivateChannel && _ctx.hidePrivateChannel(...args)))
                }, "Cancel"),
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[247] || (_cache[247] = 
//@ts-ignore
(...args) => (_ctx.createPrivateChannelGroup && _ctx.createPrivateChannelGroup(...args)))
                }, "Make a Private Channel")
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_1668, [
        _createVNode("div", _hoisted_1669, [
          _createVNode("div", _hoisted_1670, [
            _createVNode("div", _hoisted_1671, [
              _createVNode("div", _hoisted_1672, [
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: _cache[248] || (_cache[248] = 
//@ts-ignore
(...args) => (_ctx.hideHistoryMember && _ctx.hideHistoryMember(...args)))
                }, [
                  _hoisted_1673
                ])
              ]),
              _createVNode("div", _hoisted_1674, [
                _hoisted_1675,
                _hoisted_1676,
                _createVNode("div", _hoisted_1677, [
                  _createVNode("label", null, [
                    _withDirectives(_createVNode("input", {
                      type: "radio",
                      name: "fruit",
                      value: "1",
                      "onUpdate:modelValue": _cache[249] || (_cache[249] = ($event: any) => (_ctx.selectedValueForPending = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.selectedValueForPending]
                    ]),
                    _hoisted_1678
                  ]),
                  _hoisted_1679,
                  _createVNode("label", null, [
                    _withDirectives(_createVNode("input", {
                      type: "radio",
                      name: "fruit",
                      value: "2",
                      "onUpdate:modelValue": _cache[250] || (_cache[250] = ($event: any) => (_ctx.selectedValueForPending = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.selectedValueForPending]
                    ]),
                    _hoisted_1680
                  ]),
                  _hoisted_1681,
                  _createVNode("label", null, [
                    _withDirectives(_createVNode("input", {
                      type: "radio",
                      name: "fruit",
                      value: "3",
                      "onUpdate:modelValue": _cache[251] || (_cache[251] = ($event: any) => (_ctx.selectedValueForPending = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.selectedValueForPending]
                    ]),
                    _hoisted_1682
                  ]),
                  _hoisted_1683,
                  _createVNode("label", null, [
                    _withDirectives(_createVNode("input", {
                      type: "radio",
                      name: "fruit",
                      value: "4",
                      "onUpdate:modelValue": _cache[252] || (_cache[252] = ($event: any) => (_ctx.selectedValueForPending = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.selectedValueForPending]
                    ]),
                    _hoisted_1684
                  ]),
                  _hoisted_1685
                ]),
                (_ctx.selectedValueForPending === '4')
                  ? (_openBlock(), _createBlock("div", _hoisted_1686, [
                      _createVNode("div", _hoisted_1687, [
                        _createVNode("div", _hoisted_1688, [
                          _createVNode(_component_v_date_picker, {
                            modelValue: _ctx.selectedDateForMember,
                            "onUpdate:modelValue": _cache[253] || (_cache[253] = ($event: any) => (_ctx.selectedDateForMember = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_1689, [
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  onClick: _cache[254] || (_cache[254] = 
//@ts-ignore
(...args) => (_ctx.hideHistoryMember && _ctx.hideHistoryMember(...args)))
                }, " Cancel "),
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[255] || (_cache[255] = 
//@ts-ignore
(...args) => (_ctx.modifyHistoryDateForMember && _ctx.modifyHistoryDateForMember(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.deletePendingInvitation
                ? "Loading..."
                : "Modify"), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.showAdminDetails)
        ? (_openBlock(), _createBlock(_component_AdminDetailModel, {
            key: 0,
            showModal: _ctx.state.showAdminDetails,
            uuid: _ctx.state.data.estimationId,
            onClose: _ctx.closeDetailModal
          }, null, 8, ["showModal", "uuid", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isActive.messageReceiver)
        ? (_openBlock(), _createBlock(_component_ChatChannelAppMessageReceiver, {
            key: 1,
            showModal: _ctx.state.ui.isActive.messageReceiver,
            membersList: _ctx.state.data.messageReceivers,
            imageBaseUrl: _ctx.state.data.imageBaseUrl,
            onCloseMessageReceiverModal: _ctx.closeMessageReceiverModal
          }, null, 8, ["showModal", "membersList", "imageBaseUrl", "onCloseMessageReceiverModal"]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isActive.chatChannelMessageReceiver)
        ? (_openBlock(), _createBlock(_component_ChannelChatMembers, {
            key: 2,
            isShow: _ctx.state.ui.isActive.chatChannelMessageReceiver,
            imageUrl: _ctx.state.data.imageBaseUrl,
            members: _ctx.state.data.members,
            onCloseChannelChatMembersModal: _ctx.closeChannelChatMembersModal,
            userRole: _ctx.state.userRole
          }, null, 8, ["isShow", "imageUrl", "members", "onCloseChannelChatMembersModal", "userRole"]))
        : _createCommentVNode("", true),
      (_ctx.state.ui.isActive.chatChannelAppInviteMember)
        ? (_openBlock(), _createBlock(_component_ChatChannelAppInviteMember, {
            key: 3,
            showModal: _ctx.state.ui.isActive.chatChannelAppInviteMember,
            projectUUID: _ctx.state.projectId,
            channelUUID: _ctx.state.data.channelUuid,
            pendingList: _ctx.state.pendingList,
            onInvite: _ctx.inviteAllUsers,
            onSetPendingList: _ctx.setPendingList,
            onCloseChatChannelInviteModal: _ctx.hideAddMember
          }, null, 8, ["showModal", "projectUUID", "channelUUID", "pendingList", "onInvite", "onSetPendingList", "onCloseChatChannelInviteModal"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}